import React, { useState, useEffect, useCallback } from 'react';
import './App.css';

const API_URL = 'https://pinklife-backend.onrender.com';

// Sound System
const SOUNDS = {
  birth: 'https://assets.mixkit.co/active_storage/sfx/2109/2109-preview.mp3',
  death: 'https://assets.mixkit.co/active_storage/sfx/2090/2090-preview.mp3',
  money: 'https://assets.mixkit.co/active_storage/sfx/2003/2003-preview.mp3',
  love: 'https://assets.mixkit.co/active_storage/sfx/2111/2111-preview.mp3',
  click: 'https://assets.mixkit.co/active_storage/sfx/2568/2568-preview.mp3',
  success: 'https://assets.mixkit.co/active_storage/sfx/2018/2018-preview.mp3',
  fail: 'https://assets.mixkit.co/active_storage/sfx/2955/2955-preview.mp3',
  levelup: 'https://assets.mixkit.co/active_storage/sfx/2019/2019-preview.mp3',
  cards: 'https://assets.mixkit.co/active_storage/sfx/2617/2617-preview.mp3',
};
const MUSIC_TRACKS = {
  reggaeton: '/reggaeton.mp3',
  chill: '/chill.mp3',
  hiphop: '/hiphop.mp3',
};
const audioCache = {};
let bgMusic = null;

// Full Translations
const TRANSLATIONS = {
  EN: {
    new_life: 'New Life', custom_life: 'Custom Life', graveyard: 'Graveyard', shop: 'Shop',
    settings: 'Settings', life: 'Life', activities: 'Activities', shopping: 'Shopping', family: 'Family',
    school: 'School', work: 'Work', love: 'Love', assets: 'Assets', crime: 'Crime',
    casino: 'Casino', phone: 'Phone', age: 'Age', health: 'Health', happiness: 'Happiness',
    smarts: 'Smarts', looks: 'Looks', money: 'Money', age_up: 'Age +1', parents: 'Parents',
    siblings: 'Siblings', partner: 'Partner', children: 'Children', classmates: 'Classmates',
    teachers: 'Teachers', talk: 'Talk', hug: 'Hug', compliment: 'Compliment', ask_money: 'Ask Money',
    give_money: 'Give Money', prank: 'Prank', insult: 'Insult', fight: 'Fight', befriend: 'Befriend',
    flirt: 'Flirt', bully: 'Bully', ask_help: 'Ask Help', propose: 'Propose', marry: 'Marry',
    break_up: 'Break Up', have_baby: 'Have Baby', jobs: 'Jobs', current_job: 'Current Job',
    apply: 'Apply', properties: 'Properties', vehicles: 'Vehicles', pets: 'Pets',
    buy: 'Buy', adopt: 'Adopt', dating_apps: 'Dating Apps', single: 'Single',
    date: 'Date', pass: 'Pass', target: 'Target', stranger: 'Stranger', bet_amount: 'Bet Amount',
    hit: 'Hit', stand: 'Stand', double: 'Double', escape: 'Escape', give_up: 'Give Up',
    start_life: 'Start Life', close: 'Close', dark_mode: 'Dark Mode', sound: 'Sound',
    music: 'Music', language: 'Language', name: 'Name', gender: 'Gender', male: 'Male',
    female: 'Female', country: 'Country', city: 'City', skin_tone: 'Skin Tone',
    sexuality: 'Sexuality', straight: 'Straight', gay: 'Gay', bisexual: 'Bisexual',
    special_birth: 'Special Birth', born_royal: 'Born Royal', custom_stats: 'Custom Stats',
    rest_in_peace: 'Rest in Peace', lived: 'Lived', years: 'years', karma: 'Karma',
    continue_as: 'Continue as', new_life_btn: 'New Life', surgery: 'Surgery', end_life: 'End Life',
    life_story: 'Life Story', too_young: 'Too young for school', graduated: 'Graduated',
    prison: 'Prison', juvenile: 'Juvenile Detention', years_left: 'years left',
    drivers_license: 'Driver\'s License', take_test: 'Take Test', passed: 'Passed!',
    failed: 'Failed!', luxury_fashion: 'Luxury Fashion', home_decor: 'Home Decor',
    stolen_items: 'Stolen Items', conception: 'Conception', relationship: 'Relationship',
    dating: 'Dating', engaged: 'Engaged', married: 'Married', affection: 'Affection',
    go_on_date: 'Go on Date', give_gift: 'Give Gift', complain: 'Complain',
    family_member: 'Family Member',
    // Doctor
    doctor: '🩺 Doctor', checkup: 'Checkup ($200)', treat_disease: 'Treat Disease ($5,000)',
    full_heal: 'Full Heal ($500)', doctor_intro: 'Visit the doctor to stay healthy.',
    no_conditions: 'No active conditions', conditions: 'condition(s)',
    // Graveyard
    graveyard_title: 'Graveyard', no_past_lives: 'No past lives yet — start playing!',
    at_age: 'at age', children_label: 'children', royal_label: '👑 Royal',
    // Pack taglines
    pack_starter_tagline: 'Perfect start for your blonde queen!',
    pack_luxury_tagline: 'Live the high life with style!',
    pack_god_tagline: 'Untouchable. Maxed out. Legendary.',
    pack_noads_tagline: 'Clean, uninterrupted gameplay.',
    pack_crime_tagline: 'New heists, new riches.',
    pack_fame_tagline: 'Become the star you were born to be.',
    pack_royal_tagline: 'Born to rule. Born royal.',
    pack_time_tagline: 'Rewind. Redo. Relive.',
    // Scenario events
    sc_birthday: 'Birthday!', sc_got_sick: 'You got sick.', sc_accident: 'You had an accident.',
    sc_promotion: 'You got a promotion!', sc_fired: 'You got fired.', sc_lottery: 'You won the lottery!',
    sc_robbery: 'You were robbed.', sc_fell_love: 'You fell in love.', sc_breakup: 'Your relationship ended.',
    sc_new_friend: 'You made a new friend!', sc_argument: 'You had a big argument.',
    sc_vacation: 'You went on vacation!', sc_exercise: 'You started exercising regularly.',
    sc_ate_junk: 'You ate junk food all week.', sc_studied: 'You studied hard.',
    sc_party: 'You went to a wild party!', sc_meditation: 'You tried meditation.',
    sc_donation: 'You donated to charity.', sc_stole: 'You stole something.',
    sc_inheritance: 'You received an inheritance!', sc_good_news: 'You received great news!',
    sc_bad_news: 'You received bad news.', sc_hospital: 'You were hospitalized.',
    // Wardrobe
    wardrobe: 'Wardrobe', wardrobe_tab: 'Wardrobe', equip: 'Equip', unequip: 'Unequip',
    equipped: 'Equipped', no_clothes: 'No clothes owned yet. Visit the shop!',
    wardrobe_outfit: 'Outfit', wardrobe_accessory: 'Accessory', wardrobe_shoes: 'Shoes', wardrobe_bag: 'Bag',
    your_look: 'Your Current Look',
    // Royalty actions
    royalty_no_job: 'You are Royalty, you cannot hold a regular job!',
    abdicate: 'Abdicate Throne', hold_royal_ball: 'Hold a Royal Ball', execute_law: 'Execute a Law',
    royalty_actions: 'Royal Duties',
    // Crime Ladder
    crime_ladder: 'Criminal Ladder', crime_rank: 'Criminal Rank',
    order_hit: 'Order a Hit', launder_money: 'Launder Money', extort_business: 'Extort Business',
    crime_lord_actions: 'Crime Lord Actions',
    // Status-specific scenarios
    sc_gang_war: 'A rival gang declared war on your territory.',
    sc_royal_scandal: 'A royal scandal hit the tabloids today.',
    sc_heist_opportunity: 'A big heist opportunity appeared.',
    sc_royal_ball_event: 'The King wants you at a royal gala.',
    sc_mafia_tribute: 'Your lieutenants brought you tribute money.',
    sc_rival_mafia: 'The rival Mafia Boss tried to muscle in.',
    // Packs redesign labels
    pack_best_value: 'BEST VALUE', pack_popular: 'POPULAR', pack_exclusive: 'EXCLUSIVE',
    pack_new: 'NEW', pack_limited: 'LIMITED',
  },
  ES: {
    new_life: 'Nueva Vida', custom_life: 'Vida Personalizada', graveyard: 'Cementerio', shop: 'Tienda',
    settings: 'Ajustes', life: 'Vida', activities: 'Actividades', shopping: 'Tienda', family: 'Familia',
    school: 'Escuela', work: 'Trabajo', love: 'Amor', assets: 'Bienes', crime: 'Crimen',
    casino: 'Casino', phone: 'Teléfono', age: 'Edad', health: 'Salud', happiness: 'Felicidad',
    smarts: 'Inteligencia', looks: 'Apariencia', money: 'Dinero', age_up: 'Edad +1', parents: 'Padres',
    siblings: 'Hermanos', partner: 'Pareja', children: 'Hijos', classmates: 'Compañeros',
    teachers: 'Profesores', talk: 'Hablar', hug: 'Abrazar', compliment: 'Halagar', ask_money: 'Pedir Dinero',
    give_money: 'Dar Dinero', prank: 'Bromear', insult: 'Insultar', fight: 'Pelear', befriend: 'Hacer Amigo',
    flirt: 'Coquetear', bully: 'Acosar', ask_help: 'Pedir Ayuda', propose: 'Proponer', marry: 'Casarse',
    break_up: 'Terminar', have_baby: 'Tener Bebé', jobs: 'Trabajos', current_job: 'Trabajo Actual',
    apply: 'Aplicar', properties: 'Propiedades', vehicles: 'Vehículos', pets: 'Mascotas',
    buy: 'Comprar', adopt: 'Adoptar', dating_apps: 'Apps de Citas', single: 'Soltero/a',
    date: 'Cita', pass: 'Pasar', target: 'Objetivo', stranger: 'Extraño', bet_amount: 'Apuesta',
    hit: 'Pedir', stand: 'Plantarse', double: 'Doblar', escape: 'Escapar', give_up: 'Rendirse',
    start_life: 'Empezar Vida', close: 'Cerrar', dark_mode: 'Modo Oscuro', sound: 'Sonido',
    music: 'Música', language: 'Idioma', name: 'Nombre', gender: 'Género', male: 'Hombre',
    female: 'Mujer', country: 'País', city: 'Ciudad', skin_tone: 'Tono de Piel',
    sexuality: 'Sexualidad', straight: 'Heterosexual', gay: 'Gay', bisexual: 'Bisexual',
    special_birth: 'Nacimiento Especial', born_royal: 'Nacer Real', custom_stats: 'Stats Personalizados',
    rest_in_peace: 'Descanse en Paz', lived: 'Vivió', years: 'años', karma: 'Karma',
    continue_as: 'Continuar como', new_life_btn: 'Nueva Vida', surgery: 'Cirugía', end_life: 'Terminar Vida',
    life_story: 'Historia de Vida', too_young: 'Muy joven para escuela', graduated: 'Graduado',
    prison: 'Prisión', juvenile: 'Detención Juvenil', years_left: 'años restantes',
    drivers_license: 'Licencia de Conducir', take_test: 'Tomar Examen', passed: '¡Aprobado!',
    failed: '¡Reprobado!', luxury_fashion: 'Moda de Lujo', home_decor: 'Decoración',
    stolen_items: 'Objetos Robados', conception: 'Concepción', relationship: 'Relación',
    dating: 'Saliendo', engaged: 'Comprometido', married: 'Casado', affection: 'Afecto',
    go_on_date: 'Ir a Cita', give_gift: 'Dar Regalo', complain: 'Quejarse',
    family_member: 'Familiar',
    // Doctor
    doctor: '🩺 Doctor', checkup: 'Revisión ($200)', treat_disease: 'Tratar Enfermedad ($5,000)',
    full_heal: 'Curación Total ($500)', doctor_intro: 'Visita al médico para mantenerte sano.',
    no_conditions: 'Sin enfermedades activas', conditions: 'condición(es)',
    // Graveyard
    graveyard_title: 'Cementerio', no_past_lives: '¡No hay vidas pasadas aún — empieza a jugar!',
    at_age: 'a los', children_label: 'hijos', royal_label: '👑 Real',
    // Pack taglines
    pack_starter_tagline: '¡El comienzo perfecto para tu reina rubia!',
    pack_luxury_tagline: '¡Vive la vida de lujo con estilo!',
    pack_god_tagline: 'Intocable. Al máximo. Legendario.',
    pack_noads_tagline: 'Juego limpio, sin interrupciones.',
    pack_crime_tagline: 'Nuevos atracos, nuevas riquezas.',
    pack_fame_tagline: 'Conviértete en la estrella que naciste para ser.',
    pack_royal_tagline: 'Nacido para reinar. Nacido real.',
    pack_time_tagline: 'Rebobina. Rehaz. Revive.',
    // Scenario events
    sc_birthday: '¡Cumpleaños!', sc_got_sick: 'Te enfermaste.', sc_accident: 'Tuviste un accidente.',
    sc_promotion: '¡Conseguiste una promoción!', sc_fired: 'Te despidieron.', sc_lottery: '¡Ganaste la lotería!',
    sc_robbery: 'Te robaron.', sc_fell_love: 'Te enamoraste.', sc_breakup: 'Tu relación terminó.',
    sc_new_friend: '¡Hiciste un nuevo amigo!', sc_argument: 'Tuviste una gran discusión.',
    sc_vacation: '¡Te fuiste de vacaciones!', sc_exercise: 'Empezaste a hacer ejercicio.',
    sc_ate_junk: 'Comiste comida chatarra toda la semana.', sc_studied: 'Estudiaste mucho.',
    sc_party: '¡Fuiste a una fiesta salvaje!', sc_meditation: 'Intentaste la meditación.',
    sc_donation: 'Donaste a la caridad.', sc_stole: 'Robaste algo.',
    sc_inheritance: '¡Recibiste una herencia!', sc_good_news: '¡Recibiste buenas noticias!',
    sc_bad_news: 'Recibiste malas noticias.', sc_hospital: 'Fuiste hospitalizado.',
    wardrobe: 'Vestuario', wardrobe_tab: 'Vestuario', equip: 'Equipar', unequip: 'Desequipar',
    equipped: 'Equipado', no_clothes: '¡Aún no tienes ropa. ¡Visita la tienda!',
    wardrobe_outfit: 'Ropa', wardrobe_accessory: 'Accesorio', wardrobe_shoes: 'Zapatos', wardrobe_bag: 'Bolso',
    your_look: 'Tu Apariencia Actual',
    royalty_no_job: '¡Eres de la Realeza, no puedes tener un trabajo normal!',
    abdicate: 'Abdicar el Trono', hold_royal_ball: 'Organizar un Baile Real', execute_law: 'Ejecutar una Ley',
    royalty_actions: 'Deberes Reales',
    crime_ladder: 'Escalera Criminal', crime_rank: 'Rango Criminal',
    order_hit: 'Ordenar un Ataque', launder_money: 'Lavar Dinero', extort_business: 'Extorsionar un Negocio',
    crime_lord_actions: 'Acciones del Señor del Crimen',
    sc_gang_war: 'Una banda rival declaró la guerra a tu territorio.',
    sc_royal_scandal: 'Un escándalo real llegó a los tabloides hoy.',
    sc_heist_opportunity: 'Surgió una gran oportunidad de robo.',
    sc_royal_ball_event: 'El Rey te quiere en una gala real.',
    sc_mafia_tribute: 'Tus lugartenientes te trajeron dinero de tributo.',
    sc_rival_mafia: 'El rival Jefe de la Mafia intentó meterse.',
    pack_best_value: 'MEJOR VALOR', pack_popular: 'POPULAR', pack_exclusive: 'EXCLUSIVO',
    pack_new: 'NUEVO', pack_limited: 'LIMITADO',
  },
  RO: {
    new_life: 'Viață Nouă', custom_life: 'Viață Personalizată', graveyard: 'Cimitir', shop: 'Magazin',
    settings: 'Setări', life: 'Viață', activities: 'Activități', shopping: 'Magazin', family: 'Familie',
    school: 'Școală', work: 'Muncă', love: 'Dragoste', assets: 'Bunuri', crime: 'Crimă',
    casino: 'Cazinou', phone: 'Telefon', age: 'Vârstă', health: 'Sănătate', happiness: 'Fericire',
    smarts: 'Inteligență', looks: 'Aspect', money: 'Bani', age_up: 'Vârstă +1', parents: 'Părinți',
    siblings: 'Frați', partner: 'Partener', children: 'Copii', classmates: 'Colegi',
    teachers: 'Profesori', talk: 'Vorbește', hug: 'Îmbrățișează', compliment: 'Complimentează', ask_money: 'Cere Bani',
    give_money: 'Dă Bani', prank: 'Farsă', insult: 'Insultă', fight: 'Luptă', befriend: 'Împrietenește',
    flirt: 'Flirtează', bully: 'Hărțuiește', ask_help: 'Cere Ajutor', propose: 'Propune', marry: 'Căsătorește',
    break_up: 'Desparte', have_baby: 'Fă Copil', jobs: 'Joburi', current_job: 'Job Actual',
    apply: 'Aplică', properties: 'Proprietăți', vehicles: 'Vehicule', pets: 'Animale',
    buy: 'Cumpără', adopt: 'Adoptă', dating_apps: 'Aplicații Dating', single: 'Singur/ă',
    date: 'Întâlnire', pass: 'Treci', target: 'Țintă', stranger: 'Străin', bet_amount: 'Sumă Pariu',
    hit: 'Trage', stand: 'Stai', double: 'Dublează', escape: 'Evadează', give_up: 'Renunță',
    start_life: 'Începe Viața', close: 'Închide', dark_mode: 'Mod Întunecat', sound: 'Sunet',
    music: 'Muzică', language: 'Limbă', name: 'Nume', gender: 'Gen', male: 'Bărbat',
    female: 'Femeie', country: 'Țară', city: 'Oraș', skin_tone: 'Ton Piele',
    sexuality: 'Sexualitate', straight: 'Hetero', gay: 'Gay', bisexual: 'Bisexual',
    special_birth: 'Naștere Specială', born_royal: 'Născut Regal', custom_stats: 'Statistici',
    rest_in_peace: 'Odihnească-se în Pace', lived: 'A trăit', years: 'ani', karma: 'Karma',
    continue_as: 'Continuă ca', new_life_btn: 'Viață Nouă', surgery: 'Chirurgie', end_life: 'Termină Viața',
    life_story: 'Povestea Vieții', too_young: 'Prea mic pentru școală', graduated: 'Absolvent',
    prison: 'Închisoare', juvenile: 'Detenție Juvenilă', years_left: 'ani rămași',
    drivers_license: 'Permis de Conducere', take_test: 'Dă Testul', passed: 'Trecut!',
    failed: 'Picat!', luxury_fashion: 'Modă de Lux', home_decor: 'Decorațiuni',
    stolen_items: 'Obiecte Furate', conception: 'Concepție', relationship: 'Relație',
    dating: 'Întâlniri', engaged: 'Logodit', married: 'Căsătorit', affection: 'Afecțiune',
    go_on_date: 'La Întâlnire', give_gift: 'Dă Cadou', complain: 'Plângere',
    family_member: 'Membru Familie',
    // Doctor
    doctor: '🩺 Doctor', checkup: 'Control ($200)', treat_disease: 'Tratament ($5.000)',
    full_heal: 'Vindecare Completă ($500)', doctor_intro: 'Vizitează doctorul pentru a fi sănătos.',
    no_conditions: 'Nicio afecțiune activă', conditions: 'afecțiune(i)',
    // Graveyard
    graveyard_title: 'Cimitir', no_past_lives: 'Nicio viață anterioară — începe să joci!',
    at_age: 'la vârsta de', children_label: 'copii', royal_label: '👑 Regal',
    // Pack taglines
    pack_starter_tagline: 'Începutul perfect pentru regina ta!',
    pack_luxury_tagline: 'Trăiește viața de lux cu stil!',
    pack_god_tagline: 'De neatins. Maximizat. Legendar.',
    pack_noads_tagline: 'Joc fără reclame, fără întreruperi.',
    pack_crime_tagline: 'Jafuri noi, bogăție nouă.',
    pack_fame_tagline: 'Devino vedeta care ești!',
    pack_royal_tagline: 'Născut să conducă. Regal.',
    pack_time_tagline: 'Rewind. Refă. Retrăiește.',
    // Scenario events
    sc_birthday: 'La mulți ani!', sc_got_sick: 'Te-ai îmbolnăvit.', sc_accident: 'Ai avut un accident.',
    sc_promotion: 'Ai primit o promovare!', sc_fired: 'Ai fost concediat.', sc_lottery: 'Ai câștigat la loterie!',
    sc_robbery: 'Ai fost jefuit.', sc_fell_love: 'Te-ai îndrăgostit.', sc_breakup: 'Relația ta s-a terminat.',
    sc_new_friend: 'Ți-ai făcut un prieten nou!', sc_argument: 'Ai avut o ceartă mare.',
    sc_vacation: 'Ai plecat în vacanță!', sc_exercise: 'Ai început să faci sport.',
    sc_ate_junk: 'Ai mâncat junk food toată săptămâna.', sc_studied: 'Ai studiat mult.',
    sc_party: 'Ai fost la o petrecere nebună!', sc_meditation: 'Ai încercat meditația.',
    sc_donation: 'Ai donat la caritate.', sc_stole: 'Ai furat ceva.',
    sc_inheritance: 'Ai primit o moștenire!', sc_good_news: 'Ai primit vești bune!',
    sc_bad_news: 'Ai primit vești proaste.', sc_hospital: 'Ai fost spitalizat.',
    wardrobe: 'Garderobă', wardrobe_tab: 'Garderobă', equip: 'Echipează', unequip: 'Dezechipează',
    equipped: 'Echipat', no_clothes: 'Nu ai haine încă. Vizitează magazinul!',
    wardrobe_outfit: 'Ținută', wardrobe_accessory: 'Accesoriu', wardrobe_shoes: 'Pantofi', wardrobe_bag: 'Geantă',
    your_look: 'Aspectul Tău Actual',
    royalty_no_job: 'Ești membru al Familiei Regale, nu poți avea un job normal!',
    abdicate: 'Abdică de pe Tron', hold_royal_ball: 'Organizează un Bal Regal', execute_law: 'Execută o Lege',
    royalty_actions: 'Îndatoriri Regale',
    crime_ladder: 'Scara Criminală', crime_rank: 'Rang Criminal',
    order_hit: 'Ordonă un Atac', launder_money: 'Spală Bani', extort_business: 'Extorcă o Afacere',
    crime_lord_actions: 'Acțiunile Lordului Crimei',
    sc_gang_war: 'O bandă rivală a declarat război teritoriului tău.',
    sc_royal_scandal: 'Un scandal regal a ajuns în ziare azi.',
    sc_heist_opportunity: 'A apărut o oportunitate mare de jaf.',
    sc_royal_ball_event: 'Regele vrea să fii la o gală regală.',
    sc_mafia_tribute: 'Locotenentii tăi ți-au adus bani tributari.',
    sc_rival_mafia: 'Rivalul Șef al Mafiei a încercat să intre pe teritoriul tău.',
    pack_best_value: 'CEL MAI BUN PREȚ', pack_popular: 'POPULAR', pack_exclusive: 'EXCLUSIV',
    pack_new: 'NOU', pack_limited: 'LIMITAT',
  },
};

// All Countries with Cities
const ALL_COUNTRIES = {
  'USA': ['New York', 'Los Angeles', 'Chicago', 'Houston', 'Phoenix', 'Miami', 'Seattle', 'Boston', 'Denver', 'Atlanta', 'San Francisco', 'Dallas', 'Las Vegas', 'Washington DC', 'Philadelphia'],
  'UK': ['London', 'Manchester', 'Birmingham', 'Leeds', 'Glasgow', 'Liverpool', 'Edinburgh', 'Bristol', 'Belfast', 'Cardiff'],
  'Canada': ['Toronto', 'Vancouver', 'Montreal', 'Calgary', 'Ottawa', 'Edmonton', 'Winnipeg', 'Quebec City'],
  'Australia': ['Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Adelaide', 'Gold Coast', 'Canberra'],
  'Germany': ['Berlin', 'Munich', 'Hamburg', 'Frankfurt', 'Cologne', 'Stuttgart', 'Dusseldorf', 'Dresden'],
  'France': ['Paris', 'Lyon', 'Marseille', 'Toulouse', 'Nice', 'Bordeaux', 'Strasbourg', 'Lille'],
  'Japan': ['Tokyo', 'Osaka', 'Kyoto', 'Nagoya', 'Sapporo', 'Yokohama', 'Kobe', 'Hiroshima'],
  'Brazil': ['Sao Paulo', 'Rio de Janeiro', 'Brasilia', 'Salvador', 'Fortaleza', 'Belo Horizonte', 'Curitiba', 'Recife'],
  'Mexico': ['Mexico City', 'Guadalajara', 'Monterrey', 'Puebla', 'Tijuana', 'Cancun', 'Merida', 'Oaxaca'],
  'Italy': ['Rome', 'Milan', 'Naples', 'Turin', 'Florence', 'Venice', 'Bologna', 'Palermo'],
  'Spain': ['Madrid', 'Barcelona', 'Valencia', 'Seville', 'Bilbao', 'Malaga', 'Zaragoza', 'Granada'],
  'India': ['Mumbai', 'Delhi', 'Bangalore', 'Chennai', 'Kolkata', 'Hyderabad', 'Pune', 'Jaipur', 'Ahmedabad'],
  'China': ['Beijing', 'Shanghai', 'Guangzhou', 'Shenzhen', 'Chengdu', 'Hangzhou', 'Wuhan', 'Xian'],
  'Russia': ['Moscow', 'Saint Petersburg', 'Novosibirsk', 'Sochi', 'Kazan', 'Yekaterinburg'],
  'South Korea': ['Seoul', 'Busan', 'Incheon', 'Daegu', 'Daejeon', 'Gwangju'],
  'Nigeria': ['Lagos', 'Abuja', 'Kano', 'Ibadan', 'Port Harcourt', 'Benin City', 'Enugu'],
  'South Africa': ['Johannesburg', 'Cape Town', 'Durban', 'Pretoria', 'Soweto', 'Port Elizabeth'],
  'UAE': ['Dubai', 'Abu Dhabi', 'Sharjah', 'Al Ain', 'Ajman'],
  'Romania': ['Bucharest', 'Cluj-Napoca', 'Timisoara', 'Iasi', 'Constanta', 'Brasov', 'Sibiu', 'Oradea'],
  'Poland': ['Warsaw', 'Krakow', 'Lodz', 'Wroclaw', 'Poznan', 'Gdansk', 'Szczecin'],
  'Netherlands': ['Amsterdam', 'Rotterdam', 'The Hague', 'Utrecht', 'Eindhoven'],
  'Sweden': ['Stockholm', 'Gothenburg', 'Malmo', 'Uppsala'],
  'Argentina': ['Buenos Aires', 'Cordoba', 'Rosario', 'Mendoza', 'La Plata'],
  'Egypt': ['Cairo', 'Alexandria', 'Giza', 'Luxor', 'Aswan'],
  'Thailand': ['Bangkok', 'Chiang Mai', 'Phuket', 'Pattaya', 'Krabi'],
  'Philippines': ['Manila', 'Cebu', 'Davao', 'Quezon City', 'Makati'],
  'Vietnam': ['Ho Chi Minh', 'Hanoi', 'Da Nang', 'Hue', 'Nha Trang'],
  'Turkey': ['Istanbul', 'Ankara', 'Izmir', 'Antalya', 'Bursa'],
  'Greece': ['Athens', 'Thessaloniki', 'Patras', 'Heraklion', 'Rhodes'],
  'Portugal': ['Lisbon', 'Porto', 'Faro', 'Braga', 'Coimbra'],
  'Colombia': ['Bogota', 'Medellin', 'Cali', 'Barranquilla', 'Cartagena'],
  'Chile': ['Santiago', 'Valparaiso', 'Concepcion', 'La Serena'],
  'Peru': ['Lima', 'Cusco', 'Arequipa', 'Trujillo'],
  'Cuba': ['Havana', 'Santiago de Cuba', 'Camaguey', 'Trinidad'],
  'Dominican Republic': ['Santo Domingo', 'Punta Cana', 'Santiago', 'La Romana'],
  'Puerto Rico': ['San Juan', 'Ponce', 'Mayaguez', 'Bayamon'],
  'Venezuela': ['Caracas', 'Maracaibo', 'Valencia', 'Barquisimeto'],
  'Saudi Arabia': ['Riyadh', 'Jeddah', 'Mecca', 'Medina', 'Dammam'],
  'Israel': ['Tel Aviv', 'Jerusalem', 'Haifa', 'Eilat'],
  'Indonesia': ['Jakarta', 'Bali', 'Surabaya', 'Bandung', 'Yogyakarta'],
  'Malaysia': ['Kuala Lumpur', 'Penang', 'Malacca', 'Johor Bahru'],
  'Singapore': ['Singapore City', 'Orchard', 'Marina Bay', 'Sentosa'],
  'Pakistan': ['Karachi', 'Lahore', 'Islamabad', 'Peshawar', 'Faisalabad'],
  'Bangladesh': ['Dhaka', 'Chittagong', 'Sylhet', 'Khulna'],
  'Kenya': ['Nairobi', 'Mombasa', 'Kisumu', 'Nakuru'],
  'Ethiopia': ['Addis Ababa', 'Dire Dawa', 'Gondar', 'Bahir Dar'],
  'Ghana': ['Accra', 'Kumasi', 'Tamale', 'Cape Coast'],
  'Morocco': ['Casablanca', 'Marrakech', 'Fez', 'Tangier', 'Rabat'],
  'Norway': ['Oslo', 'Bergen', 'Trondheim', 'Stavanger'],
  'Denmark': ['Copenhagen', 'Aarhus', 'Odense', 'Aalborg'],
  'Finland': ['Helsinki', 'Tampere', 'Turku', 'Oulu'],
  'Ireland': ['Dublin', 'Cork', 'Galway', 'Limerick'],
  'Switzerland': ['Zurich', 'Geneva', 'Basel', 'Bern', 'Lucerne'],
  'Austria': ['Vienna', 'Salzburg', 'Innsbruck', 'Graz'],
  'Belgium': ['Brussels', 'Antwerp', 'Ghent', 'Bruges'],
  'Czech Republic': ['Prague', 'Brno', 'Ostrava', 'Plzen'],
  'Hungary': ['Budapest', 'Debrecen', 'Szeged', 'Pecs'],
  'Croatia': ['Zagreb', 'Split', 'Dubrovnik', 'Rijeka'],
  'Serbia': ['Belgrade', 'Novi Sad', 'Nis', 'Kragujevac'],
  'Bulgaria': ['Sofia', 'Plovdiv', 'Varna', 'Burgas'],
  'Ukraine': ['Kyiv', 'Lviv', 'Odessa', 'Kharkiv'],
  'Jamaica': ['Kingston', 'Montego Bay', 'Ocho Rios', 'Negril'],
  'Trinidad': ['Port of Spain', 'San Fernando', 'Chaguanas'],
  'New Zealand': ['Auckland', 'Wellington', 'Christchurch', 'Queenstown'],
  'Iceland': ['Reykjavik', 'Akureyri', 'Vik'],
  'Costa Rica': ['San Jose', 'Limon', 'Puntarenas'],
  'Panama': ['Panama City', 'Colon', 'David'],
  'Ecuador': ['Quito', 'Guayaquil', 'Cuenca'],
  'Bolivia': ['La Paz', 'Santa Cruz', 'Cochabamba', 'Sucre'],
  'Uruguay': ['Montevideo', 'Punta del Este', 'Salto'],
  'Paraguay': ['Asuncion', 'Ciudad del Este', 'Encarnacion'],
  'Iran': ['Tehran', 'Isfahan', 'Shiraz', 'Tabriz'],
  'Iraq': ['Baghdad', 'Erbil', 'Basra', 'Mosul'],
  'Jordan': ['Amman', 'Aqaba', 'Petra', 'Zarqa'],
  'Lebanon': ['Beirut', 'Tripoli', 'Sidon', 'Byblos'],
  'Qatar': ['Doha', 'Al Wakrah', 'Al Khor'],
  'Kuwait': ['Kuwait City', 'Hawalli', 'Salmiya'],
  'Bahrain': ['Manama', 'Riffa', 'Muharraq'],
  'Oman': ['Muscat', 'Salalah', 'Sohar'],
  'Nepal': ['Kathmandu', 'Pokhara', 'Bhaktapur'],
  'Sri Lanka': ['Colombo', 'Kandy', 'Galle'],
  'Myanmar': ['Yangon', 'Mandalay', 'Naypyidaw'],
  'Cambodia': ['Phnom Penh', 'Siem Reap', 'Sihanoukville'],
  'Laos': ['Vientiane', 'Luang Prabang', 'Pakse'],
  'Mongolia': ['Ulaanbaatar', 'Erdenet', 'Darkhan'],
  'Tanzania': ['Dar es Salaam', 'Zanzibar', 'Arusha', 'Dodoma'],
  'Uganda': ['Kampala', 'Entebbe', 'Jinja'],
  'Rwanda': ['Kigali', 'Butare', 'Gisenyi'],
  'Senegal': ['Dakar', 'Saint-Louis', 'Thies'],
  'Ivory Coast': ['Abidjan', 'Yamoussoukro', 'Bouake'],
  'Cameroon': ['Douala', 'Yaounde', 'Bamenda'],
  'Congo': ['Kinshasa', 'Lubumbashi', 'Brazzaville'],
  'Angola': ['Luanda', 'Benguela', 'Huambo'],
  'Mozambique': ['Maputo', 'Beira', 'Nampula'],
  'Zimbabwe': ['Harare', 'Bulawayo', 'Victoria Falls'],
  'Botswana': ['Gaborone', 'Francistown', 'Maun'],
  'Namibia': ['Windhoek', 'Swakopmund', 'Walvis Bay'],
  'Madagascar': ['Antananarivo', 'Toamasina', 'Antsirabe'],
  'Tunisia': ['Tunis', 'Sfax', 'Sousse', 'Djerba'],
  'Algeria': ['Algiers', 'Oran', 'Constantine'],
  'Libya': ['Tripoli', 'Benghazi', 'Misrata'],
  'Sudan': ['Khartoum', 'Omdurman', 'Port Sudan'],
  'Somalia': ['Mogadishu', 'Hargeisa', 'Berbera'],
};

const SKIN_TONES = [
  { id: 'light', emoji: '👶🏻', label: 'Light' },
  { id: 'light_medium', emoji: '👶🏼', label: 'Light Medium' },
  { id: 'medium', emoji: '👶🏽', label: 'Medium' },
  { id: 'medium_dark', emoji: '👶🏾', label: 'Medium Dark' },
  { id: 'dark', emoji: '👶🏿', label: 'Dark' },
];

// Card deck for Blackjack
const CARD_SUITS = ['♠', '♥', '♦', '♣'];
const CARD_VALUES = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];

function App() {
  const [screen, setScreen] = useState('home');
  const [character, setCharacter] = useState(null);
  const [theme, setTheme] = useState('dark');
  const [lang, setLang] = useState('EN');
  const [soundEnabled, setSoundEnabled] = useState(true);
  const [musicEnabled, setMusicEnabled] = useState(false);
  const [coins, setCoins] = useState(500);
  const [graveyard, setGraveyard] = useState([]);
  const [gameData, setGameData] = useState(null);
  const [activeTab, setActiveTab] = useState('life');
  const [modal, setModal] = useState(null);
  const [modalData, setModalData] = useState(null);
  const [bet, setBet] = useState(100);
  const [maze, setMaze] = useState(null);
  const [playerPos, setPlayerPos] = useState([0, 0]);
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);
  const [crimeTarget, setCrimeTarget] = useState('stranger');

  // Pack ownership flags (set on purchase)
  const [hasGodMode, setHasGodMode] = useState(false);
  const [hasMafiaPack, setHasMafiaPack] = useState(false);
  const [hasRoyalPack, setHasRoyalPack] = useState(false);
  const [hasNoAds, setHasNoAds] = useState(false);
  const [hasFamePack, setHasFamePack] = useState(false);
  const [hasTimeMachine, setHasTimeMachine] = useState(false);
  const [hasLuxuryPack, setHasLuxuryPack] = useState(false);
  const [hasStarterPack, setHasStarterPack] = useState(false);

  // Wardrobe equipped items (layered system)
  const [equippedItems, setEquippedItems] = useState({
    outfit: null,   // dress, top, etc
    accessory: null, // sunglasses, hat, etc
    shoes: null,
    bag: null,
  });
  const [wardrobeTab, setWardrobeTab] = useState('outfit');

  // Blackjack state
  const [bjGame, setBjGame] = useState(null);

  // Event popup state
  const [eventPopup, setEventPopup] = useState(null);

  // Driver's test state
  const [driverTest, setDriverTest] = useState(null);
  const [testAnswers, setTestAnswers] = useState({});

  // Luxury shop state
  const [selectedBrand, setSelectedBrand] = useState(null);

  // Home decoration state
  const [homeView, setHomeView] = useState('overview');

  // Music state
  const [musicPlaying, setMusicPlaying] = useState(false);
  const [currentTrack, setCurrentTrack] = useState('reggaeton');

  // Phone app states
  const [phoneApp, setPhoneApp] = useState(null);
  const [phoneMessages, setPhoneMessages] = useState([]);
  const [phonePosts, setPhonePosts] = useState([]);

  // Crime target selection
  const [crimeVictim, setCrimeVictim] = useState(null); // overview, interior, exterior

  // Character creator
  const [creator, setCreator] = useState({
    firstName: '',
    lastName: '',
    gender: 'male',
    country: 'USA',
    city: 'New York',
    skin_tone: 'medium',
    sexuality: 'straight',
    born_royal: false,
    health: 75,
    happiness: 75,
    smarts: 50,
    looks: 50,
  });

  const t = useCallback((key) => TRANSLATIONS[lang]?.[key] || TRANSLATIONS.EN[key] || key, [lang]);

  // Translate life log events
  const translateEvent = useCallback((eventText) => {
    if (lang === 'EN') return eventText;
    const eventTranslations = {
      ES: {
        'was born in': 'nació en',
        'Started': 'Empezó', 'Graduated from': 'Se graduó de',
        'Got hired as': 'Fue contratado como', 'Salary': 'Salario',
        'passed away at age': 'falleció a la edad de',
        'Got caught for': 'Fue atrapado por',
        'Sentenced to': 'Sentenciado a', 'years': 'años',
        'successful!': '¡exitoso!', 'Got': 'Consiguió',
        'Bought': 'Compró', 'from': 'de', 'for': 'por',
        'Found a date': 'Encontró una cita', 'on': 'en',
        'Proposed to': 'Se propuso a', 'Married': 'Se casó con',
        'Had a baby': 'Tuvo un bebé', 'named': 'llamado',
        'Escaped from': 'Escapó de', 'prison': 'prisión',
        'Failed escape': 'Escape fallido', 'Added': 'Agregó',
        'Released from': 'Liberado de',
        'Adopted a': 'Adoptó un', 'Surgery': 'Cirugía',
        'Pickpocket': 'Carterista', 'Shoplifting': 'Robo en tienda',
        'Car Theft': 'Robo de auto', 'Burglary': 'Robo con allanamiento',
        'Drug Dealing': 'Tráfico de drogas', 'Armed Robbery': 'Robo a mano armada',
        'Bank Robbery': 'Robo de banco', 'Murder': 'Asesinato',
        'Assault': 'Agresión', 'Fraud': 'Fraude',
        'Hacking': 'Hackeo', 'Arson': 'Incendio provocado',
        'target:': 'objetivo:',
      },
      RO: {
        'was born in': 's-a născut în',
        'Started': 'A început', 'Graduated from': 'A absolvit',
        'Got hired as': 'A fost angajat ca', 'Salary': 'Salariu',
        'passed away at age': 'a murit la vârsta de',
        'Got caught for': 'A fost prins pentru',
        'Sentenced to': 'Condamnat la', 'years': 'ani',
        'successful!': 'reușit!', 'Got': 'A primit',
        'Bought': 'A cumpărat', 'from': 'de la', 'for': 'pentru',
        'Found a date': 'A găsit o întâlnire', 'on': 'pe',
        'Proposed to': 'A cerut în căsătorie', 'Married': 'S-a căsătorit cu',
        'Had a baby': 'A avut un copil', 'named': 'numit',
        'Escaped from': 'A evadat din', 'prison': 'închisoare',
        'Failed escape': 'Evadare eșuată', 'Added': 'Adăugat',
        'Released from': 'Eliberat din',
        'Adopted a': 'A adoptat un', 'Surgery': 'Chirurgie',
        'target:': 'țintă:',
      },
    };
    const dict = eventTranslations[lang] || {};
    let translated = eventText;
    for (const [en, loc] of Object.entries(dict)) {
      translated = translated.replace(new RegExp(en, 'g'), loc);
    }
    return translated;
  }, [lang]);

  const playSound = useCallback((name) => {
    if (!soundEnabled) return;
    try {
      if (!audioCache[name]) {
        audioCache[name] = new Audio(SOUNDS[name] || SOUNDS.click);
        audioCache[name].volume = 0.4;
      }
      audioCache[name].currentTime = 0;
      audioCache[name].play().catch(() => {});
    } catch (e) {}
  }, [soundEnabled]);

  const toggleSound = useCallback(() => {
    setSoundEnabled(prev => !prev);
  }, []);

  const toggleMusic = useCallback((track) => {
    const trackToPlay = track || currentTrack;
    if (bgMusic && !track) {
      // Toggle off
      bgMusic.pause();
      bgMusic = null;
      setMusicPlaying(false);
      setMusicEnabled(false);
      return;
    }
    if (bgMusic) {
      bgMusic.pause();
      bgMusic = null;
    }
    try {
      bgMusic = new Audio(MUSIC_TRACKS[trackToPlay] || MUSIC_TRACKS.reggaeton);
      bgMusic.loop = true;
      bgMusic.volume = 0.25;
      bgMusic.play().catch(() => {});
      setMusicPlaying(true);
      setMusicEnabled(true);
      setCurrentTrack(trackToPlay);
    } catch (e) {}
  }, [currentTrack]);

  const notify = useCallback((msg, type = 'info') => {
    setNotification({ msg, type });
    setTimeout(() => setNotification(null), 3000);
  }, []);

  const colors = theme === 'dark' ? {
    bg: '#0a0a0a', surface: '#141414', surfaceLight: '#1f1f1f',
    primary: '#ff69b4', secondary: '#9370db', gold: '#ffd700',
    text: '#ffffff', textSec: '#a0a0a0', textMuted: '#606060',
    success: '#00d68f', error: '#ff4757',
  } : {
    bg: '#fef6f9', surface: '#ffffff', surfaceLight: '#fff0f5',
    primary: '#e91e8c', secondary: '#8b5cf6', gold: '#f59e0b',
    text: '#1a1a1a', textSec: '#505050', textMuted: '#909090',
    success: '#10b981', error: '#ef4444',
  };

  useEffect(() => { fetchGameData(); loadGraveyard(); }, []);

  const fetchGameData = async () => {
    try {
      const r = await fetch(`${API_URL}/api/game-data`);
      if (r.ok) setGameData(await r.json());
    } catch (e) {}
  };

  const loadGraveyard = async () => {
    try {
      const r = await fetch(`${API_URL}/api/graveyard/default`);
      if (r.ok) { const d = await r.json(); setGraveyard(d.graveyard || []); }
    } catch (e) {}
  };

  const createCharacter = async (custom = false) => {
    setLoading(true);
    playSound('click');
    try {
      const body = custom ? {
        name: creator.firstName && creator.lastName ? `${creator.firstName} ${creator.lastName}` : null,
        gender: creator.gender,
        country: creator.country,
        city: creator.city,
        skin_tone: creator.skin_tone,
        sexuality: creator.sexuality,
        born_royal: creator.born_royal,
        custom_stats: { health: creator.health, happiness: creator.happiness, smarts: creator.smarts, looks: creator.looks },
      } : {};
     const r = await fetch('https://pinklife-backend.onrender.com/api/character/create', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      if (r.ok) {
        const c = await r.json();
        setCharacter(c);
        setScreen('game');
        setModal(null);
        playSound('birth');
      }
    } catch (e) { notify('Error creating character', 'error'); }
    setLoading(false);
  };

  const ageUp = async () => {
    if (!character || loading || !character.is_alive) return;
    setLoading(true);
    playSound('click');
    try {
      const r = await fetch(`https://pinklife-backend.onrender.com/api/character/${character.id}/age-up`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ lang }),
      });
      if (r.ok) {
        const d = await r.json();
        setCharacter(d.character);
        playSound('levelup');
        // Show event popup if one was returned
        let eventToShow = d.event || null;

        // Custom correlations: inject status-specific events for Royalty/Mafia
        const crimeCount = d.character?.life_log?.filter(l => l.event?.toLowerCase().includes('crime') || l.event?.toLowerCase().includes('robbery') || l.event?.toLowerCase().includes('theft')).length || 0;
        const isMafiaStatus = crimeCount >= 20 || d.character?.crime_rank === 'Mafia Boss' || d.character?.crime_rank === 'El Padre';
        const isRoyalStatus = d.character?.is_royal;

        // 30% chance to override with custom scenario
        if (!eventToShow && Math.random() < 0.3) {
          const royalScenarios = [
            {
              title: { EN: '👑 Royal Scandal', ES: '👑 Escándalo Real', RO: '👑 Scandal Regal' },
              text: { EN: t('sc_royal_scandal'), ES: TRANSLATIONS.ES.sc_royal_scandal, RO: TRANSLATIONS.RO.sc_royal_scandal },
              choices: [
                { text: { EN: 'Deny everything (-$10,000)', ES: 'Negar todo (-$10.000)', RO: 'Neagă totul (-$10.000)' }, effects: { happiness: -10, karma: 5, money: -10000 } },
                { text: { EN: 'Confess publicly', ES: 'Confesar públicamente', RO: 'Mărturisește public' }, effects: { happiness: -20, karma: 15 } },
              ],
            },
            {
              title: { EN: '🎉 Royal Ball Invitation', ES: '🎉 Invitación al Baile Real', RO: '🎉 Invitație la Balul Regal' },
              text: { EN: t('sc_royal_ball_event'), ES: TRANSLATIONS.ES.sc_royal_ball_event, RO: TRANSLATIONS.RO.sc_royal_ball_event },
              choices: [
                { text: { EN: 'Attend and dazzle', ES: 'Asistir y deslumbrar', RO: 'Participă și uimește' }, effects: { happiness: 20, looks: 10, karma: 5 } },
                { text: { EN: 'Decline gracefully', ES: 'Declinar con gracia', RO: 'Refuză elegant' }, effects: { happiness: -5 } },
              ],
            },
          ];
          const mafiaScenarios = [
            {
              title: { EN: '🔫 Gang War', ES: '🔫 Guerra de Bandas', RO: '🔫 Război de Bandă' },
              text: { EN: t('sc_gang_war'), ES: TRANSLATIONS.ES.sc_gang_war, RO: TRANSLATIONS.RO.sc_gang_war },
              choices: [
                { text: { EN: 'Fight back (-$5,000)', ES: 'Contraatacar (-$5.000)', RO: 'Răspunde (-$5.000)' }, effects: { health: -15, karma: -10, money: -5000 } },
                { text: { EN: 'Negotiate a truce', ES: 'Negociar una tregua', RO: 'Negociază o pace' }, effects: { happiness: 10, karma: 10 } },
              ],
            },
            {
              title: { EN: '💰 Tribute Time', ES: '💰 Tiempo de Tributo', RO: '💰 Timp de Tribut' },
              text: { EN: t('sc_mafia_tribute'), ES: TRANSLATIONS.ES.sc_mafia_tribute, RO: TRANSLATIONS.RO.sc_mafia_tribute },
              choices: [
                { text: { EN: 'Take it all (+$25,000)', ES: 'Tomar todo (+$25.000)', RO: 'Ia tot (+$25.000)' }, effects: { money: 25000, karma: -5 } },
                { text: { EN: 'Split with the crew (+$10,000)', ES: 'Dividir con la banda (+$10.000)', RO: 'Împarte cu banda (+$10.000)' }, effects: { money: 10000, karma: 10, happiness: 15 } },
              ],
            },
          ];
          const pool = isRoyalStatus ? royalScenarios : isMafiaStatus ? mafiaScenarios : null;
          if (pool) {
            const picked = pool[Math.floor(Math.random() * pool.length)];
            eventToShow = {
              title: picked.title[lang] || picked.title.EN,
              text: picked.text[lang] || picked.text.EN,
              choices: picked.choices.map(c => ({ text: c.text[lang] || c.text.EN, effects: c.effects })),
            };
          }
        }

        // Only show event popup if character is still alive — don't cover death screen
        if (eventToShow && d.character?.is_alive !== false) {
          // ✅ Normalize choices: convert plain strings to {text, effects:{}} objects
          // to prevent Object.entries(choice.effects) crash in render and handleEventChoice
          const normalizedEvent = {
            ...eventToShow,
            choices: (eventToShow.choices || []).map(c =>
              typeof c === 'string' ? { text: c, effects: {} } : { ...c, effects: c.effects || {} }
            ),
          };
          setEventPopup(normalizedEvent);
        }
      }
    } catch (e) { notify('Error', 'error'); }
    setLoading(false);
  };

  const doActivity = async (name) => {
    if (!character || loading) return;
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/activity`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ activity_name: name }),
      });
      if (r.ok) {
        const d = await r.json();
        setCharacter(d.character);
        playSound('success');
        notify(d.message);
      } else {
        const err = await r.json();
        notify(err.detail || 'Failed', 'error');
        playSound('fail');
      }
    } catch (e) { notify('Error', 'error'); }
    setLoading(false);
  };

  const applyJob = async (title) => {
    if (!character || loading) return;
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/apply-job`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ job_title: title }),
      });
      if (r.ok) {
        const d = await r.json();
        setCharacter(d.character);
        playSound('success');
        notify(d.message);
      } else {
        const err = await r.json();
        notify(err.detail || 'Failed', 'error');
        playSound('fail');
      }
    } catch (e) { notify('Error', 'error'); }
    setLoading(false);
  };

  const commitCrime = async (name) => {
    if (!character || loading) return;
    setLoading(true);
    const victimName = crimeVictim?.name || 'a random stranger';
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/commit-crime`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ crime_name: name, target: crimeTarget, target_name: victimName }),
      });
      if (r.ok) {
        const d = await r.json();
        setCharacter(d.character);
        // ✅ If victim killed the character during crime, trigger death handling
        if (d.character?.is_alive === false || d.killed) {
          loadGraveyard();
          setModal(null);
          playSound('fail');
          setLoading(false);
          return;
        }
        if (d.caught) {
          playSound('fail');
          notify('Got caught!', 'error');
        } else {
          playSound('money');
          const lastLog = d.character.life_log?.[d.character.life_log.length - 1];
          notify(lastLog?.event || 'Success!', 'success');
        }
      }
    } catch (e) { notify('Error', 'error'); }
    setLoading(false);
  };

  const doSurgery = async (name) => {
    if (!character || loading) return;
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/surgery`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ surgery_name: name }),
      });
      if (r.ok) {
        const d = await r.json();
        setCharacter(d.character);
        playSound('success');
        notify('Surgery complete!');
      } else {
        const err = await r.json();
        notify(err.detail || 'Failed', 'error');
      }
    } catch (e) { notify('Error', 'error'); }
    setLoading(false);
  };

  const findDate = async () => {
    if (!character || loading || character.age < 12) {
      notify('Too young!', 'error');
      return;
    }
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/find-date`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
      });
      if (r.ok) {
        const d = await r.json();
        if (d.match) {
          setModalData(d.match);
          setModal('date-match');
          playSound('love');
        }
      }
    } catch (e) { notify('Error', 'error'); }
    setLoading(false);
  };

  const relationshipAction = async (action, partnerId = null, matchData = null) => {
    if (!character || loading) return;
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/relationship-action`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action, partner_id: partnerId, partner: matchData }),
      });
      if (r.ok) {
        const d = await r.json();
        setCharacter(d.character);
        playSound('love');
        notify(d.message);
        setModal(null);
      }
    } catch (e) { notify('Error', 'error'); }
    setLoading(false);
  };

  const interactFamily = async (memberId, action) => {
    if (!character || loading) return;
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/interact-family`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ member_id: memberId, action }),
      });
      if (r.ok) {
        const d = await r.json();
        setCharacter(d.character);
        playSound(['fight', 'insult'].includes(action) ? 'fail' : 'click');
        notify(d.message);
        setModal(null);
      }
    } catch (e) { notify('Error', 'error'); }
    setLoading(false);
  };

  const interactClassmate = async (id, action) => {
    if (!character || loading) return;
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/interact-classmate`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ classmate_id: id, action }),
      });
      if (r.ok) {
        const d = await r.json();
        setCharacter(d.character);
        playSound(action === 'bully' ? 'fail' : 'click');
        notify(d.message);
        setModal(null);
      }
    } catch (e) { notify('Error', 'error'); }
    setLoading(false);
  };

  const interactTeacher = async (id, action) => {
    if (!character || loading) return;
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/interact-teacher`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ teacher_id: id, action }),
      });
      if (r.ok) {
        const d = await r.json();
        setCharacter(d.character);
        playSound(action === 'prank' ? 'fail' : 'success');
        notify(d.message);
        setModal(null);
      }
    } catch (e) { notify('Error', 'error'); }
    setLoading(false);
  };

  const buyItem = async (category, itemName) => {
    if (!character || loading) return;
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/buy-item`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ category, item_name: itemName }),
      });
      if (r.ok) {
        const d = await r.json();
        setCharacter(d.character);
        playSound('money');
        notify(d.message);
      } else {
        const err = await r.json();
        notify(err.detail || 'Cannot buy', 'error');
      }
    } catch (e) { notify('Error', 'error'); }
    setLoading(false);
  };

  const adoptPet = async (petType, customName) => {
    if (!character || loading) return;
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/buy-pet`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pet_type: petType, pet_name: customName }),
      });
      if (r.ok) {
        const d = await r.json();
        setCharacter(d.character);
        playSound('success');
        notify(d.message);
        setModal(null);
      }
    } catch (e) { notify('Error', 'error'); }
    setLoading(false);
  };

  // Visual Blackjack
  const startBlackjack = () => {
    if (character.money < bet) {
      notify('Not enough money!', 'error');
      return;
    }
    playSound('cards');
    const deck = [];
    CARD_SUITS.forEach(suit => CARD_VALUES.forEach(val => deck.push({ suit, value: val })));
    for (let i = deck.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [deck[i], deck[j]] = [deck[j], deck[i]];
    }
    const playerCards = [deck.pop(), deck.pop()];
    const dealerCards = [deck.pop(), deck.pop()];
    setBjGame({ deck, playerCards, dealerCards, bet, phase: 'playing', playerStood: false });
    setModal('blackjack');
  };

  const getCardValue = (cards) => {
    let total = 0, aces = 0;
    cards.forEach(c => {
      if (c.value === 'A') { total += 11; aces++; }
      else if (['K', 'Q', 'J'].includes(c.value)) total += 10;
      else total += parseInt(c.value);
    });
    while (total > 21 && aces > 0) { total -= 10; aces--; }
    return total;
  };

  const bjHit = () => {
    if (!bjGame || bjGame.phase !== 'playing') return;
    playSound('cards');
    const newCard = bjGame.deck.pop();
    const newPlayerCards = [...bjGame.playerCards, newCard];
    const playerTotal = getCardValue(newPlayerCards);
    if (playerTotal > 21) {
      setBjGame({ ...bjGame, playerCards: newPlayerCards, phase: 'bust' });
      setTimeout(() => finishBlackjack(false, 'Bust!'), 1000);
    } else {
      setBjGame({ ...bjGame, playerCards: newPlayerCards });
    }
  };

  const bjStand = async () => {
    if (!bjGame || bjGame.phase !== 'playing') return;
    playSound('cards');
    let { deck, dealerCards } = bjGame;
    while (getCardValue(dealerCards) < 17) {
      dealerCards = [...dealerCards, deck.pop()];
    }
    setBjGame({ ...bjGame, dealerCards, playerStood: true });
    const playerTotal = getCardValue(bjGame.playerCards);
    const dealerTotal = getCardValue(dealerCards);
    setTimeout(() => {
      if (dealerTotal > 21 || playerTotal > dealerTotal) {
        finishBlackjack(true, dealerTotal > 21 ? 'Dealer busts!' : 'You win!');
      } else if (dealerTotal === playerTotal) {
        finishBlackjack(null, 'Push!');
      } else {
        finishBlackjack(false, 'Dealer wins!');
      }
    }, 1500);
  };

  const finishBlackjack = async (won, msg) => {
    if (!bjGame) return;
    const winnings = won ? bjGame.bet * 2 : won === null ? bjGame.bet : 0;
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/casino`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ game: 'blackjack', bet: bjGame.bet, result: won ? 'win' : won === null ? 'push' : 'lose' }),
      });
      if (r.ok) {
        const d = await r.json();
        setCharacter(d.character);
      }
    } catch (e) {}
    notify(`${msg} ${won ? `Won $${winnings}!` : won === null ? 'Bet returned.' : ''}`, won ? 'success' : won === null ? 'info' : 'error');
    playSound(won ? 'money' : won === null ? 'click' : 'fail');
    setTimeout(() => { setBjGame(null); setModal(null); }, 2000);
  };

  // Maze escape
  const startMaze = async () => {
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/escape-prison`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ generate_maze: true }),
      });
      if (r.ok) {
        const d = await r.json();
        setMaze(d.maze);
        setPlayerPos([0, 0]);
        setModal('maze');
      }
    } catch (e) {}
  };

  const moveMaze = (dir) => {
    if (!maze) return;
    const [x, y] = playerPos;
    let nx = x, ny = y;
    if (dir === 'up' && y > 0) ny--;
    if (dir === 'down' && y < maze.size - 1) ny++;
    if (dir === 'left' && x > 0) nx--;
    if (dir === 'right' && x < maze.size - 1) nx++;
    if (maze.maze[ny][nx] === 0) {
      setPlayerPos([nx, ny]);
      if (nx === maze.size - 1 && ny === maze.size - 1) escapePrison(true);
    }
  };

  const escapePrison = async (solved) => {
    setModal(null);
    setMaze(null);
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/escape-prison`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ solved }),
      });
      if (r.ok) {
        const d = await r.json();
        setCharacter(d.character);
        notify(d.escaped ? 'Escaped!' : 'Caught! More time added.', d.escaped ? 'success' : 'error');
        playSound(d.escaped ? 'success' : 'fail');
      }
    } catch (e) {}
    setLoading(false);
  };

  const endLife = async () => {
    if (!character) return;
    // Use modal confirm instead of window.confirm (blocked on mobile browsers)
    setModal('confirm-end-life');
  };

  const confirmEndLife = async () => {
    setModal(null);
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/end-life`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({}) });
      if (r.ok) {
        const d = await r.json();
        // Mark as dead — triggers death screen overlay
        setCharacter({ ...d.character, is_alive: false });
        playSound('death');
      } else {
        // Fallback — force death screen even if API fails
        setCharacter(prev => ({ ...prev, is_alive: false, cause_of_death: 'Chose to end life' }));
        playSound('death');
      }
    } catch (e) {
      setCharacter(prev => ({ ...prev, is_alive: false, cause_of_death: 'Chose to end life' }));
      playSound('death');
    }
    setLoading(false);
  };

  const handleEventChoice = async (choice) => {
    if (!character || !eventPopup) return;
    setLoading(true);

    // Bug Fix: Parse any money amount mentioned in choice text like "-$500" or "+$1000"
    const moneyMatch = choice.text?.match(/([+-])\$?([\d,]+)/);
    let localMoneyDelta = 0;
    if (moneyMatch) {
      const sign = moneyMatch[1] === '-' ? -1 : 1;
      localMoneyDelta = sign * parseInt(moneyMatch[2].replace(/,/g, ''), 10);
    }
    // Also check effects.money
    if (choice.effects?.money) localMoneyDelta += choice.effects.money;

    try {
      const choiceIndex = eventPopup.choices?.indexOf(choice);
      const r = await fetch(`${API_URL}/api/character/${character.id}/event-choice`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ event_type: eventPopup.title, choice_index: choiceIndex >= 0 ? choiceIndex : 0, effects: choice.effects }),
      });
      if (r.ok) {
        const d = await r.json();
        // Apply money delta on top of server response if backend didn't handle it
        const serverMoney = d.character?.money;
        const expectedMoney = (character.money || 0) + localMoneyDelta;
        const finalChar = { ...d.character };
        if (localMoneyDelta !== 0 && serverMoney === character.money) {
          // Backend didn't update money - apply locally
          finalChar.money = Math.max(0, expectedMoney);
        }
        // ✅ Apply local health effects for dynamic events not found in backend LIFE_EVENTS
        if (choice.effects?.health && finalChar.health === character.health) {
          finalChar.health = Math.max(0, Math.min(100, (character.health || 50) + choice.effects.health));
        }
        // ✅ If health hits 0, trigger death locally even if backend didn't catch it
        if (finalChar.health <= 0 && finalChar.is_alive !== false) {
          finalChar.is_alive = false;
          finalChar.cause_of_death = finalChar.cause_of_death || `Died from: ${eventPopup?.title || 'an event'}`;
        }
        setCharacter(finalChar);
        // ✅ If character died, reload graveyard immediately and clear event popup
        if (finalChar.is_alive === false) {
          setEventPopup(null);
          setModal(null);
          loadGraveyard();
          setLoading(false);
          return;
        }
        const effectStr = Object.entries(choice.effects || {}).map(([k, v]) => `${k}: ${v > 0 ? '+' : ''}${v}`).join(', ');
        notify(`${choice.text || String(choice)} (${effectStr})`, (choice.effects?.karma ?? 0) < 0 ? 'error' : 'success');
        playSound((choice.effects?.karma ?? 0) < 0 ? 'fail' : 'success');
      } else {
        // Fallback: apply effects locally
        if (localMoneyDelta !== 0) {
          setCharacter(prev => ({ ...prev, money: Math.max(0, (prev.money || 0) + localMoneyDelta) }));
        }
        notify(choice.text, 'info');
      }
    } catch (e) {
      // Fallback on network error
      if (localMoneyDelta !== 0) {
        setCharacter(prev => ({ ...prev, money: Math.max(0, (prev.money || 0) + localMoneyDelta) }));
      }
      notify('Event processed.', 'info');
    }
    setEventPopup(null);
    setLoading(false);
  };

  const startDriverTest = async () => {
    if (!character) return;
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/drivers-license`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ lang }),
      });
      if (r.ok) {
        const d = await r.json();
        if (d.test) {
          setDriverTest(d.test);
          setTestAnswers({});
          setModal('driver-test');
        }
      } else {
        const err = await r.json();
        notify(err.detail || 'Cannot start test', 'error');
      }
    } catch (e) { notify('Error', 'error'); }
    setLoading(false);
  };

  const submitDriverTest = async () => {
    if (!character || !driverTest) return;
    setLoading(true);
    let correct = 0;
    driverTest.forEach((q, i) => {
      if (parseInt(testAnswers[i]) === q.answer) correct++;
    });
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/drivers-license`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ correct_answers: correct, total_questions: driverTest.length, lang }),
      });
      if (r.ok) {
        const d = await r.json();
        setCharacter(d.character);
        if (d.passed) {
          notify(`🎓 ${t('passed')} ${correct}/${driverTest.length}`, 'success');
          playSound('success');
        } else {
          notify(`❌ ${t('failed')} ${correct}/${driverTest.length} — Need 4/5`, 'error');
          playSound('fail');
        }
      }
    } catch (e) { notify('Error', 'error'); }
    setDriverTest(null);
    setModal(null);
    setLoading(false);
  };

  const buyLuxury = async (brand, itemName) => {
    if (!character || loading) return;
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/buy-item`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ category: 'luxury', item_name: itemName, brand }),
      });
      if (r.ok) {
        const d = await r.json();
        setCharacter(d.character);
        playSound('money');
        notify(d.message);
      } else {
        const err = await r.json();
        notify(err.detail || 'Cannot buy', 'error');
      }
    } catch (e) { notify('Error', 'error'); }
    setLoading(false);
  };

  const goToDoctor = async (visitType = 'checkup') => {
    if (!character || loading) return;
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/go-to-doctor`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ visit_type: visitType }),
      });
      if (r.ok) {
        const d = await r.json();
        setCharacter(d.character);
        playSound('success');
        notify(d.message, 'success');
      } else {
        const err = await r.json();
        notify(err.detail || 'Cannot visit doctor', 'error');
        playSound('fail');
      }
    } catch (e) { notify('Error', 'error'); }
    setLoading(false);
  };

  // Auto-save to graveyard when character dies on frontend
  useEffect(() => {
    if (character && !character.is_alive) {
      // Already handled by backend, but reload graveyard to show updated list
      loadGraveyard();
    }
  }, [character?.is_alive]);

  const haveChild = async () => {
    if (!character || loading) return;
    const partner = character.partners?.[0];
    if (!partner) { notify('You need a partner to have children!', 'error'); return; }
    if (character.age < 18) { notify('Too young to have children!', 'error'); return; }
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/relationship-action`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'have_child', partner_id: partner.id }),
      });
      if (r.ok) {
        const d = await r.json();
        setCharacter(d.character);
        playSound('birth');
        notify(d.message || '🍼 You had a baby!', 'success');
      } else {
        const err = await r.json();
        notify(err.detail || 'Cannot have child', 'error');
      }
    } catch (e) { notify('Error', 'error'); }
    setLoading(false);
  };

  const adoptChild = async () => {
    if (!character || loading) return;
    if (character.age < 21) { notify('Must be 21+ to adopt!', 'error'); return; }
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/relationship-action`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'adopt_child' }),
      });
      if (r.ok) {
        const d = await r.json();
        setCharacter(d.character);
        playSound('birth');
        notify(d.message || '🏠 You adopted a child!', 'success');
      } else {
        const err = await r.json();
        notify(err.detail || 'Cannot adopt', 'error');
      }
    } catch (e) { notify('Error', 'error'); }
    setLoading(false);
  };

  const switchToChild = async (childId) => {
    if (!character) return;
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/character/${character.id}/switch-to-child`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ child_id: childId }),
      });
      if (r.ok) {
        const d = await r.json();
        setCharacter(d.character);
        playSound('success');
        notify('Now playing as your child!');
      }
    } catch (e) {}
    setLoading(false);
  };

  // Pink Clouds
  const PinkClouds = () => (
    <div className="clouds-container">
      {[...Array(6)].map((_, i) => <div key={i} className="pink-cloud">☁️</div>)}
    </div>
  );

  // ============ RENDER FUNCTIONS ============

  const renderHome = () => (
    <div className="home-screen" style={{ background: colors.bg, color: colors.text }}>
      <PinkClouds />
      <div className="home-top">
        <button className="theme-toggle" onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}>
          {theme === 'dark' ? '🌙' : '☀️'}
        </button>
        <div className="home-audio-btns" style={{ display: 'flex', gap: '0.4rem', alignItems: 'center' }}>
          {/* Sound SFX button — independent */}
          <button
            className="audio-toggle-btn"
            title="Toggle Sound Effects"
            style={{
              background: soundEnabled ? `${colors.primary}22` : 'rgba(255,255,255,0.07)',
              border: `1.5px solid ${soundEnabled ? colors.primary : colors.textMuted}`,
              borderRadius: '50%', width: 38, height: 38, cursor: 'pointer',
              fontSize: '1.1rem', display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
            onClick={toggleSound}
          >
            {soundEnabled ? '🔊' : '🔇'}
          </button>
          {/* Music button — independent */}
          <button
            className="audio-toggle-btn"
            title="Toggle Background Music"
            style={{
              background: musicPlaying ? `${colors.secondary}22` : 'rgba(255,255,255,0.07)',
              border: `1.5px solid ${musicPlaying ? colors.secondary : colors.textMuted}`,
              borderRadius: '50%', width: 38, height: 38, cursor: 'pointer',
              fontSize: '1.1rem', display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
            onClick={() => toggleMusic()}
          >
            {musicPlaying ? '🎵' : '🎶'}
          </button>
        </div>
        <div className="coins-display" style={{ color: colors.gold }}>💎 {coins}</div>
      </div>

      <div className="home-content">
        <div className="logo-container">
          <span className="logo-cloud">☁️</span>
          <h1 className="game-title">PINKLIFE</h1>
          <p className="game-subtitle" style={{ color: colors.textSec }}>Life Simulator</p>
        </div>

        <div className="home-buttons">
          <button className="primary-btn" style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.secondary})` }}
            onClick={() => createCharacter(false)}>
            ✨ {t('new_life')}
          </button>
          <button className="primary-btn" style={{ background: `linear-gradient(135deg, ${colors.secondary}, ${colors.primary})` }}
            onClick={() => setModal('creator')}>
            🎨 {t('custom_life')}
          </button>
        </div>

        <div className="secondary-btns">
          <button className="sec-btn" style={{ color: colors.text }} onClick={() => { loadGraveyard(); setModal('graveyard'); }}>
            <span className="sec-btn-icon">⚰️</span>
            <span className="sec-btn-text">{t('graveyard')}</span>
          </button>
          <button className="sec-btn" style={{ color: colors.text }} onClick={() => setModal('shop')}>
            <span className="sec-btn-icon">👑</span>
            <span className="sec-btn-text">{t('shop')}</span>
          </button>
          <button className="sec-btn" style={{ color: colors.text }} onClick={() => setModal('settings')}>
            <span className="sec-btn-icon">⚙️</span>
            <span className="sec-btn-text">{t('settings')}</span>
          </button>
        </div>

        <p className="version-text" style={{ color: colors.textMuted }}>v7.1 • Made by Bianca</p>
      </div>
    </div>
  );

  const renderGame = () => {
    if (!character) return null;

    const tabs = [
      { id: 'life', icon: '📖', label: t('life') },
      { id: 'activities', icon: '💪', label: t('activities') },
      { id: 'shopping', icon: '🛍️', label: t('shopping') },
      { id: 'family', icon: '👨‍👩‍👧', label: t('family') },
      // School only shows at age 6+ (no newborns/toddlers in school)
      ...(character.age >= 6 ? [{ id: 'school', icon: '🏫', label: t('school') }] : []),
      // Work only at 14+
      ...(character.age >= 14 ? [{ id: 'work', icon: '💼', label: t('work') }] : []),
      { id: 'love', icon: '💕', label: t('love') },
      { id: 'assets', icon: '🏠', label: t('assets') },
      // Crime at 10+
      ...(character.age >= 10 ? [{ id: 'crime', icon: '🦹', label: t('crime') }] : []),
      // Casino 21+
      ...(character.age >= 21 ? [{ id: 'casino', icon: '🎰', label: t('casino') }] : []),
      { id: 'phone', icon: '📱', label: t('phone') },
      { id: 'wardrobe', icon: '👗', label: t('wardrobe_tab') },
    ];

    // Royal crown on avatar
    const avatarDisplay = character.is_royal ? `👑${character.emoji}` : character.emoji;

    return (
      <div className="game-screen" style={{ background: colors.bg, color: colors.text }}>
        <div className="game-header" style={{ background: colors.surface }}>
          <button className="header-btn" data-testid="home-btn" onClick={() => setScreen('home')}>🏠</button>
          <div className="header-info">
            <span className="char-avatar" data-testid="char-avatar">{avatarDisplay}</span>
            <div className="char-name">{character.name}</div>
            <div className="char-location" style={{ color: colors.textSec }}>{character.city}, {character.country} • {t('age')} {character.age}</div>
          </div>
          <button className="header-btn" data-testid="sfx-btn" title="Toggle Sound FX"
            onClick={toggleSound}
            style={{ color: soundEnabled ? colors.primary : colors.textMuted }}>
            {soundEnabled ? '🔊' : '🔇'}
          </button>
          <button className="header-btn" data-testid="music-btn" title="Toggle Music"
            onClick={() => toggleMusic()}
            style={{ color: musicPlaying ? colors.secondary : colors.textMuted }}>
            {musicPlaying ? '🎵' : '🎶'}
          </button>
          <button className="header-btn" onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}>
            {theme === 'dark' ? '🌙' : '☀️'}
          </button>
          <div className="money-display" style={{ color: colors.success }}>${(character.money || 0).toLocaleString()}</div>
        </div>

        <div className="stats-section" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          {[
            { key: 'health', icon: '❤️', color: '#ff4757' },
            { key: 'happiness', icon: '😊', color: '#00d68f' },
            { key: 'smarts', icon: '🧠', color: '#3b82f6' },
            { key: 'looks', icon: '✨', color: '#f59e0b' },
          ].map(s => (
            <div key={s.key} className="stat-row">
              <span className="stat-icon">{s.icon}</span>
              <div className="stat-bar-container">
                <div className="stat-bar-fill" style={{ width: `${character[s.key] || 0}%`, background: `linear-gradient(90deg, ${s.color}, ${s.color}88)` }} />
              </div>
              <span className="stat-value" style={{ color: colors.text }}>{character[s.key] || 0}</span>
            </div>
          ))}
        </div>

        <div className="info-chips">
          {character.is_royal && <div className="info-chip royal"><span>👑</span><span style={{ color: colors.gold }}>{character.royal_title}</span></div>}
          {character.job !== 'Unemployed' && <div className="info-chip"><span>💼</span><span>{character.job}</span></div>}
          {character.has_license && <div className="info-chip"><span>🚗</span><span>Licensed</span></div>}
          {(character.in_prison || character.in_juvenile) && <div className="info-chip prison"><span>🔒</span><span style={{ color: colors.error }}>{character.prison_years?.toFixed(1)}yr</span></div>}
        </div>

        <div className="age-up-section">
          <button className="age-up-btn" onClick={ageUp} disabled={loading || !character.is_alive}>
            ⏰ {t('age_up')}
          </button>
        </div>

        <div className="tabs-wrapper" style={{ background: colors.bg }}>
          <div className="tabs-scroll">
            {tabs.map(tab => (
              <button key={tab.id} className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
                style={{ color: activeTab === tab.id ? '#fff' : colors.text }}
                onClick={() => { setActiveTab(tab.id); playSound('click'); }}>
                <span>{tab.icon}</span>
                <span>{tab.label}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="tab-content">
          {activeTab === 'life' && renderLifeTab()}
          {activeTab === 'activities' && renderActivitiesTab()}
          {activeTab === 'shopping' && renderShoppingTab()}
          {activeTab === 'family' && renderFamilyTab()}
          {activeTab === 'school' && renderSchoolTab()}
          {activeTab === 'work' && renderWorkTab()}
          {activeTab === 'love' && renderLoveTab()}
          {activeTab === 'assets' && renderAssetsTab()}
          {activeTab === 'crime' && renderCrimeTab()}
          {activeTab === 'casino' && renderCasinoTab()}
          {activeTab === 'phone' && renderPhoneTab()}
          {activeTab === 'wardrobe' && renderWardrobeTab()}
        </div>

        {/* 📱 Floating Phone Shortcut Button */}
        {character.is_alive && activeTab !== 'phone' && (
          <button
            onClick={() => { setActiveTab('phone'); playSound('click'); }}
            style={{
              position: 'fixed',
              bottom: '160px',
              right: '18px',
              width: '52px',
              height: '52px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #ff69b4, #ff1493)',
              border: 'none',
              boxShadow: '0 4px 16px rgba(255,105,180,0.5)',
              fontSize: '1.5rem',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 900,
              transition: 'transform 0.15s',
            }}
            title="Open Phone"
            onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.12)'}
            onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
          >
            📱
          </button>
        )}

        {!character.is_alive && renderDeathScreen()}
      </div>
    );
  };

  const renderLifeTab = () => (
    <div>
      {character.age === 0 && character.conception_method && (
        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          <div className="card-title" style={{ color: colors.primary }}>
            {character.conception_method.emoji} {t('conception')}
          </div>
          <p>{character.conception_method.method}</p>
          <p style={{ color: colors.textSec, fontSize: '0.9rem' }}>{character.conception_method.description}</p>
        </div>
      )}

      <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
        <div className="card-title">📜 {t('life_story')}</div>
        <div className="log-list">
          {character.life_log?.slice(-10).reverse().map((l, i) => (
            <div key={i} className="log-entry">
              <span className="log-age">{t('age')} {l.age}</span>
              <span className="log-text">{translateEvent(l.event)}</span>
            </div>
          ))}
        </div>
      </div>

      {(character.in_prison || character.in_juvenile) && (
        <div className="content-card prison-card">
          <div className="card-title" style={{ color: colors.error }}>
            🔒 {character.in_juvenile ? t('juvenile') : t('prison')}
          </div>
          <p>{character.prison_years?.toFixed(1)} {t('years_left')}</p>
          <button className="escape-btn" onClick={startMaze}>🏃 {t('escape')}</button>
        </div>
      )}

      <div className="action-btns-row">
        {character.age >= 18 && (
          <button className="action-btn-card" style={{ background: colors.secondary }}
            onClick={() => setModal('surgery')}>
            <span className="action-btn-icon">💉</span>
            <span className="action-btn-text">{t('surgery')}</span>
          </button>
        )}
        <button className="action-btn-card" style={{ background: colors.error }} onClick={endLife}>
          <span className="action-btn-icon">🕊️</span>
          <span className="action-btn-text">{t('end_life')}</span>
        </button>
      </div>
    </div>
  );

  const renderActivitiesTab = () => {
    const isMinor = character.age < 18;
    const healthPct = character.health || 0;
    const healthColor = healthPct >= 70 ? '#2ecc71' : healthPct >= 40 ? '#f39c12' : '#e74c3c';
    const hasDiseases = (character.active_diseases?.length || 0) > 0;

    return (
    <div>
      {/* 🏥 Medical Center — Premium UI */}
      <div style={{
        marginBottom: '1rem',
        borderRadius: '20px',
        overflow: 'hidden',
        border: `1.5px solid rgba(255,105,180,0.25)`,
        background: theme === 'dark'
          ? 'linear-gradient(145deg, rgba(20,10,30,0.95), rgba(40,10,50,0.9))'
          : 'linear-gradient(145deg, rgba(255,240,248,0.98), rgba(255,220,240,0.95))',
        boxShadow: '0 8px 32px rgba(255,20,147,0.12)',
      }}>
        {/* Header banner */}
        <div style={{
          padding: '1rem 1.2rem 0.75rem',
          background: 'linear-gradient(135deg, #ff1493cc, #c2185bcc)',
          display: 'flex', alignItems: 'center', gap: '0.75rem',
        }}>
          <span style={{ fontSize: '2rem' }}>🏥</span>
          <div style={{ flex: 1 }}>
            <div style={{ color: '#fff', fontWeight: 800, fontSize: '1.05rem', letterSpacing: '0.5px' }}>
              MEDICAL CENTER
            </div>
            <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.78rem' }}>
              {isMinor ? '🎁 Free care for minors (under 18)' : 'Professional healthcare services'}
            </div>
          </div>
          {isMinor && (
            <div style={{
              background: 'rgba(255,255,255,0.2)', borderRadius: '20px',
              padding: '0.25rem 0.6rem', color: '#fff', fontSize: '0.72rem', fontWeight: 700,
            }}>FREE</div>
          )}
        </div>

        {/* Health status bar */}
        <div style={{ padding: '0.9rem 1.2rem 0.6rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.4rem' }}>
            <span style={{ color: colors.textSec, fontSize: '0.8rem', fontWeight: 600 }}>HEALTH STATUS</span>
            <span style={{ color: healthColor, fontWeight: 800, fontSize: '0.95rem' }}>
              {healthPct >= 70 ? '✅ Good' : healthPct >= 40 ? '⚠️ Fair' : '🚨 Critical'} — {healthPct}/100
            </span>
          </div>
          <div style={{ height: '8px', background: 'rgba(255,255,255,0.1)', borderRadius: '4px', overflow: 'hidden' }}>
            <div style={{
              height: '100%', width: `${healthPct}%`,
              background: `linear-gradient(90deg, ${healthColor}99, ${healthColor})`,
              borderRadius: '4px', transition: 'width 0.4s ease',
            }} />
          </div>
          {hasDiseases && (
            <div style={{
              marginTop: '0.5rem', padding: '0.4rem 0.7rem', borderRadius: '8px',
              background: 'rgba(231,76,60,0.15)', border: '1px solid rgba(231,76,60,0.3)',
              display: 'flex', alignItems: 'center', gap: '0.5rem',
            }}>
              <span>⚠️</span>
              <span style={{ color: '#e74c3c', fontSize: '0.82rem', fontWeight: 600 }}>
                {character.active_diseases.length} active condition{character.active_diseases.length > 1 ? 's' : ''} detected
              </span>
            </div>
          )}
        </div>

        {/* Service cards */}
        <div style={{ padding: '0 1rem 1rem', display: 'flex', flexDirection: 'column', gap: '0.55rem' }}>

          {/* Checkup */}
          <button onClick={() => goToDoctor('checkup')} disabled={loading}
            style={{
              display: 'flex', alignItems: 'center', gap: '0.9rem',
              padding: '0.85rem 1rem', borderRadius: '14px', border: 'none',
              background: theme === 'dark' ? 'rgba(46,204,113,0.12)' : 'rgba(46,204,113,0.1)',
              cursor: loading ? 'not-allowed' : 'pointer', textAlign: 'left',
              borderLeft: '3px solid #2ecc71', width: '100%', opacity: loading ? 0.6 : 1,
              transition: 'all 0.2s',
            }}>
            <span style={{ fontSize: '1.6rem', minWidth: '2rem', textAlign: 'center' }}>🩺</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, color: colors.text, fontSize: '0.92rem' }}>
                General Checkup
              </div>
              <div style={{ color: colors.textSec, fontSize: '0.78rem', marginTop: '0.1rem' }}>
                Routine examination · Health +5–15
              </div>
            </div>
            <div style={{
              background: isMinor ? 'rgba(46,204,113,0.2)' : 'rgba(255,255,255,0.08)',
              borderRadius: '10px', padding: '0.3rem 0.65rem',
              color: isMinor ? '#2ecc71' : colors.text, fontWeight: 700, fontSize: '0.85rem',
              whiteSpace: 'nowrap',
            }}>
              {isMinor ? 'FREE' : '$200'}
            </div>
          </button>

          {/* Full Heal */}
          <button onClick={() => goToDoctor('heal')} disabled={loading}
            style={{
              display: 'flex', alignItems: 'center', gap: '0.9rem',
              padding: '0.85rem 1rem', borderRadius: '14px', border: 'none',
              background: theme === 'dark' ? 'rgba(52,152,219,0.12)' : 'rgba(52,152,219,0.1)',
              cursor: loading ? 'not-allowed' : 'pointer', textAlign: 'left',
              borderLeft: '3px solid #3498db', width: '100%', opacity: loading ? 0.6 : 1,
              transition: 'all 0.2s',
            }}>
            <span style={{ fontSize: '1.6rem', minWidth: '2rem', textAlign: 'center' }}>💊</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, color: colors.text, fontSize: '0.92rem' }}>
                Full Recovery
              </div>
              <div style={{ color: colors.textSec, fontSize: '0.78rem', marginTop: '0.1rem' }}>
                Complete health restoration · Health → 100
              </div>
            </div>
            <div style={{
              background: isMinor ? 'rgba(46,204,113,0.2)' : 'rgba(255,255,255,0.08)',
              borderRadius: '10px', padding: '0.3rem 0.65rem',
              color: isMinor ? '#2ecc71' : colors.text, fontWeight: 700, fontSize: '0.85rem',
              whiteSpace: 'nowrap',
            }}>
              {isMinor ? 'FREE' : '$500'}
            </div>
          </button>

          {/* Treat Disease — only if active diseases exist */}
          {hasDiseases && (
            <button onClick={() => goToDoctor('treatment')} disabled={loading}
              style={{
                display: 'flex', alignItems: 'center', gap: '0.9rem',
                padding: '0.85rem 1rem', borderRadius: '14px', border: 'none',
                background: theme === 'dark' ? 'rgba(231,76,60,0.15)' : 'rgba(231,76,60,0.08)',
                cursor: loading ? 'not-allowed' : 'pointer', textAlign: 'left',
                borderLeft: '3px solid #e74c3c', width: '100%', opacity: loading ? 0.6 : 1,
                transition: 'all 0.2s',
              }}>
              <span style={{ fontSize: '1.6rem', minWidth: '2rem', textAlign: 'center' }}>🔬</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700, color: colors.text, fontSize: '0.92rem' }}>
                  Disease Treatment
                </div>
                <div style={{ color: colors.textSec, fontSize: '0.78rem', marginTop: '0.1rem' }}>
                  Treats worst active condition · Major health restore
                </div>
              </div>
              <div style={{
                background: isMinor ? 'rgba(46,204,113,0.2)' : 'rgba(231,76,60,0.15)',
                borderRadius: '10px', padding: '0.3rem 0.65rem',
                color: isMinor ? '#2ecc71' : '#e74c3c', fontWeight: 700, fontSize: '0.85rem',
                whiteSpace: 'nowrap',
              }}>
                {isMinor ? 'FREE' : '$5,000'}
              </div>
            </button>
          )}
        </div>
      </div>

      <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
      <div className="card-title">🎯 {t('activities')}</div>
      <div className="items-grid">
        {gameData?.activities?.filter(a => character.age >= (a.minAge || 0)).map(a => (
          <button key={a.name} className="grid-item" style={{ color: colors.text }}
            onClick={() => doActivity(a.name)} disabled={loading || (a.cost || 0) > character.money}>
            <span className="grid-item-icon">{a.emoji}</span>
            <div className="grid-item-name">{a.name}</div>
            {a.cost > 0 && <div className="grid-item-price">${a.cost}</div>}
          </button>
        ))}
      </div>
      <p className="swipe-hint" style={{ color: colors.textMuted }}>← Swipe for more →</p>
    </div>
    </div>
  );
  };


  const [shopCategory, setShopCategory] = useState('luxury');

  const renderShoppingTab = () => {
    const luxuryBrands = gameData?.items?.luxury_fashion || {};
    const brandNames = Object.keys(luxuryBrands);
    const categories = [
      { id: 'luxury', icon: '👗', label: 'Luxury Fashion' },
      { id: 'vehicles', icon: '🚗', label: 'Vehicles' },
      { id: 'houses', icon: '🏠', label: 'Real Estate' },
      { id: 'furniture', icon: '🛋️', label: 'Home Decor' },
      { id: 'clothes', icon: '👔', label: 'Clothes' },
      { id: 'accessories', icon: '💎', label: 'Accessories' },
      { id: 'pets', icon: '🐾', label: 'Pet Shop' },
    ];

    return (
      <div>
        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          <div className="card-title" data-testid="shopping-tab-title">🛍️ Shopping Mall</div>
          <p style={{ textAlign: 'center', color: colors.success, fontSize: '1.1rem', fontWeight: 700, marginBottom: '1rem' }}>
            💰 ${(character.money || 0).toLocaleString()}
          </p>

          {/* Category Tabs */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem', marginBottom: '1rem' }}>
            {categories.map(cat => (
              <button key={cat.id} data-testid={`shop-cat-${cat.id}`}
                className={`creator-option ${shopCategory === cat.id ? 'selected' : ''}`}
                style={{ color: colors.text, fontSize: '0.8rem', padding: '0.4rem 0.7rem' }}
                onClick={() => setShopCategory(cat.id)}>
                {cat.icon} {cat.label}
              </button>
            ))}
          </div>
        </div>

        {/* Luxury Fashion Brands */}
        {shopCategory === 'luxury' && (
          <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
            <div className="card-title" data-testid="luxury-section">👗 Luxury Fashion</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '1rem' }}>
              {brandNames.map(brand => (
                <button key={brand} data-testid={`brand-${brand.replace(/\s/g,'-')}`}
                  className={`creator-option ${selectedBrand === brand ? 'selected' : ''}`}
                  style={{ color: colors.text, padding: '0.5rem 0.75rem', fontWeight: 600 }}
                  onClick={() => setSelectedBrand(selectedBrand === brand ? null : brand)}>
                  {brand}
                </button>
              ))}
            </div>
            {selectedBrand && luxuryBrands[selectedBrand] && (
              <div className="items-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
                {luxuryBrands[selectedBrand].map(item => (
                  <button key={item.name} className="grid-item premium-item" style={{ color: colors.text }}
                    data-testid={`buy-${item.name.replace(/\s/g,'-')}`}
                    onClick={() => buyLuxury(selectedBrand, item.name)}
                    disabled={loading || item.price > character.money}>
                    <span style={{ fontSize: '2rem', display: 'block', marginBottom: '0.3rem' }}>{item.emoji}</span>
                    <div style={{ fontSize: '0.8rem', fontWeight: 600 }}>{item.name}</div>
                    <div style={{ color: colors.success, fontWeight: 700 }}>${item.price.toLocaleString()}</div>
                  </button>
                ))}
              </div>
            )}
            {!selectedBrand && <p style={{ textAlign: 'center', color: colors.textMuted }}>Select a brand above</p>}
          </div>
        )}

        {/* Vehicles */}
        {shopCategory === 'vehicles' && (
          <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
            <div className="card-title">🚗 Vehicles</div>
            <div className="items-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
              {gameData?.items?.vehicles?.map(item => (
                <button key={item.name} className="grid-item premium-item" style={{ color: colors.text }}
                  data-testid={`buy-vehicle-${item.name.replace(/\s/g,'-')}`}
                  onClick={() => buyItem('vehicles', item.name)}
                  disabled={loading || item.price > character.money}>
                  <span style={{ fontSize: '2rem', display: 'block', marginBottom: '0.3rem' }}>{item.emoji}</span>
                  <div style={{ fontSize: '0.8rem', fontWeight: 600 }}>{item.name}</div>
                  <div style={{ color: colors.success, fontWeight: 700 }}>${item.price.toLocaleString()}</div>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Real Estate */}
        {shopCategory === 'houses' && (
          <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
            <div className="card-title">🏠 Real Estate</div>
            <div className="items-grid" style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
              {gameData?.items?.houses?.map(item => (
                <button key={item.name} className="grid-item premium-item" style={{ color: colors.text, minHeight: '120px' }}
                  data-testid={`buy-house-${item.name.replace(/\s/g,'-')}`}
                  onClick={() => buyItem('houses', item.name)}
                  disabled={loading || item.price > character.money}>
                  <span style={{ fontSize: '2.5rem', display: 'block', marginBottom: '0.3rem' }}>{item.emoji}</span>
                  <div style={{ fontSize: '0.85rem', fontWeight: 600 }}>{item.name}</div>
                  <div style={{ color: colors.success, fontWeight: 700, fontSize: '1rem' }}>${item.price.toLocaleString()}</div>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Home Decor / Furniture */}
        {shopCategory === 'furniture' && (
          <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
            <div className="card-title">🛋️ Home Decor & Furniture</div>
            <div className="items-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
              {gameData?.items?.furniture?.map(item => (
                <button key={item.name} className="grid-item premium-item" style={{ color: colors.text }}
                  data-testid={`buy-furn-${item.name.replace(/\s/g,'-')}`}
                  onClick={() => buyItem('furniture', item.name)}
                  disabled={loading || item.price > character.money}>
                  <span style={{ fontSize: '2rem', display: 'block', marginBottom: '0.3rem' }}>{item.emoji}</span>
                  <div style={{ fontSize: '0.8rem', fontWeight: 600 }}>{item.name}</div>
                  <div style={{ color: colors.success, fontWeight: 700 }}>${item.price.toLocaleString()}</div>
                  <div style={{ fontSize: '0.7rem', color: colors.textMuted }}>{item.room}</div>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Clothes */}
        {shopCategory === 'clothes' && (
          <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
            <div className="card-title">👔 Clothes</div>
            <div className="items-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
              {gameData?.items?.clothes?.map(item => (
                <button key={item.name} className="grid-item premium-item" style={{ color: colors.text }}
                  onClick={() => buyItem('clothes', item.name)}
                  disabled={loading || item.price > character.money}>
                  <span style={{ fontSize: '2rem', display: 'block', marginBottom: '0.3rem' }}>{item.emoji}</span>
                  <div style={{ fontSize: '0.8rem', fontWeight: 600 }}>{item.name}</div>
                  <div style={{ color: colors.success, fontWeight: 700 }}>${item.price.toLocaleString()}</div>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Accessories */}
        {shopCategory === 'accessories' && (
          <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
            <div className="card-title">💎 Accessories</div>
            <div className="items-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
              {gameData?.items?.accessories?.map(item => (
                <button key={item.name} className="grid-item premium-item" style={{ color: colors.text }}
                  onClick={() => buyItem('accessories', item.name)}
                  disabled={loading || item.price > character.money}>
                  <span style={{ fontSize: '2rem', display: 'block', marginBottom: '0.3rem' }}>{item.emoji}</span>
                  <div style={{ fontSize: '0.8rem', fontWeight: 600 }}>{item.name}</div>
                  <div style={{ color: colors.success, fontWeight: 700 }}>${item.price.toLocaleString()}</div>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Pet Shop */}
        {shopCategory === 'pets' && (
          <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
            <div className="card-title">🐾 Pet Shop</div>
            <div className="items-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
              {gameData?.items?.pets?.map(item => (
                <button key={item.name} className="grid-item premium-item" style={{ color: colors.text }}
                  data-testid={`buy-pet-${item.name.replace(/\s/g,'-')}`}
                  onClick={async () => {
                    if (loading || item.price > character.money) return;
                    setLoading(true);
                    try {
                      const r = await fetch(`${API_URL}/api/character/${character.id}/buy-pet`, {
                        method: 'POST', headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ pet_type: item.name }),
                      });
                      if (r.ok) {
                        const d = await r.json();
                        setCharacter(d.character);
                        playSound('success');
                        notify(`Adopted a ${item.name}!`, 'success');
                      } else {
                        const err = await r.json();
                        notify(err.detail || 'Failed', 'error');
                      }
                    } catch (e) { notify('Error', 'error'); }
                    setLoading(false);
                  }}
                  disabled={loading || item.price > character.money}>
                  <span style={{ fontSize: '2rem', display: 'block', marginBottom: '0.3rem' }}>{item.emoji}</span>
                  <div style={{ fontSize: '0.8rem', fontWeight: 600 }}>{item.name}</div>
                  <div style={{ color: colors.success, fontWeight: 700 }}>${item.price.toLocaleString()}</div>
                  <div style={{ fontSize: '0.7rem', color: colors.textMuted }}>${item.maintenance}/yr</div>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };


  const renderFamilyTab = () => {
    const parents = character.relationships?.filter(r => ['Father', 'Mother'].includes(r.relation)) || [];
    const siblings = character.relationships?.filter(r => ['Brother', 'Sister'].includes(r.relation)) || [];

    return (
      <div>
        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          <div className="card-title">👨‍👩‍👧 {t('parents')}</div>
          {parents.length === 0 ? <p style={{ color: colors.textMuted }}>No parents</p> :
            parents.map(p => (
              <div key={p.id} className={`person-card ${!p.is_alive ? 'deceased' : ''}`}
                onClick={() => p.is_alive && (setModalData(p), setModal('family-interact'))}>
                <span className="person-avatar">{p.emoji}</span>
                <div className="person-info">
                  <div className="person-name">{p.name} {!p.is_alive && '💀'}</div>
                  <div className="person-detail" style={{ color: colors.textSec }}>{p.relation} • {t('age')} {p.age}</div>
                  {p.job && <div className="person-detail" style={{ color: colors.textMuted }}>{p.job}</div>}
                  <div className="affection-bar"><div className="affection-fill" style={{ width: `${p.affection || 50}%` }} /></div>
                </div>
                {p.is_alive && <span className="tap-hint">Tap</span>}
              </div>
            ))}
        </div>

        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          <div className="card-title">👫 {t('siblings')}</div>
          {siblings.length === 0 ? <p style={{ color: colors.textMuted }}>No siblings</p> :
            siblings.map(s => (
              <div key={s.id} className={`person-card ${!s.is_alive ? 'deceased' : ''}`}
                onClick={() => s.is_alive && (setModalData(s), setModal('family-interact'))}>
                <span className="person-avatar">{s.emoji}</span>
                <div className="person-info">
                  <div className="person-name">{s.name} {!s.is_alive && '💀'}</div>
                  <div className="person-detail" style={{ color: colors.textSec }}>{s.relation} • {t('age')} {s.age}</div>
                  <div className="affection-bar"><div className="affection-fill" style={{ width: `${s.affection || 50}%` }} /></div>
                </div>
                {s.is_alive && <span className="tap-hint">Tap</span>}
              </div>
            ))}
        </div>

        {character.partners?.length > 0 && (
          <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
            <div className="card-title">💕 {t('partner')}</div>
            {character.partners.map(p => (
              <div key={p.id} className="person-card" onClick={() => (setModalData(p), setModal('partner-interact'))}>
                <span className="person-avatar">{p.emoji}</span>
                <div className="person-info">
                  <div className="person-name">{p.name}</div>
                  <div className="person-detail" style={{ color: colors.primary }}>
                    {p.status === 'married' ? `💒 ${t('married')}` : p.status === 'engaged' ? `💍 ${t('engaged')}` : `💕 ${t('dating')}`}
                  </div>
                  <div className="person-detail" style={{ color: colors.textSec }}>{t('age')} {p.age}</div>
                </div>
                <span className="tap-hint">Tap</span>
              </div>
            ))}
          </div>
        )}

        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          <div className="card-title">👶 {t('children')}</div>
          {(character.children?.length || 0) === 0 ? <p style={{ color: colors.textMuted }}>No children yet</p> :
            character.children.map(c => (
              <div key={c.id} className="person-card">
                <span className="person-avatar">{c.emoji || '👶'}</span>
                <div className="person-info">
                  <div className="person-name">{c.name}</div>
                  <div className="person-detail" style={{ color: colors.textSec }}>{t('age')} {c.age}</div>
                  {c.health && <div className="person-detail" style={{ color: colors.textMuted }}>❤️ {c.health} · 😊 {c.happiness}</div>}
                  <div className="affection-bar">
                    <div className="affection-fill" style={{ width: `${c.affection || 70}%` }} />
                  </div>
                </div>
                <button style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.2rem' }}
                  onClick={() => switchToChild(c.id)} title="Play as child">▶️</button>
              </div>
            ))}
          {/* Have Child / Adopt buttons */}
          <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.75rem', flexWrap: 'wrap' }}>
            {character.partners?.length > 0 && character.age >= 18 && (
              <button className="primary-btn" style={{ background: colors.primary, flex: 1, padding: '0.6rem' }}
                onClick={haveChild} disabled={loading}>
                👶 {t('have_baby')}
              </button>
            )}
            {character.age >= 21 && (
              <button className="primary-btn" style={{ background: colors.secondary, flex: 1, padding: '0.6rem' }}
                onClick={adoptChild} disabled={loading}>
                🏠 {t('adopt')}
              </button>
            )}
          </div>
        </div>

        {/* ---- end children card ---- */}
      </div>
    );
  };

  const renderSchoolTab = () => {
    if (!character.in_school) {
      return (
        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          <div className="card-title">🏫 {t('school')}</div>
          <p style={{ color: colors.textMuted }}>
            {character.age < 5 ? t('too_young') : character.age >= 18 ? t('graduated') : 'Not in school'}
          </p>
        </div>
      );
    }

    return (
      <div>
        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          <div className="card-title">🏫 {character.school_type}</div>
          <p style={{ color: colors.textSec }}>{character.school_grade}</p>
        </div>

        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          <div className="card-title">🎒 {t('classmates')} ({character.classmates?.length || 0})</div>
          <div className="classmates-grid">
            {character.classmates?.map(c => (
              <div key={c.id} className="classmate-item" style={{ color: colors.text }}
                onClick={() => (setModalData(c), setModal('classmate-interact'))}>
                <span className="classmate-avatar">{c.emoji}</span>
                <span className="classmate-name">{c.name.split(' ')[0]}</span>
                {c.is_crush && <span className="classmate-badge" style={{ color: colors.primary }}>💕</span>}
                {c.is_bully && <span className="classmate-badge" style={{ color: colors.error }}>😈</span>}
              </div>
            ))}
          </div>
        </div>

        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          <div className="card-title">👩‍🏫 {t('teachers')} ({character.teachers?.length || 0})</div>
          <div className="teachers-list">
            {character.teachers?.map(t => (
              <div key={t.id} className="teacher-item" style={{ color: colors.text }}
                onClick={() => (setModalData(t), setModal('teacher-interact'))}>
                <span className="teacher-avatar">{t.emoji}</span>
                <div className="teacher-info">
                  <div className="teacher-name">{t.name}</div>
                  <div className="teacher-subject" style={{ color: colors.textSec }}>{t.subject}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const renderWorkTab = () => {
    if (character.is_royal) {
      return (
        <div>
          <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,215,0,0.07)' : 'rgba(255,215,0,0.05)', border: `1.5px solid ${colors.gold}44`, textAlign: 'center', padding: '2rem' }}>
            <div style={{ fontSize: '3rem', marginBottom: '0.75rem' }}>👑</div>
            <div style={{ fontWeight: 700, fontSize: '1.1rem', color: colors.gold, marginBottom: '0.5rem' }}>{character.royal_title}</div>
            <p style={{ color: colors.textSec, marginBottom: '1.25rem' }}>{t('royalty_no_job')}</p>
            <div className="card-title" style={{ color: colors.gold, marginBottom: '0.75rem' }}>{t('royalty_actions')}</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
              {[
                { icon: '👑', key: 'abdicate', action: 'abdicate_throne', desc: { EN: 'Give up the crown. Lose royal status but gain freedom.', ES: 'Renuncia a la corona. Pierde el estatus real pero gana libertad.', RO: 'Renunță la coroană. Pierzi statutul regal dar câștigi libertatea.' } },
                { icon: '🎉', key: 'hold_royal_ball', action: 'royal_ball', desc: { EN: '+15 Happiness, +10 Looks. Costs $50,000.', ES: '+15 Felicidad, +10 Apariencia. Cuesta $50.000.', RO: '+15 Fericire, +10 Aspect. Costă $50.000.' } },
                { icon: '📜', key: 'execute_law', action: 'execute_law', desc: { EN: '+20 Smarts, +5 Karma. Shape the kingdom.', ES: '+20 Inteligencia, +5 Karma. Moldea el reino.', RO: '+20 Inteligență, +5 Karma. Modelează regatul.' } },
              ].map(ra => (
                <button key={ra.key} style={{
                  padding: '0.85rem 1rem', borderRadius: '12px', border: `1.5px solid ${colors.gold}44`,
                  background: `linear-gradient(135deg, ${colors.gold}18, ${colors.gold}08)`,
                  cursor: 'pointer', textAlign: 'left', display: 'flex', gap: '0.75rem', alignItems: 'flex-start'
                }}
                  onClick={() => {
                    if (ra.key === 'abdicate') {
                      setCharacter(prev => ({ ...prev, is_royal: false, royal_title: null }));
                      notify('You abdicated the throne.', 'info');
                    } else if (ra.key === 'hold_royal_ball') {
                      if ((character.money || 0) < 50000) { notify('Need $50,000!', 'error'); return; }
                      setCharacter(prev => ({ ...prev, money: prev.money - 50000, happiness: Math.min(100, (prev.happiness || 50) + 15), looks: Math.min(100, (prev.looks || 50) + 10) }));
                      notify('🎉 Royal Ball was a success! +15 Happiness, +10 Looks', 'success');
                      playSound('success');
                    } else if (ra.key === 'execute_law') {
                      setCharacter(prev => ({ ...prev, smarts: Math.min(100, (prev.smarts || 50) + 20), karma: Math.min(100, (prev.karma || 50) + 5) }));
                      notify('📜 New law executed! +20 Smarts, +5 Karma', 'success');
                      playSound('success');
                    }
                  }}
                  disabled={loading}>
                  <span style={{ fontSize: '1.5rem' }}>{ra.icon}</span>
                  <div>
                    <div style={{ fontWeight: 700, color: colors.gold, marginBottom: '0.2rem' }}>{t(ra.key)}</div>
                    <div style={{ fontSize: '0.82rem', color: colors.textSec }}>{ra.desc[lang] || ra.desc.EN}</div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      );
    }
    return (
      <>
        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          <div className="card-title">💼 {t('current_job')}</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem', background: 'rgba(255,255,255,0.05)', borderRadius: '12px' }}>
            <span style={{ fontWeight: 700 }}>{character.job}</span>
            {character.salary > 0 && <span style={{ color: colors.success }}>${character.salary.toLocaleString()}/yr</span>}
          </div>
        </div>

        {character.age >= 16 && (
          <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
            <div className="card-title">🔍 {t('jobs')}</div>
            <div className="items-grid">
              {gameData?.jobs?.filter(j => j.title !== 'Unemployed' && character.age >= j.minAge).slice(0, 15).map(j => (
                <button key={j.title} className="grid-item" style={{ color: colors.text }}
                  onClick={() => applyJob(j.title)} disabled={loading}>
                  <span className="grid-item-icon">{j.emoji}</span>
                  <div className="grid-item-name">{j.title}</div>
                  <div className="grid-item-price">${j.salary.toLocaleString()}/yr</div>
                  <div className="grid-item-info">{j.minSmarts > 0 && `${j.minSmarts} IQ`}</div>
                </button>
              ))}
            </div>
          </div>
        )}
      </>
  );
  };

  const renderLoveTab = () => (
    <div>
      <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
        <div className="card-title">💕 {t('relationship')}</div>
        {(character.partners?.length || 0) === 0 ? (
          <p style={{ color: colors.textMuted }}>{t('single')}</p>
        ) : character.partners.map(p => (
          <div key={p.id} className="person-card" onClick={() => (setModalData(p), setModal('partner-interact'))}>
            <span className="person-avatar">{p.emoji}</span>
            <div className="person-info">
              <div className="person-name">{p.name}</div>
              <div className="person-detail" style={{ color: colors.primary }}>
                {p.status === 'married' ? `💒 ${t('married')}` : p.status === 'engaged' ? `💍 ${t('engaged')}` : `💕 ${t('dating')}`}
              </div>
            </div>
          </div>
        ))}
      </div>

      {character.age >= 12 && (character.partners?.length || 0) === 0 && (
        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          <div className="card-title">💘 {t('dating_apps')}</div>
          <div className="dating-apps-grid">
            {[
              { name: 'Tinder', icon: '🔥', color: '#fe3c72' },
              { name: 'Bumble', icon: '🐝', color: '#ffc629' },
              { name: 'Hinge', icon: '💕', color: '#e94057' },
              { name: 'Instagram', icon: '📸', color: '#c13584' },
              { name: 'Grindr', icon: '🏳️‍🌈', color: '#f8c630' },
              { name: 'HER', icon: '💜', color: '#d63384' },
            ].map(app => (
              <button key={app.name} className="dating-app-btn" onClick={() => findDate()}>
                <span className="dating-app-icon" style={{ background: app.color, padding: '0.5rem', borderRadius: '12px' }}>{app.icon}</span>
                <span className="dating-app-name" style={{ color: colors.text }}>{app.name}</span>
              </button>
            ))}
          </div>
        </div>
      )}

      {character.partners?.length > 0 && character.age >= 18 && (
        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          <div className="card-title">👶 Family Planning</div>
          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
            <button className="primary-btn" style={{ background: colors.primary, flex: 1 }}
              onClick={haveChild} disabled={loading}>
              👶 {t('have_baby')}
            </button>
            {character.age >= 21 && (
              <button className="primary-btn" style={{ background: colors.secondary, flex: 1 }}
                onClick={adoptChild} disabled={loading}>
                🏠 {t('adopt')}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );

  const renderAssetsTab = () => (
    <div>
      <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
        <div className="card-title">🏠 {t('properties')}</div>
        {(character.houses?.length || 0) === 0 ? <p style={{ color: colors.textMuted }}>None</p> :
          character.houses.map((h, i) => (
            <div key={i} style={{ display: 'flex', gap: '0.75rem', padding: '0.75rem', background: 'rgba(255,255,255,0.05)', borderRadius: '10px', marginBottom: '0.5rem' }}>
              <span style={{ fontSize: '1.5rem' }}>{h.emoji}</span>
              <span style={{ color: colors.text }}>{h.name}</span>
            </div>
          ))}
        <button className="primary-btn" data-testid="buy-house-btn" style={{ background: colors.primary, marginTop: '0.75rem' }}
          onClick={() => setModal('buy-house')}>🏠 {t('buy')}</button>
      </div>

      {/* Home Decoration */}
      {character.houses?.length > 0 && (
        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          <div className="card-title" data-testid="home-decor-title">🎨 Home Decoration</div>
          <div className="home-view-tabs" style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
            {['overview', 'interior', 'exterior'].map(v => (
              <button key={v} className={`creator-option ${homeView === v ? 'selected' : ''}`}
                data-testid={`home-view-${v}`}
                style={{ color: colors.text, flex: 1, textTransform: 'capitalize' }}
                onClick={() => setHomeView(v)}>
                {v === 'overview' ? '🏠' : v === 'interior' ? '🛋️' : '🌳'} {v}
              </button>
            ))}
          </div>

          {homeView === 'overview' && (
            <div style={{ textAlign: 'center', padding: '0.5rem' }}>
              <div style={{ fontSize: '4rem', marginBottom: '0.5rem' }}>{character.houses[character.houses.length - 1]?.emoji || '🏠'}</div>
              <div style={{ fontWeight: 700, fontSize: '1.1rem', marginBottom: '1rem' }}>{character.houses[character.houses.length - 1]?.name || 'Your Home'}</div>

              {/* Visual furniture display */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.75rem', padding: '0.5rem' }}>
                {character.furniture?.map((f, i) => (
                  <div key={i} style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                    padding: '0.75rem', background: `${colors.primary}15`, borderRadius: '16px',
                    border: `1px solid ${colors.primary}30`, minHeight: '80px',
                  }}>
                    <span style={{ fontSize: '2rem', marginBottom: '0.25rem' }}>{f.emoji}</span>
                    <span style={{ fontSize: '0.7rem', color: colors.textSec, textAlign: 'center' }}>{f.name}</span>
                  </div>
                ))}
                {(!character.furniture || character.furniture.length === 0) && (
                  <div style={{ gridColumn: 'span 4', padding: '2rem', textAlign: 'center' }}>
                    <span style={{ fontSize: '3rem', display: 'block', marginBottom: '0.5rem' }}>🏗️</span>
                    <p style={{ color: colors.textMuted }}>Your home is empty! Buy furniture to decorate.</p>
                  </div>
                )}
              </div>
              <button className="primary-btn" style={{ background: colors.primary, marginTop: '1rem' }}
                onClick={() => setModal('in-game-shop')}>🛍️ Shop for Furniture</button>
            </div>
          )}

          {homeView === 'interior' && (
            <div>
              {/* Visual room grid with large icons */}
              {[
                { id: 'living', name: 'Living Room', icon: '🛋️', bg: '#ff69b422' },
                { id: 'bedroom', name: 'Bedroom', icon: '🛏️', bg: '#9b59b622' },
                { id: 'kitchen', name: 'Kitchen', icon: '🍳', bg: '#e67e2222' },
                { id: 'interior', name: 'Other Rooms', icon: '🏠', bg: '#3498db22' },
              ].map(room => {
                const roomItems = character.furniture?.filter(f => {
                  const fData = gameData?.items?.furniture?.find(fd => fd.name === f.name);
                  return fData?.room === room.id;
                }) || [];
                return (
                  <div key={room.id} style={{
                    padding: '1rem', background: room.bg, borderRadius: '16px', marginBottom: '0.75rem',
                    border: `1px solid ${colors.primary}20`,
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.75rem' }}>
                      <span style={{ fontSize: '1.5rem' }}>{room.icon}</span>
                      <span style={{ fontWeight: 700, color: colors.text }}>{room.name}</span>
                      <span style={{ fontSize: '0.8rem', color: colors.textMuted, marginLeft: 'auto' }}>{roomItems.length} items</span>
                    </div>
                    {roomItems.length === 0 ? (
                      <div style={{ padding: '1rem', textAlign: 'center', border: `2px dashed ${colors.textMuted}44`, borderRadius: '12px' }}>
                        <span style={{ fontSize: '1.5rem' }}>📦</span>
                        <p style={{ color: colors.textMuted, fontSize: '0.85rem', margin: '0.25rem 0 0' }}>Empty room</p>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                        {roomItems.map((f, i) => (
                          <div key={i} style={{
                            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                            padding: '0.6rem', background: 'rgba(255,255,255,0.15)', borderRadius: '12px', minWidth: '70px',
                          }}>
                            <span style={{ fontSize: '1.8rem' }}>{f.emoji}</span>
                            <span style={{ fontSize: '0.7rem', color: colors.textSec }}>{f.name}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
              <button className="primary-btn" style={{ background: colors.secondary, marginTop: '0.25rem' }}
                onClick={() => setModal('in-game-shop')}>🛍️ Buy Furniture</button>
            </div>
          )}

          {homeView === 'exterior' && (
            <div>
              <div style={{
                padding: '1.5rem', background: `linear-gradient(180deg, #87ceeb33 0%, #90ee9033 100%)`,
                borderRadius: '16px', marginBottom: '0.75rem', border: `1px solid ${colors.primary}20`,
                minHeight: '150px', position: 'relative', textAlign: 'center',
              }}>
                <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>{character.houses[character.houses.length - 1]?.emoji || '🏡'}</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem', justifyContent: 'center', marginTop: '0.75rem' }}>
                  {(character.furniture?.filter(f => {
                    const fData = gameData?.items?.furniture?.find(fd => fd.name === f.name);
                    return fData?.room === 'exterior';
                  }) || []).map((f, i) => (
                    <div key={i} style={{
                      display: 'flex', flexDirection: 'column', alignItems: 'center',
                      padding: '0.75rem', background: 'rgba(255,255,255,0.3)', borderRadius: '14px',
                      backdropFilter: 'blur(8px)', minWidth: '80px',
                    }}>
                      <span style={{ fontSize: '2rem' }}>{f.emoji}</span>
                      <span style={{ fontSize: '0.75rem', color: colors.text }}>{f.name}</span>
                    </div>
                  ))}
                  {(!character.furniture?.some(f => {
                    const fData = gameData?.items?.furniture?.find(fd => fd.name === f.name);
                    return fData?.room === 'exterior';
                  })) && (
                    <div style={{ padding: '1rem', textAlign: 'center' }}>
                      <span style={{ fontSize: '2rem', display: 'block' }}>🌿</span>
                      <p style={{ color: colors.textMuted, fontSize: '0.85rem' }}>Empty yard - add a pool, garden, or terrace!</p>
                    </div>
                  )}
                </div>
              </div>
              <button className="primary-btn" style={{ background: colors.secondary }}
                onClick={() => setModal('in-game-shop')}>🌳 Buy Exterior Items</button>
            </div>
          )}
        </div>
      )}

      {/* Driver's License */}
      {character.age >= 16 && !character.has_license && (
        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          <div className="card-title">🚗 {t('drivers_license')}</div>
          <p style={{ color: colors.textSec, marginBottom: '0.75rem' }}>
            Take the driving test to get your license! (Attempt #{(character.license_attempts || 0) + 1})
          </p>
          <button className="primary-btn" data-testid="take-driver-test" style={{ background: colors.primary }}
            onClick={startDriverTest}>
            📝 {t('take_test')}
          </button>
        </div>
      )}

      <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
        <div className="card-title">🚗 {t('vehicles')}</div>
        {(character.vehicles?.length || 0) === 0 ? <p style={{ color: colors.textMuted }}>None</p> :
          character.vehicles.map((v, i) => (
            <div key={i} style={{ display: 'flex', gap: '0.75rem', padding: '0.75rem', background: 'rgba(255,255,255,0.05)', borderRadius: '10px', marginBottom: '0.5rem' }}>
              <span style={{ fontSize: '1.5rem' }}>{v.emoji}</span>
              <span style={{ color: colors.text }}>{v.name}</span>
            </div>
          ))}
        <button className="primary-btn" data-testid="buy-vehicle-btn" style={{ background: colors.primary, marginTop: '0.75rem' }}
          onClick={() => setModal('buy-vehicle')}>🚗 {t('buy')}</button>
      </div>

      <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
        <div className="card-title">🐾 {t('pets')}</div>
        {(character.pets?.length || 0) === 0 ? <p style={{ color: colors.textMuted }}>None</p> :
          character.pets.map((p, i) => (
            <div key={i} style={{ display: 'flex', gap: '0.75rem', padding: '0.75rem', background: 'rgba(255,255,255,0.05)', borderRadius: '10px', marginBottom: '0.5rem' }}>
              <span style={{ fontSize: '1.5rem' }}>{p.emoji}</span>
              <span style={{ color: colors.text }}>{p.name} ({p.type})</span>
            </div>
          ))}
        <button className="primary-btn" data-testid="adopt-pet-btn" style={{ background: colors.primary, marginTop: '0.75rem' }}
          onClick={() => setModal('adopt-pet')}>🐾 {t('adopt')}</button>
      </div>

      {/* Wardrobe */}
      {(character.clothes?.length > 0 || character.accessories?.length > 0) && (
        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          <div className="card-title" data-testid="wardrobe-title">👗 Wardrobe</div>
          {character.clothes?.map((c, i) => (
            <div key={`c-${i}`} style={{ display: 'flex', gap: '0.75rem', padding: '0.5rem', background: 'rgba(255,255,255,0.05)', borderRadius: '8px', marginBottom: '0.25rem', justifyContent: 'space-between' }}>
              <span>{c.emoji} {c.name}</span>
              {c.brand && <span style={{ color: colors.primary, fontSize: '0.85rem' }}>{c.brand}</span>}
            </div>
          ))}
          {character.accessories?.map((a, i) => (
            <div key={`a-${i}`} style={{ display: 'flex', gap: '0.75rem', padding: '0.5rem', background: 'rgba(255,255,255,0.05)', borderRadius: '8px', marginBottom: '0.25rem' }}>
              <span>{a.emoji} {a.name}</span>
            </div>
          ))}
        </div>
      )}

      {character.stolen_items?.length > 0 && (
        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,71,87,0.1)' : 'rgba(255,71,87,0.05)' }}>
          <div className="card-title" style={{ color: colors.error }}>🦹 {t('stolen_items')}</div>
          {character.stolen_items.map((s, i) => (
            <div key={i} style={{ display: 'flex', gap: '0.75rem', padding: '0.75rem', background: 'rgba(255,255,255,0.05)', borderRadius: '10px', marginBottom: '0.5rem', justifyContent: 'space-between' }}>
              <span>{s.emoji} {s.name}</span>
              <span style={{ color: colors.success }}>${s.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );

  const renderWardrobeTab = () => {
    // Classify all owned clothes by layer type
    // Normalize accessories: legacy entries may be plain strings; convert to objects
    const normalizeAcc = (a) => {
      if (typeof a === 'string') {
        // Look up emoji from known accessories list
        const accMap = {
          'Sunglasses': '🕶️', 'Designer Sunglasses': '🕶️', 'Baseball Cap': '🧢',
          'Crown': '👑', 'Top Hat': '🎩', 'Earrings': '💎', 'Diamond Earrings': '💎',
          'Gold Chain': '📿', 'Diamond Necklace': '💍', 'Watch': '⌚',
          'Luxury Watch': '⌚', 'Ring': '💍', 'Diamond Ring': '💍',
        };
        return { name: a, emoji: accMap[a] || '💎', type: 'accessory' };
      }
      return a;
    };
    // Merge clothes + wardrobe (luxury fashion lands here) + accessories, deduping by name
    const seenNames = new Set();
    const allClothes = [
      ...(character.clothes || []),
      ...(character.wardrobe || []),  // luxury/fashion brand items
      ...(character.accessories || []).map(normalizeAcc),
    ].filter(item => {
      const key = item?.name;
      if (!key || seenNames.has(key)) return false;
      seenNames.add(key);
      return true;
    });
    const classify = (item) => {
      const n = (item.name || '').toLowerCase();
      const e = item.emoji || '';
      if (['👟','👠','👡','👢','🥿','👞','🥾'].some(x => e.includes(x)) || n.includes('shoe') || n.includes('heel') || n.includes('boot') || n.includes('sneaker')) return 'shoes';
      if (['👜','👛','🎒','💼'].some(x => e.includes(x)) || n.includes('bag') || n.includes('purse') || n.includes('handbag')) return 'bag';
      if (['🕶','👓','🧣','🎩','👒','💍','⌚','📿','🧤','🧢'].some(x => e.includes(x)) || n.includes('glass') || n.includes('hat') || n.includes('watch') || n.includes('necklace') || n.includes('ring') || n.includes('scarf') || n.includes('glove')) return 'accessory';
      return 'outfit';
    };
    const byLayer = { outfit: [], accessory: [], shoes: [], bag: [] };
    allClothes.forEach(item => { const cat = classify(item); byLayer[cat].push(item); });

    const layerLabels = { outfit: t('wardrobe_outfit'), accessory: t('wardrobe_accessory'), shoes: t('wardrobe_shoes'), bag: t('wardrobe_bag') };
    const layerIcons  = { outfit: '👗', accessory: '🕶️', shoes: '👠', bag: '👜' };

    // Build layered avatar display
    const getEquippedEmoji = (layer) => equippedItems[layer]?.emoji || '';

    return (
      <div>
        {/* Layered Avatar Preview */}
        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,105,180,0.08)' : 'rgba(255,105,180,0.04)', border: `1.5px solid ${colors.primary}33`, textAlign: 'center', padding: '1.5rem' }}>
          <div className="card-title" style={{ color: colors.primary }}>{t('your_look')}</div>
          {/* Layered avatar container */}
          <div style={{ position: 'relative', display: 'inline-block', width: 120, height: 160, margin: '0 auto 1rem' }}>
            {/* Base character emoji */}
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', fontSize: '5rem', zIndex: 1 }}>
              {character.emoji || '🧍'}
            </div>
            {/* Outfit layer */}
            {equippedItems.outfit && (
              <div style={{ position: 'absolute', bottom: 20, left: '50%', transform: 'translateX(-50%)', fontSize: '2.2rem', zIndex: 2 }}>
                {equippedItems.outfit.emoji}
              </div>
            )}
            {/* Accessory layer */}
            {equippedItems.accessory && (
              <div style={{ position: 'absolute', top: 4, left: '50%', transform: 'translateX(-50%)', fontSize: '1.6rem', zIndex: 3 }}>
                {equippedItems.accessory.emoji}
              </div>
            )}
            {/* Shoes layer */}
            {equippedItems.shoes && (
              <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', fontSize: '1.4rem', zIndex: 2 }}>
                {equippedItems.shoes.emoji}
              </div>
            )}
            {/* Bag layer */}
            {equippedItems.bag && (
              <div style={{ position: 'absolute', bottom: 30, right: 0, fontSize: '1.4rem', zIndex: 3 }}>
                {equippedItems.bag.emoji}
              </div>
            )}
            {/* Royal crown overlay */}
            {character.is_royal && (
              <div style={{ position: 'absolute', top: -10, left: '50%', transform: 'translateX(-50%)', fontSize: '1.8rem', zIndex: 4 }}>👑</div>
            )}
          </div>
          {/* Currently equipped summary */}
          <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            {Object.entries(equippedItems).map(([layer, item]) => item ? (
              <div key={layer} style={{ padding: '0.3rem 0.75rem', borderRadius: 20, background: `${colors.primary}22`, border: `1px solid ${colors.primary}44`, fontSize: '0.8rem', color: colors.primary }}>
                {item.emoji} {item.name}
              </div>
            ) : null)}
            {Object.values(equippedItems).every(v => !v) && (
              <p style={{ color: colors.textMuted, fontSize: '0.85rem' }}>Nothing equipped yet</p>
            )}
          </div>
        </div>

        {/* Layer Tabs */}
        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.75rem', overflowX: 'auto' }}>
          {['outfit', 'accessory', 'shoes', 'bag'].map(layer => (
            <button key={layer} onClick={() => setWardrobeTab(layer)}
              style={{
                padding: '0.5rem 0.9rem', borderRadius: 20, border: 'none', cursor: 'pointer', fontSize: '0.85rem', whiteSpace: 'nowrap',
                background: wardrobeTab === layer ? `linear-gradient(135deg, ${colors.primary}, ${colors.secondary})` : 'rgba(255,255,255,0.08)',
                color: wardrobeTab === layer ? '#fff' : colors.text, fontWeight: wardrobeTab === layer ? 700 : 400,
              }}>
              {layerIcons[layer]} {layerLabels[layer]}
              {equippedItems[layer] && ' ✓'}
            </button>
          ))}
        </div>

        {/* Items for current layer */}
        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          <div className="card-title">{layerIcons[wardrobeTab]} {layerLabels[wardrobeTab]}</div>
          {byLayer[wardrobeTab].length === 0 ? (
            <div style={{ textAlign: 'center', padding: '1.5rem 0' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>🛍️</div>
              <p style={{ color: colors.textMuted, fontSize: '0.9rem' }}>{t('no_clothes')}</p>
              <button className="primary-btn" style={{ background: colors.primary, marginTop: '0.75rem', display: 'inline-block' }}
                onClick={() => setModal('in-game-shop')}>
                🛍️ Go Shopping
              </button>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              {byLayer[wardrobeTab].map((item, i) => {
                const isEquipped = equippedItems[wardrobeTab]?.name === item.name;
                return (
                  <div key={i} style={{
                    display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.75rem 1rem',
                    borderRadius: 12, border: `1.5px solid ${isEquipped ? colors.primary : 'rgba(255,255,255,0.08)'}`,
                    background: isEquipped ? `${colors.primary}18` : 'rgba(255,255,255,0.04)',
                  }}>
                    <span style={{ fontSize: '1.8rem' }}>{item.emoji}</span>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 600, color: colors.text }}>{item.name}</div>
                      {item.brand && <div style={{ fontSize: '0.78rem', color: colors.primary }}>{item.brand}</div>}
                    </div>
                    {isEquipped ? (
                      <button onClick={() => setEquippedItems(prev => ({ ...prev, [wardrobeTab]: null }))}
                        style={{ padding: '0.4rem 0.9rem', borderRadius: 20, border: `1.5px solid ${colors.error}`, background: 'transparent', color: colors.error, cursor: 'pointer', fontSize: '0.82rem', fontWeight: 600 }}>
                        {t('unequip')}
                      </button>
                    ) : (
                      <button onClick={() => { setEquippedItems(prev => ({ ...prev, [wardrobeTab]: item })); playSound('click'); notify(`${item.emoji} ${item.name} equipped!`, 'success'); }}
                        style={{ padding: '0.4rem 0.9rem', borderRadius: 20, border: `1.5px solid ${colors.primary}`, background: `${colors.primary}22`, color: colors.primary, cursor: 'pointer', fontSize: '0.82rem', fontWeight: 600 }}>
                        {t('equip')}
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderCrimeTab = () => {
    // Criminal Ladder calculation
    const crimeCount = character.life_log?.filter(l => l.event?.toLowerCase().includes('crime') || l.event?.toLowerCase().includes('robbery') || l.event?.toLowerCase().includes('theft') || l.event?.toLowerCase().includes('dealing') || l.event?.toLowerCase().includes('murder')).length || 0;
    const getCrimeLadder = () => {
      if (crimeCount >= 30 || character.crime_rank === 'El Padre') return { rank: 'El Padre', emoji: '🎩', color: '#8b0000', next: null };
      if (crimeCount >= 20 || character.crime_rank === 'Mafia Boss') return { rank: 'Mafia Boss', emoji: '🕴️', color: '#4a0080', next: 'El Padre', needed: 30 };
      if (crimeCount >= 10 || character.crime_rank === 'Crime Lord') return { rank: 'Crime Lord', emoji: '💀', color: '#c0392b', next: 'Mafia Boss', needed: 20 };
      if (crimeCount >= 5) return { rank: 'Gangster', emoji: '🔫', color: '#e67e22', next: 'Crime Lord', needed: 10 };
      if (crimeCount >= 2) return { rank: 'Thug', emoji: '🪝', color: '#7f8c8d', next: 'Gangster', needed: 5 };
      return { rank: 'Civilian', emoji: '👤', color: '#95a5a6', next: 'Thug', needed: 2 };
    };
    const ladder = getCrimeLadder();
    const isMafia = ['Mafia Boss', 'El Padre'].includes(ladder.rank);

    // Build victim list from character's actual relationships
    const victims = [];
    victims.push({ name: 'Random Stranger', type: 'stranger', emoji: '👤' });
    victims.push({ name: 'Random Neighbor', type: 'neighbor', emoji: '🏘️' });
    if (character.parents) character.parents.forEach(p => victims.push({ name: p.name, type: 'family', emoji: '👨‍👩‍👧' }));
    if (character.siblings) character.siblings.forEach(s => victims.push({ name: s.name, type: 'family', emoji: '👫' }));
    if (character.partner) victims.push({ name: character.partner.name, type: 'partner', emoji: '💔' });
    if (character.classmates) character.classmates.slice(0, 5).forEach(c => victims.push({ name: c.name, type: 'classmate', emoji: '🎒' }));

    const selectedVictimName = crimeVictim ? crimeVictim.name : 'Random Stranger';

    return (
      <div>
        {/* Criminal Ladder Card */}
        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? `rgba(139,0,0,0.12)` : 'rgba(139,0,0,0.05)', border: `1.5px solid ${ladder.color}44`, marginBottom: '0.75rem' }}>
          <div className="card-title" style={{ color: ladder.color }}>{t('crime_ladder')}</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '0.5rem 0' }}>
            <span style={{ fontSize: '2.5rem' }}>{ladder.emoji}</span>
            <div>
              <div style={{ fontWeight: 800, fontSize: '1.15rem', color: ladder.color }}>{ladder.rank}</div>
              <div style={{ fontSize: '0.82rem', color: colors.textSec }}>{t('crime_rank')}: {crimeCount} crimes</div>
              {ladder.next && <div style={{ fontSize: '0.78rem', color: colors.textMuted }}>→ {ladder.next} at {ladder.needed} crimes</div>}
            </div>
          </div>
          {ladder.next && (
            <div style={{ height: 6, background: 'rgba(255,255,255,0.1)', borderRadius: 3, overflow: 'hidden', marginTop: '0.4rem' }}>
              <div style={{ height: '100%', background: ladder.color, borderRadius: 3, width: `${Math.min(100, (crimeCount / ladder.needed) * 100)}%`, transition: 'width 0.5s' }} />
            </div>
          )}
        </div>

        {/* Mafia Boss / El Padre Special Actions */}
        {isMafia && (
          <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(74,0,128,0.15)' : 'rgba(74,0,128,0.05)', border: `1.5px solid #4a008077`, marginBottom: '0.75rem' }}>
            <div className="card-title" style={{ color: '#9b59b6' }}>🕴️ {t('crime_lord_actions')}</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
              {[
                { icon: '🔫', key: 'order_hit', reward: 50000, karmaLoss: -20, desc: { EN: 'Send your crew after a rival. +$50,000 but -20 Karma.', ES: 'Manda a tu banda por un rival. +$50,000 pero -20 Karma.', RO: 'Trimite-ți banda după un rival. +$50.000 dar -20 Karma.' } },
                { icon: '💸', key: 'launder_money', reward: 30000, desc: { EN: 'Clean dirty money through your businesses. +$30,000.', ES: 'Lava dinero sucio por tus negocios. +$30.000.', RO: 'Spală bani murdari prin afacerile tale. +$30.000.' } },
                { icon: '🏪', key: 'extort_business', reward: 20000, desc: { EN: 'Make local shops pay protection. +$20,000.', ES: 'Haz que las tiendas locales paguen protección. +$20.000.', RO: 'Fă magazinele locale să plătească protecție. +$20.000.' } },
              ].map(ma => (
                <button key={ma.key} style={{
                  padding: '0.85rem 1rem', borderRadius: '12px', border: '1.5px solid #9b59b622',
                  background: 'linear-gradient(135deg, rgba(155,89,182,0.15), rgba(155,89,182,0.05))',
                  cursor: 'pointer', textAlign: 'left', display: 'flex', gap: '0.75rem', alignItems: 'flex-start'
                }} onClick={() => {
                  const gain = ma.reward + Math.floor(Math.random() * 10000);
                  setCharacter(prev => ({
                    ...prev,
                    money: (prev.money || 0) + gain,
                    karma: ma.karmaLoss ? Math.max(0, (prev.karma || 50) + ma.karmaLoss) : prev.karma,
                  }));
                  notify(`${ma.icon} +$${gain.toLocaleString()}${ma.karmaLoss ? ` (${ma.karmaLoss} Karma)` : ''}`, 'success');
                  playSound('money');
                }} disabled={loading}>
                  <span style={{ fontSize: '1.5rem' }}>{ma.icon}</span>
                  <div>
                    <div style={{ fontWeight: 700, color: '#9b59b6', marginBottom: '0.2rem' }}>{t(ma.key)}</div>
                    <div style={{ fontSize: '0.82rem', color: colors.textSec }}>{ma.desc[lang] || ma.desc.EN}</div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}

        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          <div className="card-title" data-testid="crime-title">🦹 {t('crime')}</div>

          {(character.in_prison || character.in_juvenile) ? (
            <div>
              <p style={{ textAlign: 'center', color: colors.error, marginBottom: '1rem' }}>
                🔒 {character.in_juvenile ? 'Juvenile Detention' : 'Prison'} - {character.prison_years?.toFixed(1)} years remaining
              </p>
              <button className="primary-btn" data-testid="escape-prison-btn"
                style={{ background: 'linear-gradient(135deg, #ff4757, #ff6b81)' }}
                onClick={startMazeEscape}>
                🏃 Attempt Escape (Maze)
              </button>
            </div>
          ) : (
            <>
              {/* Target Selection */}
              <div style={{ marginBottom: '1rem' }}>
                <p style={{ color: colors.textSec, marginBottom: '0.5rem', fontWeight: 600 }}>👤 Choose your victim:</p>
                <div className="target-toggle" style={{ flexWrap: 'wrap', gap: '0.4rem' }}>
                  {victims.map((v, i) => (
                    <button key={i} data-testid={`victim-${v.name.replace(/\s/g,'-')}`}
                      className={`target-btn ${(crimeVictim?.name === v.name || (!crimeVictim && v.type === 'stranger')) ? 'active' : ''}`}
                      style={{ color: colors.text, fontSize: '0.8rem', padding: '0.4rem 0.6rem' }}
                      onClick={() => {
                        setCrimeVictim(v);
                        setCrimeTarget(v.type === 'stranger' || v.type === 'neighbor' ? 'stranger' : 'family');
                      }}>
                      {v.emoji} {v.name}
                    </button>
                  ))}
                </div>
                <p style={{ color: colors.primary, fontSize: '0.85rem', marginTop: '0.5rem' }}>
                  Target: <strong>{selectedVictimName}</strong>
                </p>
              </div>

              {/* Crime Grid - Complex BitLife-style */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                {gameData?.crimes?.filter(c => character.age >= c.minAge).map(c => {
                  const riskClass = c.risk < 0.3 ? 'crime-risk-low' : c.risk < 0.5 ? 'crime-risk-med' : 'crime-risk-high';
                  const riskLabel = c.risk < 0.3 ? 'Low Risk' : c.risk < 0.5 ? 'Medium Risk' : 'High Risk';
                  const riskColor = c.risk < 0.3 ? '#2ecc71' : c.risk < 0.5 ? '#f39c12' : '#e74c3c';
                  return (
                    <button key={c.name} className={`content-card ${riskClass}`} data-testid={`crime-${c.name.replace(/\s/g,'-')}`}
                      style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
                        cursor: 'pointer', textAlign: 'left', padding: '0.75rem', margin: 0 }}
                      onClick={() => commitCrime(c.name)} disabled={loading}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                          <span style={{ fontSize: '1.8rem' }}>{c.emoji}</span>
                          <div>
                            <div style={{ fontWeight: 700, fontSize: '0.95rem', color: colors.text }}>{c.name}</div>
                            <div style={{ fontSize: '0.8rem', color: colors.textMuted }}>Min age: {c.minAge}+</div>
                          </div>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                          <div style={{ color: colors.success, fontWeight: 700 }}>${c.reward[0].toLocaleString()}-${c.reward[1].toLocaleString()}</div>
                          <div style={{ fontSize: '0.8rem', color: riskColor, fontWeight: 600 }}>{riskLabel} ({Math.round(c.risk * 100)}%)</div>
                          <div style={{ fontSize: '0.75rem', color: colors.error }}>Prison: {c.prisonYears[0]}-{c.prisonYears[1]}yr</div>
                        </div>
                      </div>
                    </button>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  const renderCasinoTab = () => (
    <div>
      {character.age < 21 ? (
        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          <p style={{ textAlign: 'center', color: colors.textMuted }}>🔞 Must be 21+</p>
        </div>
      ) : (
        <div className="content-card" style={{ '--glass-bg': theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }}>
          <div className="card-title">🎰 {t('casino')}</div>
          <div className="bet-controls">
            <p style={{ marginBottom: '0.5rem' }}>{t('bet_amount')}:</p>
            <div className="bet-input-row">
              <input type="number" className="bet-input" value={bet} onChange={e => setBet(Math.max(1, Number(e.target.value)))}
                style={{ color: colors.text }} />
            </div>
            <div className="bet-presets">
              {[100, 500, 1000, 5000, 10000].map(b => (
                <button key={b} className="bet-preset-btn" style={{ color: colors.text }}
                  onClick={() => setBet(b)}>${b}</button>
              ))}
            </div>
          </div>
          <div className="casino-games-grid">
            <button className="casino-game-btn" onClick={startBlackjack} disabled={bet > character.money}>
              <span className="casino-game-icon">🃏</span>
              <span className="casino-game-name">Blackjack</span>
              <span className="casino-game-desc">Visual cards!</span>
            </button>
            {[
              { id: 'slots', name: 'Slots', icon: '🎰', desc: 'Up to 50x!' },
              { id: 'roulette', name: 'Roulette', icon: '🎡', desc: 'Up to 35x!' },
              { id: 'poker', name: 'Poker', icon: '♠️', desc: 'Up to 5x' },
            ].map(g => (
              <button key={g.id} className="casino-game-btn"
                onClick={async () => {
                  if (bet > character.money) return;
                  setLoading(true);
                  try {
                    const r = await fetch(`${API_URL}/api/character/${character.id}/casino`, {
                      method: 'POST', headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ game: g.id, bet }),
                    });
                    if (r.ok) {
                      const d = await r.json();
                      setCharacter(d.character);
                      notify(d.message, d.won ? 'success' : 'error');
                      playSound(d.won ? 'money' : 'fail');
                    }
                  } catch (e) {}
                  setLoading(false);
                }}
                disabled={bet > character.money}>
                <span className="casino-game-icon">{g.icon}</span>
                <span className="casino-game-name">{g.name}</span>
                <span className="casino-game-desc">{g.desc}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );

  const renderPhoneTab = () => {
    // Generate random social media posts based on character's world
    const generatePosts = () => {
      const names = [
        ...(character.classmates || []).slice(0, 3).map(c => c.name),
        ...(character.siblings || []).map(s => s.name),
        character.partner?.name,
        'CelebGossip', 'MemeKing', 'NewsFlash',
      ].filter(Boolean);

      const posts = [
        { user: names[0] || 'User123', text: `Just vibing in ${character.city} 🌆`, likes: Math.floor(Math.random() * 500), emoji: '📸' },
        { user: names[1] || 'CoolCat', text: 'Who wants to hang out this weekend?', likes: Math.floor(Math.random() * 200), emoji: '🎉' },
        { user: 'NewsFlash', text: `Breaking: New restaurant opens in ${character.city}!`, likes: Math.floor(Math.random() * 1000), emoji: '📰' },
        { user: names[2] || 'FoodieLife', text: 'This pizza is incredible 🍕', likes: Math.floor(Math.random() * 300), emoji: '😋' },
        { user: 'MemeKing', text: 'When you age up and nothing happens 😂', likes: Math.floor(Math.random() * 2000), emoji: '🤣' },
      ];
      return posts;
    };

    const generateMessages = () => {
      const msgs = [];
      if (character.partner) msgs.push({ from: character.partner.name, text: 'Hey babe, miss you ❤️', time: '2m ago' });
      if (character.parents?.[0]) msgs.push({ from: character.parents[0].name, text: 'Come home for dinner!', time: '15m ago' });
      if (character.siblings?.[0]) msgs.push({ from: character.siblings[0].name, text: 'lol did you see that?', time: '1h ago' });
      if (character.classmates?.[0]) msgs.push({ from: character.classmates[0].name, text: 'Wanna study together?', time: '3h ago' });
      msgs.push({ from: 'Unknown', text: 'You won a prize! Click here...', time: '5h ago' });
      return msgs;
    };

    // Phone app content
    if (phoneApp) {
      const appContent = {
        instagram: (
          <div style={{ padding: '0.5rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h3 style={{ color: colors.text, margin: 0 }}>📸 Instagram</h3>
              <button style={{ background: 'none', border: 'none', color: colors.text, fontSize: '1.2rem', cursor: 'pointer' }} onClick={() => setPhoneApp(null)}>✕</button>
            </div>
            {generatePosts().map((post, i) => (
              <div key={i} style={{ padding: '0.75rem', background: 'rgba(255,255,255,0.05)', borderRadius: '10px', marginBottom: '0.5rem' }}>
                <div style={{ fontWeight: 700, marginBottom: '0.25rem' }}>{post.emoji} {post.user}</div>
                <div style={{ fontSize: '0.9rem', color: colors.textSec }}>{post.text}</div>
                <div style={{ display: 'flex', gap: '1rem', marginTop: '0.5rem', fontSize: '0.8rem', color: colors.textMuted }}>
                  <span onClick={() => notify('Liked!', 'success')} style={{ cursor: 'pointer' }}>❤️ {post.likes}</span>
                  <span>💬 {Math.floor(post.likes * 0.1)}</span>
                  <span>📤 Share</span>
                </div>
              </div>
            ))}
            <button className="primary-btn" style={{ background: '#c13584', marginTop: '0.5rem' }}
              onClick={() => { notify('Posted a selfie! +5 Looks', 'success'); }}>
              📸 Post a Selfie
            </button>
          </div>
        ),
        tiktok: (
          <div style={{ padding: '0.5rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h3 style={{ color: colors.text, margin: 0 }}>🎵 TikTok</h3>
              <button style={{ background: 'none', border: 'none', color: colors.text, fontSize: '1.2rem', cursor: 'pointer' }} onClick={() => setPhoneApp(null)}>✕</button>
            </div>
            {['Dance Challenge 💃', 'Life Hack 🧠', 'Prank Video 😈', 'Cooking Tutorial 🍳', 'Storytime 📖'].map((vid, i) => (
              <div key={i} style={{ padding: '0.75rem', background: 'rgba(255,255,255,0.05)', borderRadius: '10px', marginBottom: '0.5rem', cursor: 'pointer' }}
                onClick={() => notify(`Watched: ${vid} (+${Math.floor(Math.random()*5)+1} Happiness)`, 'success')}>
                <span style={{ fontSize: '0.9rem' }}>{vid}</span>
                <span style={{ float: 'right', color: colors.textMuted, fontSize: '0.8rem' }}>▶️ {Math.floor(Math.random()*10)+1}M views</span>
              </div>
            ))}
            <button className="primary-btn" style={{ background: '#000', marginTop: '0.5rem' }}
              onClick={() => notify('Posted a TikTok! Going viral!', 'success')}>
              🎬 Make a TikTok
            </button>
          </div>
        ),
        twitter: (
          <div style={{ padding: '0.5rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h3 style={{ color: colors.text, margin: 0 }}>🐦 Twitter</h3>
              <button style={{ background: 'none', border: 'none', color: colors.text, fontSize: '1.2rem', cursor: 'pointer' }} onClick={() => setPhoneApp(null)}>✕</button>
            </div>
            {[
              { user: 'CelebGossip', text: `Drama in ${character.city} today...`, rt: 450 },
              { user: 'BreakingNews', text: 'Stock market hits all-time high 📈', rt: 2300 },
              { user: 'MemeAccount', text: 'Pov: you pick the wrong career in PinkLife 💀', rt: 8900 },
            ].map((tweet, i) => (
              <div key={i} style={{ padding: '0.75rem', background: 'rgba(255,255,255,0.05)', borderRadius: '10px', marginBottom: '0.5rem' }}>
                <div style={{ fontWeight: 700, marginBottom: '0.25rem' }}>@{tweet.user}</div>
                <div style={{ fontSize: '0.9rem', color: colors.textSec }}>{tweet.text}</div>
                <div style={{ display: 'flex', gap: '1rem', marginTop: '0.5rem', fontSize: '0.8rem', color: colors.textMuted }}>
                  <span style={{ cursor: 'pointer' }} onClick={() => notify('Retweeted!')}>🔄 {tweet.rt}</span>
                  <span style={{ cursor: 'pointer' }} onClick={() => notify('Liked!')}>❤️ {Math.floor(tweet.rt * 1.5)}</span>
                </div>
              </div>
            ))}
            <button className="primary-btn" style={{ background: '#1da1f2', marginTop: '0.5rem' }}
              onClick={() => notify('Tweet posted! +3 Smarts', 'success')}>
              ✏️ Tweet
            </button>
          </div>
        ),
        youtube: (
          <div style={{ padding: '0.5rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h3 style={{ color: colors.text, margin: 0 }}>▶️ YouTube</h3>
              <button style={{ background: 'none', border: 'none', color: colors.text, fontSize: '1.2rem', cursor: 'pointer' }} onClick={() => setPhoneApp(null)}>✕</button>
            </div>
            {[
              { title: 'How to Get Rich Quick', views: '2.3M', emoji: '💰' },
              { title: 'Top 10 Life Hacks', views: '5.1M', emoji: '🧠' },
              { title: 'Epic Fails Compilation', views: '12M', emoji: '😂' },
              { title: 'Music Mix - Reggaeton', views: '890K', emoji: '🎶' },
            ].map((vid, i) => (
              <div key={i} style={{ padding: '0.75rem', background: 'rgba(255,255,255,0.05)', borderRadius: '10px', marginBottom: '0.5rem', cursor: 'pointer' }}
                onClick={() => {
                  if (vid.emoji === '🎶') { toggleMusic('reggaeton'); notify('Playing Reggaeton!', 'success'); }
                  else notify(`Watching: ${vid.title} (+2 Happiness)`, 'success');
                }}>
                <span>{vid.emoji} {vid.title}</span>
                <span style={{ float: 'right', color: colors.textMuted, fontSize: '0.8rem' }}>{vid.views} views</span>
              </div>
            ))}
          </div>
        ),
        snapchat: (
          <div style={{ padding: '0.5rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h3 style={{ color: colors.text, margin: 0 }}>👻 Snapchat</h3>
              <button style={{ background: 'none', border: 'none', color: colors.text, fontSize: '1.2rem', cursor: 'pointer' }} onClick={() => setPhoneApp(null)}>✕</button>
            </div>
            {[...(character.classmates || []).slice(0, 3), ...(character.siblings || []).slice(0, 2)].map((person, i) => (
              <div key={i} style={{ padding: '0.75rem', background: 'rgba(255,255,255,0.05)', borderRadius: '10px', marginBottom: '0.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span>{person.emoji || '👤'} {person.name}</span>
                <button style={{ background: '#fffc00', color: '#000', border: 'none', borderRadius: '8px', padding: '0.3rem 0.6rem', cursor: 'pointer', fontWeight: 600 }}
                  onClick={() => notify(`Snapped ${person.name}! 📸`)}>
                  📷 Snap
                </button>
              </div>
            ))}
            <button className="primary-btn" style={{ background: '#fffc00', color: '#000', marginTop: '0.5rem' }}
              onClick={() => notify('Posted to Story! 👻', 'success')}>
              📸 Post to Story
            </button>
          </div>
        ),
        messages: (
          <div style={{ padding: '0.5rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h3 style={{ color: colors.text, margin: 0 }}>💬 Messages</h3>
              <button style={{ background: 'none', border: 'none', color: colors.text, fontSize: '1.2rem', cursor: 'pointer' }} onClick={() => setPhoneApp(null)}>✕</button>
            </div>
            {generateMessages().map((msg, i) => (
              <div key={i} style={{ padding: '0.75rem', background: 'rgba(255,255,255,0.05)', borderRadius: '10px', marginBottom: '0.5rem', cursor: 'pointer' }}
                onClick={() => notify(`Replied to ${msg.from}`, 'success')}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ fontWeight: 700 }}>{msg.from}</span>
                  <span style={{ color: colors.textMuted, fontSize: '0.8rem' }}>{msg.time}</span>
                </div>
                <div style={{ fontSize: '0.9rem', color: colors.textSec, marginTop: '0.25rem' }}>{msg.text}</div>
              </div>
            ))}
          </div>
        ),
        music: (
          <div style={{ padding: '0.5rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h3 style={{ color: colors.text, margin: 0 }}>🎶 Music</h3>
              <button style={{ background: 'none', border: 'none', color: colors.text, fontSize: '1.2rem', cursor: 'pointer' }} onClick={() => setPhoneApp(null)}>✕</button>
            </div>
            {[
              { name: 'Reggaeton Mix', track: 'reggaeton', emoji: '🔥' },
              { name: 'Chill Vibes', track: 'chill', emoji: '🌊' },
              { name: 'Hip Hop Beats', track: 'hiphop', emoji: '🎤' },
            ].map((song, i) => (
              <div key={i} style={{ padding: '0.75rem', background: currentTrack === song.track && musicPlaying ? `${colors.primary}22` : 'rgba(255,255,255,0.05)', borderRadius: '10px', marginBottom: '0.5rem', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                onClick={() => {
                  if (bgMusic) { bgMusic.pause(); bgMusic = null; }
                  bgMusic = new Audio(MUSIC_TRACKS[song.track]);
                  bgMusic.loop = true;
                  bgMusic.volume = 0.25;
                  bgMusic.play().catch(() => {});
                  setMusicPlaying(true);
                  setCurrentTrack(song.track);
                  notify(`Now playing: ${song.name}`, 'success');
                }}>
                <span>{song.emoji} {song.name}</span>
                {currentTrack === song.track && musicPlaying && <span style={{ color: colors.primary }}>♫ Playing</span>}
              </div>
            ))}
            {musicPlaying && (
              <button className="primary-btn" style={{ background: colors.error, marginTop: '0.5rem' }}
                onClick={() => { if (bgMusic) { bgMusic.pause(); bgMusic = null; } setMusicPlaying(false); }}>
                ⏹️ Stop Music
              </button>
            )}
          </div>
        ),
      };

      return (
        <div className="phone-container">
          <div className="phone-screen" style={{ color: '#fff' }}>
            <div className="phone-status-bar">
              <span className="phone-time">{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
              <div className="phone-icons">📶 🔋</div>
            </div>
            {appContent[phoneApp] || (
              <div style={{ padding: '1rem', textAlign: 'center', color: colors.textMuted }}>App loading...</div>
            )}
            <div className="phone-home-bar" style={{ cursor: 'pointer' }} onClick={() => setPhoneApp(null)} />
          </div>
        </div>
      );
    }

    return (
      <div className="phone-container">
        <div className="phone-screen" style={{ color: '#fff' }}>
          <div className="phone-status-bar">
            <span className="phone-time">{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
            <div className="phone-icons">📶 🔋</div>
          </div>
          <div className="phone-apps-grid">
            {[
              { name: 'Tinder', icon: '🔥', color: '#fe3c72', action: () => { findDate(); } },
              { name: 'Instagram', icon: '📸', color: '#c13584', action: () => setPhoneApp('instagram') },
              { name: 'TikTok', icon: '🎵', color: '#010101', action: () => setPhoneApp('tiktok') },
              { name: 'Twitter', icon: '🐦', color: '#1da1f2', action: () => setPhoneApp('twitter') },
              { name: 'YouTube', icon: '▶️', color: '#ff0000', action: () => setPhoneApp('youtube') },
              { name: 'Snapchat', icon: '👻', color: '#fffc00', action: () => setPhoneApp('snapchat') },
              { name: 'Messages', icon: '💬', color: '#34c759', action: () => setPhoneApp('messages') },
              { name: 'Music', icon: '🎶', color: '#fc3c44', action: () => setPhoneApp('music') },
              { name: 'Casino', icon: '🎰', color: '#ff69b4', action: () => setActiveTab('casino') },
              { name: 'Bank', icon: '🏦', color: '#007aff', action: () => notify(`Balance: $${(character.money || 0).toLocaleString()}`) },
              { name: 'Settings', icon: '⚙️', color: '#8e8e93', action: () => setModal('settings') },
              { name: 'Shopping', icon: '🛍️', color: '#ff9500', action: () => setModal('in-game-shop') },
            ].map(app => (
              <div key={app.name} className="phone-app" data-testid={`phone-app-${app.name.toLowerCase()}`} onClick={app.action}>
                <div className="phone-app-icon" style={{ background: app.color }}>{app.icon}</div>
                <span className="phone-app-name">{app.name}</span>
              </div>
            ))}
          </div>
          <div className="phone-home-bar" />
        </div>
      </div>
    );
  };

  const renderDeathScreen = () => {
    const causeTranslations = {
      ES: { 'Surrendered': 'Se rindió', 'Natural causes': 'Causas naturales', 'Natural causes (old age)': 'Vejez', 'Unknown': 'Desconocido' },
      RO: { 'Surrendered': 'A renunțat', 'Natural causes': 'Cauze naturale', 'Natural causes (old age)': 'Bătrânețe', 'Unknown': 'Necunoscut' },
    };
    const causeDict = causeTranslations[lang] || {};
    const cause = causeDict[character.cause_of_death] || character.cause_of_death;

    return (
      <div className="death-overlay">
        <div className="death-modal" style={{ color: colors.text }}>
          <span className="death-icon">💀</span>
          <h2 className="death-title">{t('rest_in_peace')}</h2>
          <h3 className="death-name" style={{ color: colors.primary }}>{character.name}</h3>
          <p className="death-age">{t('lived')} {character.age} {t('years')}</p>
          <p className="death-cause" style={{ color: colors.textMuted }}>{cause}</p>
          <div className="death-stats" style={{ color: colors.textSec }}>
            <span>💰 ${character.money?.toLocaleString()}</span>
            <span>☯️ {t('karma')}: {character.karma}</span>
            {character.children?.length > 0 && <span>👶 {character.children.length}</span>}
            {character.job && character.job !== 'Unemployed' && <span>💼 {character.job}</span>}
          </div>
          {character.children?.length > 0 && (
            <div className="legacy-section">
              <p className="legacy-title">{t('continue_as')}:</p>
              {character.children.map(c => (
                <button key={c.id} className="legacy-btn" onClick={() => switchToChild(c.id)}>
                  {c.emoji} {c.name} ({t('age')} {c.age})
                </button>
              ))}
            </div>
          )}
          <button className="new-life-btn" onClick={() => { setCharacter(null); setEventPopup(null); setModal(null); setScreen('home'); }}>
            ✨ {t('new_life_btn')}
          </button>
        </div>
      </div>
    );
  };

  // ============ MODALS ============
  const renderModal = () => {
    if (!modal) return null;
    const closeModal = () => { setModal(null); setModalData(null); setBjGame(null); };

    // Confirm End Life modal (mobile-safe, no window.confirm)
    if (modal === 'confirm-end-life') {
      return (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <div className="modal-content" style={{ color: colors.text, '--glass-bg': theme === 'dark' ? 'rgba(30,30,30,0.95)' : 'rgba(255,255,255,0.95)', maxWidth: '340px' }} onClick={e => e.stopPropagation()}>
            <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
              <span style={{ fontSize: '3rem' }}>🕊️</span>
              <h2 style={{ color: colors.error, margin: '0.5rem 0 0.25rem' }}>End Life?</h2>
              <p style={{ color: colors.textSec, fontSize: '0.95rem' }}>
                This will end {character?.name}'s life and show your life summary.
              </p>
            </div>
            <div style={{ display: 'flex', gap: '0.75rem' }}>
              <button className="primary-btn" style={{ background: colors.error, flex: 1 }}
                onClick={confirmEndLife}>
                ☠️ Yes, End Life
              </button>
              <button className="primary-btn" style={{ background: colors.textMuted, flex: 1 }}
                onClick={() => setModal(null)}>
                ↩️ Cancel
              </button>
            </div>
          </div>
        </div>
      );
    }

    // Creator Modal
    if (modal === 'creator') {
      return (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" style={{ color: colors.text, '--glass-bg': theme === 'dark' ? 'rgba(30,30,30,0.95)' : 'rgba(255,255,255,0.95)' }} onClick={e => e.stopPropagation()}>
            <h2 className="modal-title">🎨 Create Character</h2>

            {/* Randomize Button */}
            <button style={{
              width: '100%', padding: '0.75rem', marginBottom: '1rem', borderRadius: '12px', border: 'none',
              background: `linear-gradient(135deg, ${colors.secondary}, ${colors.primary})`,
              color: '#fff', fontWeight: 700, fontSize: '1rem', cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem',
            }} onClick={() => {
              const countriesList = Object.keys(ALL_COUNTRIES);
              const randomCountry = countriesList[Math.floor(Math.random() * countriesList.length)];
              const randomCities = ALL_COUNTRIES[randomCountry];
              const randomCity = randomCities[Math.floor(Math.random() * randomCities.length)];
              const firstNames = ['Alex', 'Sam', 'Jordan', 'Taylor', 'Morgan', 'Riley', 'Casey', 'Quinn', 'Avery', 'Blake'];
              const lastNames = ['Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis', 'Wilson', 'Martinez'];
              const skins = SKIN_TONES.map(s => s.id);
              setCreator({
                firstName: firstNames[Math.floor(Math.random() * firstNames.length)],
                lastName: lastNames[Math.floor(Math.random() * lastNames.length)],
                gender: Math.random() > 0.5 ? 'male' : 'female',
                country: randomCountry,
                city: randomCity,
                skin_tone: skins[Math.floor(Math.random() * skins.length)],
                sexuality: ['straight', 'straight', 'straight', 'gay', 'bisexual'][Math.floor(Math.random() * 5)],
                born_royal: Math.random() < 0.05,
                health: Math.floor(Math.random() * 91) + 10,
                happiness: Math.floor(Math.random() * 91) + 10,
                smarts: Math.floor(Math.random() * 91) + 10,
                looks: Math.floor(Math.random() * 91) + 10,
              });
            }}>
              🎲 Randomize Everything
            </button>

            <div className="creator-section">
              <div className="creator-label">📝 {t('name')}</div>
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <input className="creator-input" placeholder="First name" value={creator.firstName}
                  onChange={e => setCreator({...creator, firstName: e.target.value})} style={{ color: colors.text }} />
                <input className="creator-input" placeholder="Last name" value={creator.lastName}
                  onChange={e => setCreator({...creator, lastName: e.target.value})} style={{ color: colors.text }} />
              </div>
            </div>

            <div className="creator-section">
              <div className="creator-label">⚧ {t('gender')}</div>
              <div className="creator-options">
                <button className={`creator-option ${creator.gender === 'male' ? 'selected' : ''}`}
                  style={{ color: colors.text }} onClick={() => setCreator({...creator, gender: 'male'})}>
                  👨 {t('male')}
                </button>
                <button className={`creator-option ${creator.gender === 'female' ? 'selected' : ''}`}
                  style={{ color: colors.text }} onClick={() => setCreator({...creator, gender: 'female'})}>
                  👩 {t('female')}
                </button>
              </div>
            </div>

            <div className="creator-section">
              <div className="creator-label">🎨 {t('skin_tone')}</div>
              <div className="skin-options">
                {SKIN_TONES.map(s => (
                  <button key={s.id} className={`skin-option ${creator.skin_tone === s.id ? 'selected' : ''}`}
                    onClick={() => setCreator({...creator, skin_tone: s.id})}>
                    {s.emoji}
                  </button>
                ))}
              </div>
            </div>

            <div className="creator-section">
              <div className="creator-label">🌍 {t('country')}</div>
              <div className="creator-options" style={{ maxHeight: '150px', overflowY: 'auto' }}>
                {Object.keys(ALL_COUNTRIES).map(c => (
                  <button key={c} className={`creator-option ${creator.country === c ? 'selected' : ''}`}
                    style={{ color: colors.text }}
                    onClick={() => setCreator({...creator, country: c, city: ALL_COUNTRIES[c][0]})}>
                    {c}
                  </button>
                ))}
              </div>
            </div>

            <div className="creator-section">
              <div className="creator-label">🏙️ {t('city')}</div>
              <div className="creator-options">
                {ALL_COUNTRIES[creator.country]?.map(city => (
                  <button key={city} className={`creator-option ${creator.city === city ? 'selected' : ''}`}
                    style={{ color: colors.text }} onClick={() => setCreator({...creator, city})}>
                    {city}
                  </button>
                ))}
              </div>
            </div>

            <div className="creator-section">
              <div className="creator-label">💕 {t('sexuality')}</div>
              <div className="creator-options">
                {[{ id: 'straight', emoji: '👫', label: t('straight') }, { id: 'gay', emoji: '🏳️‍🌈', label: t('gay') }, { id: 'bisexual', emoji: '💜', label: t('bisexual') }].map(s => (
                  <button key={s.id} className={`creator-option ${creator.sexuality === s.id ? 'selected' : ''}`}
                    style={{ color: colors.text }} onClick={() => setCreator({...creator, sexuality: s.id})}>
                    {s.emoji} {s.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="creator-section">
              <div className="creator-label">👑 {t('special_birth')}</div>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.75rem', background: 'rgba(255,255,255,0.05)', borderRadius: '10px', cursor: 'pointer' }}>
                <input type="checkbox" checked={creator.born_royal}
                  onChange={e => setCreator({...creator, born_royal: e.target.checked})} />
                <span>👑 {t('born_royal')}</span>
              </label>
            </div>

            <div className="creator-section">
              <div className="creator-label">📊 {t('custom_stats')}</div>
              {[
                { key: 'health', icon: '❤️', color: '#ff4757' },
                { key: 'happiness', icon: '😊', color: '#00d68f' },
                { key: 'smarts', icon: '🧠', color: '#3b82f6' },
                { key: 'looks', icon: '✨', color: '#f59e0b' },
              ].map(s => (
                <div key={s.key} className="stat-slider-row">
                  <span className="stat-slider-icon">{s.icon}</span>
                  <input type="range" min="10" max="100" className="stat-slider" value={creator[s.key]}
                    onChange={e => setCreator({...creator, [s.key]: Number(e.target.value)})} />
                  <span className="stat-slider-value" style={{ color: colors.text }}>{creator[s.key]}</span>
                </div>
              ))}
            </div>

            <button className="start-life-btn" onClick={() => createCharacter(true)}>
              🎉 {t('start_life')}
            </button>
            <button className="modal-close-btn" style={{ background: colors.textMuted, color: '#fff' }} onClick={closeModal}>
              {t('close')}
            </button>
          </div>
        </div>
      );
    }

    // Settings
    if (modal === 'settings') {
      return (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" style={{ color: colors.text, '--glass-bg': theme === 'dark' ? 'rgba(30,30,30,0.95)' : 'rgba(255,255,255,0.95)' }} onClick={e => e.stopPropagation()}>
            <h2 className="modal-title">⚙️ {t('settings')}</h2>
            <div className="settings-list">
              <div className="setting-item" onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}>
                <span className="setting-label">{t('dark_mode')}</span>
                <span className="setting-value">{theme === 'dark' ? '🌙' : '☀️'}</span>
              </div>
              <div className="setting-item" onClick={toggleSound}>
                <span className="setting-label">{t('sound')} (SFX)</span>
                <span className="setting-value">{soundEnabled ? '🔊 On' : '🔇 Off'}</span>
              </div>
              <div className="setting-item" onClick={() => toggleMusic()}>
                <span className="setting-label">{t('music')} (Background)</span>
                <span className="setting-value">{musicPlaying ? '🎵 On' : '🎶 Off'}</span>
              </div>
              <div className="setting-item" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                <span className="setting-label" style={{ marginBottom: '0.5rem' }}>🎶 Music Track</span>
                <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                  {[
                    { id: 'reggaeton', label: '🔥 Reggaeton' },
                    { id: 'chill', label: '🌊 Chill' },
                    { id: 'hiphop', label: '🎤 Hip Hop' },
                  ].map(tr => (
                    <button key={tr.id}
                      style={{
                        padding: '0.4rem 0.8rem', borderRadius: '8px', border: 'none', cursor: 'pointer',
                        background: currentTrack === tr.id ? colors.primary : 'rgba(255,255,255,0.1)',
                        color: currentTrack === tr.id ? '#fff' : colors.text, fontSize: '0.85rem',
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (bgMusic) { bgMusic.pause(); bgMusic = null; }
                        bgMusic = new Audio(MUSIC_TRACKS[tr.id]);
                        bgMusic.loop = true;
                        bgMusic.volume = 0.25;
                        bgMusic.play().catch(() => {});
                        setMusicPlaying(true);
                        setCurrentTrack(tr.id);
                      }}>
                      {tr.label}
                    </button>
                  ))}
                </div>
              </div>
              <div className="setting-item">
                <span className="setting-label">{t('language')}</span>
                <select className="lang-select" value={lang} onChange={e => setLang(e.target.value)}
                  style={{ color: colors.text, background: theme === 'dark' ? '#333' : '#fff' }}>
                  <option value="EN">🇬🇧 English</option>
                  <option value="ES">🇪🇸 Español</option>
                  <option value="RO">🇷🇴 Română</option>
                </select>
              </div>
            </div>
            <div className="about-section" style={{ textAlign: 'center', padding: '1.5rem 0', borderTop: `1px solid ${colors.textMuted}33`, marginTop: '1rem' }}>
              <p style={{ color: colors.primary, fontWeight: 700, fontSize: '1.1rem', marginBottom: '0.25rem' }}>Made by Bianca</p>
              <p style={{ color: colors.textMuted, fontSize: '0.85rem' }}>PinkLife v7.0</p>
            </div>
            <button className="modal-close-btn" style={{ background: colors.primary, color: '#fff' }} onClick={closeModal}>{t('close')}</button>
          </div>
        </div>
      );
    }

    // Shop
    if (modal === 'shop') {
      // ─── Pack metadata: visuals, bullets, badge, accent ───────────────────────
      const PACK_META = {
        starter: {
          icon: '✨', preview: '👱‍♀️✨💫',
          accent: '#f59e0b',
          badge: { EN: 'POPULAR', ES: 'POPULAR', RO: 'POPULAR' },
          taglineKey: 'pack_starter_tagline',
          bullets: {
            EN: ['+500 💎 Coins instantly', 'Unlock bonus starter outfits', 'Early-game advantage boost', 'One-time exclusive content'],
            ES: ['+500 💎 Monedas al instante', 'Desbloquea atuendos iniciales', 'Ventaja en el inicio del juego', 'Contenido exclusivo único'],
            RO: ['+500 💎 Monede instant', 'Deblochează ținute de start', 'Avantaj la început de joc', 'Conținut exclusiv unic'],
          },
          stateFlag: 'hasStarterPack',
        },
        luxury_pack: {
          icon: '💎', preview: '👱‍♀️💎🥂',
          accent: '#e91e8c',
          badge: { EN: 'BEST VALUE', ES: 'MEJOR VALOR', RO: 'CEL MAI BUN PREȚ' },
          taglineKey: 'pack_luxury_tagline',
          bullets: {
            EN: ['+$500,000 in-game cash', '+2,000 💎 Coins bonus', 'Unlock all luxury brands', 'VIP shopping access', 'Premium furniture drops'],
            ES: ['+$500.000 en efectivo', '+2.000 💎 Monedas', 'Desbloquea marcas de lujo', 'Acceso VIP de compras', 'Muebles premium'],
            RO: ['+$500.000 bani în joc', '+2.000 💎 Monede', 'Deblochează branduri de lux', 'Acces VIP la cumpărături', 'Mobilier premium'],
          },
          stateFlag: 'hasLuxuryPack',
        },
        god_mode: {
          icon: '👑', preview: '👑✨🌟',
          accent: '#ffd700',
          badge: { EN: 'EXCLUSIVE', ES: 'EXCLUSIVO', RO: 'EXCLUSIV' },
          taglineKey: 'pack_god_tagline',
          bullets: {
            EN: ['All stats maxed to 100', 'Invincible health forever', 'Unlimited happiness boost', 'Max Karma & Smarts instantly', '⚡ God-tier gameplay'],
            ES: ['Todos los stats al máximo', 'Salud invencible para siempre', 'Boost de felicidad ilimitado', 'Karma y Smarts al máximo', '⚡ Gameplay divino'],
            RO: ['Toate statisticile la maxim', 'Sănătate de neatins mereu', 'Fericire nelimitată', 'Karma și Inteligență maxime', '⚡ Gameplay divin'],
          },
          stateFlag: 'hasGodMode',
        },
        no_ads: {
          icon: '🚫', preview: '🚫📺🎮',
          accent: '#10b981',
          badge: { EN: 'CLEAN', ES: 'LIMPIO', RO: 'CURAT' },
          taglineKey: 'pack_noads_tagline',
          bullets: {
            EN: ['Zero ads, ever', 'Uninterrupted gameplay', 'Faster load times', 'Pure immersive experience'],
            ES: ['Cero anuncios jamás', 'Juego sin interrupciones', 'Carga más rápida', 'Experiencia inmersiva pura'],
            RO: ['Zero reclame niciodată', 'Joc fără întreruperi', 'Încărcare mai rapidă', 'Experiență pură'],
          },
          stateFlag: 'hasNoAds',
        },
        crime_pack: {
          icon: '🕴️', preview: '🕴️🔫💰',
          accent: '#7c3aed',
          badge: { EN: 'NEW', ES: 'NUEVO', RO: 'NOU' },
          taglineKey: 'pack_crime_tagline',
          bullets: {
            EN: ['Unlock Mafia Boss path', 'Exclusive crime missions', 'Order hits & launder money', 'Double crime rewards', 'Crime Lord starter rank'],
            ES: ['Desbloquea camino Mafia Boss', 'Misiones criminales exclusivas', 'Ordena ataques y lava dinero', 'Doble recompensas criminales', 'Rango Crime Lord inicial'],
            RO: ['Deblochează calea Mafia Boss', 'Misiuni criminale exclusive', 'Ordonă atacuri și spală bani', 'Recompense criminale duble', 'Rang Crime Lord de start'],
          },
          stateFlag: 'hasMafiaPack',
        },
        fame_pack: {
          icon: '⭐', preview: '⭐📸🎬',
          accent: '#f59e0b',
          badge: { EN: 'POPULAR', ES: 'POPULAR', RO: 'POPULAR' },
          taglineKey: 'pack_fame_tagline',
          bullets: {
            EN: ['+20 Looks & Happiness', 'Celebrity status unlocked', 'Exclusive fame events', 'Paparazzi scenarios', 'Brand deal opportunities'],
            ES: ['+20 Apariencia y Felicidad', 'Estado de celebridad', 'Eventos de fama exclusivos', 'Escenarios de paparazzi', 'Oportunidades de marcas'],
            RO: ['+20 Aspect și Fericire', 'Statut de celebritate', 'Evenimente de faimă exclusive', 'Scenarii paparazzi', 'Oportunități de brand deals'],
          },
          stateFlag: 'hasFamePack',
        },
        royal_pack: {
          icon: '🏰', preview: '👑🏰💍',
          accent: '#ffd700',
          badge: { EN: 'LIMITED', ES: 'LIMITADO', RO: 'LIMITAT' },
          taglineKey: 'pack_royal_tagline',
          bullets: {
            EN: ['Born Royal instantly', '+$1,000,000 royal treasury', 'Exclusive royal title', 'Royal Ball & execute laws', 'Royalty-specific scenarios'],
            ES: ['Nacer Real al instante', '+$1.000.000 tesoro real', 'Título real exclusivo', 'Baile Real y ejecutar leyes', 'Escenarios de realeza'],
            RO: ['Devii Regal instant', '+$1.000.000 trezorerie regală', 'Titlu regal exclusiv', 'Bal Regal și executa legi', 'Scenarii regale exclusive'],
          },
          stateFlag: 'hasRoyalPack',
        },
        time_machine: {
          icon: '⏰', preview: '⏰🔄✨',
          accent: '#3b82f6',
          badge: { EN: 'EXCLUSIVE', ES: 'EXCLUSIVO', RO: 'EXCLUSIV' },
          taglineKey: 'pack_time_tagline',
          bullets: {
            EN: ['Undo last age-up', 'Rewind bad decisions', 'Second chance system', 'Save your best moments', 'Unlimited do-overs'],
            ES: ['Deshacer último año', 'Retroceder malas decisiones', 'Sistema de segunda oportunidad', 'Guarda tus mejores momentos', 'Repeticiones ilimitadas'],
            RO: ['Anulează ultimul an', 'Derulează decizii proaste', 'Sistem a doua șansă', 'Salvează cele mai bune momente', 'Refaceri nelimitate'],
          },
          stateFlag: 'hasTimeMachine',
        },
      };

      // ─── Stripe purchase handler — UNTOUCHED from original ─────────────────
      const handleStripePurchase = async (pack) => {
        playSound('click');
        try {
          // Call backend to create Stripe session
          const r = await fetch(`${API_URL}/api/create-checkout-session`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ pack_id: pack.id, pack_name: pack.name, price: pack.price }),
          });
          if (r.ok) {
            const d = await r.json();
            if (d.url) {
              window.location.href = d.url;
            } else if (d.session_id) {
              if (window.Stripe) {
                const stripe = window.Stripe(d.publishable_key || 'pk_live_placeholder');
                await stripe.redirectToCheckout({ sessionId: d.session_id });
              } else {
                notify('Redirecting to payment...', 'info');
              }
            } else {
              applyPackEffect(pack);
            }
          } else {
            applyPackEffect(pack);
          }
        } catch (e) {
          applyPackEffect(pack);
        }
      };

      // ─── Pack effect applier — updates global state flags + character ────────
      const applyPackEffect = (pack) => {
        if (pack.id === 'god_mode') {
          setHasGodMode(true);
          if (character) setCharacter(prev => ({ ...prev, health: 100, happiness: 100, smarts: 100, looks: 100, karma: 100 }));
          notify('🔥 GOD MODE activated! All stats maxed!', 'success');
        } else if (pack.id === 'royal_pack') {
          setHasRoyalPack(true);
          if (character) setCharacter(prev => ({ ...prev, is_royal: true, money: (prev.money || 0) + 1000000 }));
          notify('👑 Royal Pack! You are now royalty! +$1,000,000!', 'success');
        } else if (pack.id === 'fame_pack') {
          setHasFamePack(true);
          if (character) setCharacter(prev => ({ ...prev, looks: Math.min(100, (prev.looks || 50) + 20), happiness: Math.min(100, (prev.happiness || 50) + 20) }));
          notify('⭐ Fame Pack! +20 Looks & Happiness!', 'success');
        } else if (pack.id === 'starter') {
          setHasStarterPack(true);
          setCoins(c => c + 500);
          notify('🌟 Starter Pack activated! +500 Coins!', 'success');
        } else if (pack.id === 'luxury_pack') {
          setHasLuxuryPack(true);
          setCoins(c => c + 2000);
          if (character) setCharacter(prev => ({ ...prev, money: (prev.money || 0) + 500000 }));
          notify('💎 Luxury Pack! +$500,000 & +2000 Coins!', 'success');
        } else if (pack.id === 'crime_pack') {
          setHasMafiaPack(true);
          notify('🕴️ Crime Pack! Mafia path unlocked!', 'success');
        } else if (pack.id === 'no_ads') {
          setHasNoAds(true);
          notify('🚫 No Ads Pack! Enjoy clean gameplay!', 'success');
        } else if (pack.id === 'time_machine') {
          setHasTimeMachine(true);
          notify('⏰ Time Machine unlocked! Rewind your life!', 'success');
        } else {
          notify(`✅ ${pack.name} activated!`, 'success');
        }
        playSound('money');
      };

      const getBadgeLabel = (packId) => {
        const meta = PACK_META[packId];
        if (!meta?.badge) return null;
        return meta.badge[lang] || meta.badge.EN;
      };

      // ─── Inline CSS-in-JS styles ────────────────────────────────────────────
      const packCardStyle = (accent, isOwned) => ({
        position: 'relative',
        borderRadius: 20,
        marginBottom: '1.1rem',
        padding: '1.25rem',
        background: theme === 'dark'
          ? `linear-gradient(145deg, rgba(20,20,20,0.98), rgba(30,10,30,0.96))`
          : `linear-gradient(145deg, rgba(255,255,255,0.98), rgba(255,240,250,0.96))`,
        border: `1.5px solid ${isOwned ? '#10b98188' : accent + '55'}`,
        boxShadow: isOwned
          ? `0 0 0 2px #10b98133, 0 8px 32px ${accent}18`
          : `0 4px 24px ${accent}22, 0 1px 0 ${accent}33 inset`,
        overflow: 'hidden',
      });

      const glowBarStyle = (accent) => ({
        position: 'absolute', top: 0, left: 0, right: 0, height: 3,
        background: `linear-gradient(90deg, transparent, ${accent}, transparent)`,
        borderRadius: '20px 20px 0 0',
      });

      return (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" data-testid="shop-modal"
            style={{
              color: colors.text,
              '--glass-bg': theme === 'dark' ? 'rgba(10,10,10,0.97)' : 'rgba(255,255,255,0.97)',
              padding: '0',
              overflow: 'hidden',
              borderRadius: 24,
              maxHeight: '92vh',
            }}
            onClick={e => e.stopPropagation()}>

            {/* ── Header ────────────────────────────────────────────── */}
            <div style={{
              background: `linear-gradient(135deg, ${colors.primary}ee, ${colors.secondary}ee)`,
              padding: '1.25rem 1.5rem 1rem',
              position: 'relative',
              overflow: 'hidden',
            }}>
              {/* Decorative shimmer */}
              <div style={{ position: 'absolute', top: -30, right: -30, width: 120, height: 120, borderRadius: '50%', background: 'rgba(255,255,255,0.08)' }} />
              <div style={{ position: 'absolute', bottom: -20, left: 60, width: 80, height: 80, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }} />
              <button onClick={closeModal} style={{
                position: 'absolute', top: '0.75rem', right: '0.75rem',
                background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: '50%',
                width: 32, height: 32, cursor: 'pointer', color: '#fff', fontSize: '1rem',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>✕</button>
              <h2 data-testid="shop-title" style={{ margin: 0, color: '#fff', fontSize: '1.4rem', fontWeight: 800, letterSpacing: '-0.5px' }}>
                👑 PinkLife Premium
              </h2>
              <p style={{ margin: '0.25rem 0 0', color: 'rgba(255,255,255,0.82)', fontSize: '0.85rem' }}>
                {lang === 'RO' ? 'Deblochează experiența completă' : lang === 'ES' ? 'Desbloquea la experiencia completa' : 'Unlock the full experience'}
              </p>
              <div style={{ marginTop: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <div style={{ background: 'rgba(255,255,255,0.18)', borderRadius: 20, padding: '0.3rem 0.9rem', display: 'inline-flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.9rem', color: '#fff', fontWeight: 700 }}>
                  💎 {coins} {lang === 'RO' ? 'Monede' : lang === 'ES' ? 'Monedas' : 'Coins'}
                </div>
              </div>
            </div>

            {/* ── Pack Cards ────────────────────────────────────────── */}
            <div style={{ overflowY: 'auto', maxHeight: 'calc(92vh - 130px)', padding: '1.25rem 1.1rem 1.5rem' }}>
              {(gameData?.packs || []).map(p => {
                const meta = PACK_META[p.id] || { icon: '✨', preview: '✨', accent: colors.primary, taglineKey: 'shop', bullets: { EN: [p.description] } };
                const accent = meta.accent;
                const badgeLabel = getBadgeLabel(p.id);
                const bullets = (meta.bullets?.[lang] || meta.bullets?.EN || []);
                const isOwned = (
                  (p.id === 'god_mode' && hasGodMode) ||
                  (p.id === 'royal_pack' && hasRoyalPack) ||
                  (p.id === 'fame_pack' && hasFamePack) ||
                  (p.id === 'starter' && hasStarterPack) ||
                  (p.id === 'luxury_pack' && hasLuxuryPack) ||
                  (p.id === 'crime_pack' && hasMafiaPack) ||
                  (p.id === 'no_ads' && hasNoAds) ||
                  (p.id === 'time_machine' && hasTimeMachine)
                );

                return (
                  <div key={p.id} style={packCardStyle(accent, isOwned)}>
                    {/* Glow top bar */}
                    <div style={glowBarStyle(accent)} />

                    {/* Badge */}
                    {badgeLabel && !isOwned && (
                      <div style={{
                        position: 'absolute', top: 14, right: 14,
                        background: `linear-gradient(135deg, ${accent}, ${accent}aa)`,
                        color: '#fff', fontSize: '0.62rem', fontWeight: 800,
                        padding: '0.22rem 0.6rem', borderRadius: 20,
                        letterSpacing: '0.06em', boxShadow: `0 2px 8px ${accent}55`,
                      }}>
                        {badgeLabel}
                      </div>
                    )}
                    {isOwned && (
                      <div style={{
                        position: 'absolute', top: 14, right: 14,
                        background: 'linear-gradient(135deg, #10b981, #059669)',
                        color: '#fff', fontSize: '0.62rem', fontWeight: 800,
                        padding: '0.22rem 0.6rem', borderRadius: 20, letterSpacing: '0.06em',
                      }}>
                        ✓ {lang === 'RO' ? 'ACTIV' : lang === 'ES' ? 'ACTIVO' : 'OWNED'}
                      </div>
                    )}

                    {/* Pack header row */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.85rem' }}>
                      {/* Big emoji preview */}
                      <div style={{
                        width: 64, height: 64, borderRadius: 18, flexShrink: 0,
                        background: `linear-gradient(135deg, ${accent}28, ${accent}10)`,
                        border: `1.5px solid ${accent}44`,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: '1.9rem',
                        boxShadow: `0 4px 16px ${accent}22`,
                      }}>
                        {meta.icon}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.5rem', flexWrap: 'wrap' }}>
                          <span style={{ fontWeight: 800, fontSize: '1.05rem', color: colors.text }}>{p.name}</span>
                        </div>
                        <p style={{ margin: '0.2rem 0 0', fontSize: '0.82rem', color: accent, fontStyle: 'italic', fontWeight: 600 }}>
                          {t(meta.taglineKey)}
                        </p>
                        <div style={{ marginTop: '0.3rem', display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
                          <span style={{ fontSize: '1.3rem', color: colors.gold, fontWeight: 900 }}>{p.price} 💎</span>
                        </div>
                      </div>
                    </div>

                    {/* Emoji preview strip */}
                    <div style={{
                      textAlign: 'center', fontSize: '1.6rem', letterSpacing: '0.15em',
                      padding: '0.6rem', borderRadius: 12,
                      background: `${accent}0d`, marginBottom: '0.85rem',
                      border: `1px dashed ${accent}33`,
                    }}>
                      {meta.preview}
                    </div>

                    {/* Feature bullets */}
                    <div style={{ marginBottom: '1rem' }}>
                      {bullets.map((b, i) => (
                        <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', marginBottom: '0.3rem' }}>
                          <span style={{ color: accent, fontSize: '0.8rem', marginTop: 2, flexShrink: 0 }}>✦</span>
                          <span style={{ fontSize: '0.83rem', color: colors.textSec, lineHeight: 1.4 }}>{b}</span>
                        </div>
                      ))}
                    </div>

                    {/* Buy button */}
                    <button data-testid={`buy-pack-${p.id}`}
                      disabled={isOwned}
                      onClick={() => handleStripePurchase(p)}
                      style={{
                        width: '100%', padding: '0.85rem', borderRadius: 14,
                        border: 'none', cursor: isOwned ? 'default' : 'pointer',
                        fontWeight: 800, fontSize: '0.95rem', letterSpacing: '0.02em',
                        background: isOwned
                          ? 'rgba(16,185,129,0.15)'
                          : `linear-gradient(135deg, ${accent}, ${accent}bb)`,
                        color: isOwned ? '#10b981' : '#fff',
                        boxShadow: isOwned ? 'none' : `0 4px 20px ${accent}44`,
                        transition: 'opacity 0.2s, transform 0.15s',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem',
                      }}
                      onMouseEnter={e => { if (!isOwned) e.currentTarget.style.opacity = '0.88'; }}
                      onMouseLeave={e => { e.currentTarget.style.opacity = '1'; }}
                    >
                      {isOwned
                        ? (lang === 'RO' ? '✓ Pachet Activ' : lang === 'ES' ? '✓ Pack Activo' : '✓ Pack Active')
                        : `${lang === 'RO' ? 'Cumpără' : lang === 'ES' ? 'Comprar' : 'Buy'} - 💎 ${p.price}`}
                    </button>
                  </div>
                );
              })}

            </div>
          </div>
        </div>
      );
    }

    // In-Game Shopping (luxury, furniture, clothes) - only available during gameplay
    if (modal === 'in-game-shop' && character) {
      const luxuryBrands = gameData?.items?.luxury_fashion || {};
      const brandNames = Object.keys(luxuryBrands);

      return (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" style={{ color: colors.text, '--glass-bg': theme === 'dark' ? 'rgba(30,30,30,0.95)' : 'rgba(255,255,255,0.95)' }} onClick={e => e.stopPropagation()}>
            <h2 className="modal-title" data-testid="ingame-shop-title">🛍️ Shopping</h2>
            <p style={{ textAlign: 'center', color: colors.success, marginBottom: '1rem' }}>💰 ${(character.money || 0).toLocaleString()}</p>

            <div className="shop-category">
              <div className="shop-category-title" data-testid="luxury-fashion-title">👗 {t('luxury_fashion')}</div>
              <div className="brand-tabs" style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '1rem' }}>
                {brandNames.map(brand => (
                  <button key={brand} data-testid={`brand-tab-${brand.replace(/\s/g, '-')}`}
                    className={`creator-option ${selectedBrand === brand ? 'selected' : ''}`}
                    style={{ color: colors.text, fontSize: '0.85rem', padding: '0.5rem 0.75rem' }}
                    onClick={() => setSelectedBrand(selectedBrand === brand ? null : brand)}>
                    {brand}
                  </button>
                ))}
              </div>
              {selectedBrand && luxuryBrands[selectedBrand] && (
                <div className="items-grid" data-testid={`brand-items-${selectedBrand.replace(/\s/g, '-')}`}>
                  {luxuryBrands[selectedBrand].map(item => (
                    <button key={item.name} className="grid-item" style={{ color: colors.text }}
                      data-testid={`luxury-item-${item.name.replace(/\s/g, '-')}`}
                      onClick={() => buyLuxury(selectedBrand, item.name)}
                      disabled={loading || item.price > character.money}>
                      <span className="grid-item-icon">{item.emoji}</span>
                      <div className="grid-item-name" style={{ fontSize: '0.8rem' }}>{item.name}</div>
                      <div className="grid-item-price">${item.price.toLocaleString()}</div>
                    </button>
                  ))}
                </div>
              )}
              {!selectedBrand && <p style={{ color: colors.textMuted, textAlign: 'center', fontSize: '0.9rem' }}>Select a brand to browse items</p>}
            </div>

            <div className="shop-category">
              <div className="shop-category-title">🏠 {t('home_decor')}</div>
              <div className="items-grid">
                {gameData?.items?.furniture?.map(item => (
                  <button key={item.name} className="grid-item" style={{ color: colors.text }}
                    data-testid={`furniture-${item.name.replace(/\s/g, '-')}`}
                    onClick={() => { buyItem('furniture', item.name); }}
                    disabled={loading || item.price > character.money}>
                    <span className="grid-item-icon">{item.emoji}</span>
                    <div className="grid-item-name" style={{ fontSize: '0.8rem' }}>{item.name}</div>
                    <div className="grid-item-price">${item.price.toLocaleString()}</div>
                  </button>
                ))}
              </div>
            </div>

            <div className="shop-category">
              <div className="shop-category-title">👔 Clothes & Accessories</div>
              <div className="items-grid">
                {gameData?.items?.clothes?.map(item => (
                  <button key={item.name} className="grid-item" style={{ color: colors.text }}
                    onClick={() => buyItem('clothes', item.name)} disabled={loading || item.price > character.money}>
                    <span className="grid-item-icon">{item.emoji}</span>
                    <div className="grid-item-name" style={{ fontSize: '0.8rem' }}>{item.name}</div>
                    <div className="grid-item-price">${item.price.toLocaleString()}</div>
                  </button>
                ))}
                {gameData?.items?.accessories?.map(item => (
                  <button key={item.name} className="grid-item" style={{ color: colors.text }}
                    onClick={() => buyItem('accessories', item.name)} disabled={loading || item.price > character.money}>
                    <span className="grid-item-icon">{item.emoji}</span>
                    <div className="grid-item-name" style={{ fontSize: '0.8rem' }}>{item.name}</div>
                    <div className="grid-item-price">${item.price.toLocaleString()}</div>
                  </button>
                ))}
              </div>
            </div>

            <button className="modal-close-btn" style={{ background: colors.primary, color: '#fff' }} onClick={closeModal}>{t('close')}</button>
          </div>
        </div>
      );
    }

    // Graveyard
    if (modal === 'graveyard') {
      return (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" style={{ color: colors.text, '--glass-bg': theme === 'dark' ? 'rgba(30,30,30,0.95)' : 'rgba(255,255,255,0.95)' }} onClick={e => e.stopPropagation()}>
            <h2 className="modal-title">⚰️ {t('graveyard_title')}</h2>
            {graveyard.length === 0
              ? <p style={{ textAlign: 'center', color: colors.textMuted, padding: '2rem 0' }}>{t('no_past_lives')}</p>
              : graveyard.slice().reverse().map((g, i) => (
                <div key={i} style={{ padding: '1rem', background: 'rgba(255,255,255,0.05)', borderRadius: '12px', marginBottom: '0.75rem', border: `1px solid ${colors.textMuted}22` }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.35rem' }}>
                    <span style={{ fontSize: '1.5rem' }}>{g.emoji || '💀'}</span>
                    <span style={{ fontWeight: 700, fontSize: '1rem' }}>{g.name}</span>
                    {g.was_royal && <span>{t('royal_label')}</span>}
                  </div>
                  <div style={{ color: colors.textSec, fontSize: '0.9rem', marginBottom: '0.2rem' }}>
                    💀 {t('at_age')} {g.age_at_death} {t('years')} — {g.cause_of_death}
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', fontSize: '0.85rem' }}>
                    <span style={{ color: colors.success }}>💰 ${(g.money || 0).toLocaleString()}</span>
                    <span style={{ color: colors.gold }}>☯️ {g.karma}</span>
                    {g.job && g.job !== 'Unemployed' && <span>💼 {g.job}</span>}
                    {(g.children_count || 0) > 0 && <span>👶 {g.children_count} {t('children_label')}</span>}
                    {g.country && <span>🌍 {g.city || g.country}</span>}
                  </div>
                </div>
              ))}
            <button className="modal-close-btn" style={{ background: colors.primary, color: '#fff' }} onClick={closeModal}>{t('close')}</button>
          </div>
        </div>
      );
    }

    // Date Match
    if (modal === 'date-match' && modalData) {
      return (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" style={{ color: colors.text, '--glass-bg': theme === 'dark' ? 'rgba(30,30,30,0.95)' : 'rgba(255,255,255,0.95)' }} onClick={e => e.stopPropagation()}>
            <h2 className="modal-title" style={{ color: colors.primary }}>💘 New Match!</h2>
            <div className="match-display">
              <span className="match-avatar">{modalData.emoji}</span>
              <div className="match-name">{modalData.name}</div>
              <div className="match-detail" style={{ color: colors.textSec }}>{t('age')} {modalData.age} • {modalData.personality}</div>
              <div className="match-detail">{t('looks')}: {modalData.looks}%</div>
              <div className="match-compat">💕 {modalData.compatibility}% compatible</div>
            </div>
            <div className="match-actions">
              <button className="match-btn" style={{ background: colors.success }}
                onClick={() => relationshipAction('start_dating', null, modalData)}>
                💕 {t('date')}
              </button>
              <button className="match-btn" style={{ background: colors.error }} onClick={closeModal}>
                👎 {t('pass')}
              </button>
            </div>
          </div>
        </div>
      );
    }

    // Partner Interact
    if (modal === 'partner-interact' && modalData) {
      return (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" style={{ color: colors.text, '--glass-bg': theme === 'dark' ? 'rgba(30,30,30,0.95)' : 'rgba(255,255,255,0.95)' }} onClick={e => e.stopPropagation()}>
            <span className="modal-avatar">{modalData.emoji}</span>
            <h2 className="modal-title">{modalData.name}</h2>
            <p style={{ textAlign: 'center', color: colors.primary }}>
              {modalData.status === 'married' ? `💒 ${t('married')}` : modalData.status === 'engaged' ? `💍 ${t('engaged')}` : `💕 ${t('dating')}`}
            </p>
            <div className="interact-grid">
              {/* Romantic interactions */}
              <button className="interact-btn" data-testid="date-go-on-date" style={{ color: colors.text }} onClick={async () => {
                const dates = ['fancy restaurant 🍷', 'movie theater 🎬', 'beach walk 🏖️', 'concert 🎵', 'amusement park 🎢', 'picnic in the park 🧺'];
                const d = dates[Math.floor(Math.random() * dates.length)];
                await relationshipAction('spend_time', modalData.id);
                notify(`Went on a date to a ${d}! ❤️`, 'success');
                playSound('love');
              }}>
                <span className="interact-icon">🍷</span>
                <span className="interact-name">{t('go_on_date')}</span>
              </button>
              <button className="interact-btn" data-testid="date-give-gift" style={{ color: colors.text }} onClick={async () => {
                const gifts = ['flowers 💐', 'jewelry 💍', 'perfume 🧴', 'chocolate 🍫', 'teddy bear 🧸', 'designer bag 👜'];
                const g = gifts[Math.floor(Math.random() * gifts.length)];
                const cost = Math.floor(Math.random() * 500) + 50;
                if ((character.money || 0) < cost) { notify('Not enough money for a gift!', 'error'); return; }
                await relationshipAction('gift', modalData.id);
                notify(`Gave ${modalData.name} ${g} ($${cost}) 🎁`, 'success');
                playSound('money');
              }}>
                <span className="interact-icon">🎁</span>
                <span className="interact-name">{t('give_gift')}</span>
              </button>
              <button className="interact-btn" data-testid="date-conversation" style={{ color: colors.text }} onClick={async () => {
                const topics = ['your future together', 'childhood memories', 'dreams and goals', 'funny stories', 'politics (bad idea!)', 'vacation plans'];
                const topic = topics[Math.floor(Math.random() * topics.length)];
                await relationshipAction('talk', modalData.id);
                notify(`Had a deep conversation about ${topic} 💬`, 'success');
              }}>
                <span className="interact-icon">💬</span>
                <span className="interact-name">{t('talk')}</span>
              </button>
              <button className="interact-btn" data-testid="date-compliment" style={{ color: colors.text }} onClick={() => {
                const compliments = [`told ${modalData.name} they look gorgeous`, `said ${modalData.name} is the best thing in your life`, `complimented ${modalData.name}'s smile`];
                const c = compliments[Math.floor(Math.random() * compliments.length)];
                relationshipAction('compliment', modalData.id);
                notify(`You ${c} 😊`, 'success');
                playSound('love');
              }}>
                <span className="interact-icon">😍</span>
                <span className="interact-name">{t('compliment')}</span>
              </button>
              <button className="interact-btn" data-testid="date-complain" style={{ color: colors.text }} onClick={() => {
                const complaints = ['spending habits', 'not helping around the house', 'being on the phone too much', 'forgetting anniversaries'];
                const c = complaints[Math.floor(Math.random() * complaints.length)];
                relationshipAction('argue', modalData.id);
                notify(`Complained about ${modalData.name}'s ${c} 😤`, 'error');
              }}>
                <span className="interact-icon">😤</span>
                <span className="interact-name">{t('complain')}</span>
              </button>
              <button className="interact-btn" style={{ color: colors.text }} onClick={() => {
                relationshipAction('spend_time', modalData.id);
                notify(`Spent quality time with ${modalData.name} 🤗`, 'success');
              }}>
                <span className="interact-icon">🤗</span>
                <span className="interact-name">{t('hug')}</span>
              </button>
              {modalData.status === 'dating' && (
                <button className="interact-btn" data-testid="date-propose" style={{ color: colors.text }} onClick={() => relationshipAction('propose', modalData.id)}>
                  <span className="interact-icon">💍</span>
                  <span className="interact-name">{t('propose')}</span>
                </button>
              )}
              {modalData.status === 'engaged' && (
                <button className="interact-btn" data-testid="date-marry" style={{ color: colors.text }} onClick={() => relationshipAction('marry', modalData.id)}>
                  <span className="interact-icon">💒</span>
                  <span className="interact-name">{t('marry')}</span>
                </button>
              )}
              <button className="interact-btn" data-testid="date-breakup" style={{ color: colors.text }} onClick={() => relationshipAction('break_up', modalData.id)}>
                <span className="interact-icon">💔</span>
                <span className="interact-name">{t('break_up')}</span>
              </button>
            </div>
            <button className="modal-close-btn" style={{ background: colors.primary, color: '#fff' }} onClick={closeModal}>{t('close')}</button>
          </div>
        </div>
      );
    }

    // Family Interact
    if (modal === 'family-interact' && modalData) {
      const actions = [
        { id: 'talk', icon: '💬', name: t('talk') },
        { id: 'hug', icon: '🤗', name: t('hug') },
        { id: 'compliment', icon: '😊', name: t('compliment') },
        { id: 'ask_money', icon: '💵', name: t('ask_money') },
        { id: 'gift', icon: '🎁', name: t('give_money') },
        { id: 'prank', icon: '😜', name: t('prank') },
        { id: 'insult', icon: '😤', name: t('insult') },
        { id: 'fight', icon: '👊', name: t('fight') },
      ];
      return (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" style={{ color: colors.text, '--glass-bg': theme === 'dark' ? 'rgba(30,30,30,0.95)' : 'rgba(255,255,255,0.95)' }} onClick={e => e.stopPropagation()}>
            <span className="modal-avatar">{modalData.emoji}</span>
            <h2 className="modal-title">{modalData.name}</h2>
            <p style={{ textAlign: 'center', color: colors.textSec }}>{modalData.relation} • {t('age')} {modalData.age}</p>
            <p style={{ textAlign: 'center', color: colors.primary }}>{t('affection')}: {modalData.affection}%</p>
            <div className="interact-grid">
              {actions.map(a => (
                <button key={a.id} className="interact-btn" style={{ color: colors.text }}
                  onClick={() => interactFamily(modalData.id, a.id)}>
                  <span className="interact-icon">{a.icon}</span>
                  <span className="interact-name">{a.name}</span>
                </button>
              ))}
            </div>
            <button className="modal-close-btn" style={{ background: colors.primary, color: '#fff' }} onClick={closeModal}>{t('close')}</button>
          </div>
        </div>
      );
    }

    // Classmate Interact
    if (modal === 'classmate-interact' && modalData) {
      const actions = [
        { id: 'talk', icon: '💬', name: t('talk') },
        { id: 'befriend', icon: '🤝', name: t('befriend') },
        { id: 'flirt', icon: '😍', name: t('flirt') },
        { id: 'bully', icon: '😈', name: t('bully') },
      ];
      return (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" style={{ color: colors.text, '--glass-bg': theme === 'dark' ? 'rgba(30,30,30,0.95)' : 'rgba(255,255,255,0.95)' }} onClick={e => e.stopPropagation()}>
            <span className="modal-avatar">{modalData.emoji}</span>
            <h2 className="modal-title">{modalData.name}</h2>
            <p style={{ textAlign: 'center', color: colors.textSec }}>{t('classmates')}</p>
            {modalData.is_crush && <p style={{ textAlign: 'center', color: colors.primary }}>💕 Your Crush</p>}
            <div className="interact-grid">
              {actions.map(a => (
                <button key={a.id} className="interact-btn" style={{ color: colors.text }}
                  onClick={() => interactClassmate(modalData.id, a.id)}>
                  <span className="interact-icon">{a.icon}</span>
                  <span className="interact-name">{a.name}</span>
                </button>
              ))}
            </div>
            <button className="modal-close-btn" style={{ background: colors.primary, color: '#fff' }} onClick={closeModal}>{t('close')}</button>
          </div>
        </div>
      );
    }

    // Teacher Interact
    if (modal === 'teacher-interact' && modalData) {
      const actions = [
        { id: 'talk', icon: '💬', name: t('talk') },
        { id: 'compliment', icon: '😊', name: t('compliment') },
        { id: 'ask_help', icon: '📚', name: t('ask_help') },
        { id: 'prank', icon: '🎃', name: t('prank') },
      ];
      return (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" style={{ color: colors.text, '--glass-bg': theme === 'dark' ? 'rgba(30,30,30,0.95)' : 'rgba(255,255,255,0.95)' }} onClick={e => e.stopPropagation()}>
            <span className="modal-avatar">{modalData.emoji}</span>
            <h2 className="modal-title">{modalData.name}</h2>
            <p style={{ textAlign: 'center', color: colors.textSec }}>{modalData.subject} Teacher</p>
            <div className="interact-grid">
              {actions.map(a => (
                <button key={a.id} className="interact-btn" style={{ color: colors.text }}
                  onClick={() => interactTeacher(modalData.id, a.id)}>
                  <span className="interact-icon">{a.icon}</span>
                  <span className="interact-name">{a.name}</span>
                </button>
              ))}
            </div>
            <button className="modal-close-btn" style={{ background: colors.primary, color: '#fff' }} onClick={closeModal}>{t('close')}</button>
          </div>
        </div>
      );
    }

    // Surgery
    if (modal === 'surgery') {
      return (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" style={{ color: colors.text, '--glass-bg': theme === 'dark' ? 'rgba(30,30,30,0.95)' : 'rgba(255,255,255,0.95)' }} onClick={e => e.stopPropagation()}>
            <h2 className="modal-title">💉 {t('surgery')}</h2>
            <div className="items-grid">
              {gameData?.surgeries?.filter(s => character.age >= s.minAge && (!s.gender || s.gender === character.gender)).map(s => (
                <button key={s.name} className="grid-item" style={{ color: colors.text }}
                  onClick={() => { doSurgery(s.name); closeModal(); }} disabled={s.cost > character.money}>
                  <span className="grid-item-icon">{s.emoji}</span>
                  <div className="grid-item-name">{s.name}</div>
                  <div className="grid-item-price">${s.cost.toLocaleString()}</div>
                  <div className="grid-item-info" style={{ color: colors.success }}>+{s.effects?.looks || 0} {t('looks')}</div>
                </button>
              ))}
            </div>
            <button className="modal-close-btn" style={{ background: colors.primary, color: '#fff' }} onClick={closeModal}>{t('close')}</button>
          </div>
        </div>
      );
    }

    // Buy House
    if (modal === 'buy-house') {
      return (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" style={{ color: colors.text, '--glass-bg': theme === 'dark' ? 'rgba(30,30,30,0.95)' : 'rgba(255,255,255,0.95)' }} onClick={e => e.stopPropagation()}>
            <h2 className="modal-title">🏠 {t('properties')}</h2>
            <div className="items-grid">
              {gameData?.items?.houses?.map(h => (
                <button key={h.name} className="grid-item" style={{ color: colors.text }}
                  onClick={() => { buyItem('houses', h.name); closeModal(); }} disabled={h.price > character.money}>
                  <span className="grid-item-icon">{h.emoji}</span>
                  <div className="grid-item-name">{h.name}</div>
                  <div className="grid-item-price">${h.price.toLocaleString()}</div>
                </button>
              ))}
            </div>
            <button className="modal-close-btn" style={{ background: colors.primary, color: '#fff' }} onClick={closeModal}>{t('close')}</button>
          </div>
        </div>
      );
    }

    // Buy Vehicle
    if (modal === 'buy-vehicle') {
      return (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" style={{ color: colors.text, '--glass-bg': theme === 'dark' ? 'rgba(30,30,30,0.95)' : 'rgba(255,255,255,0.95)' }} onClick={e => e.stopPropagation()}>
            <h2 className="modal-title">🚗 {t('vehicles')}</h2>
            <div className="items-grid">
              {gameData?.items?.vehicles?.map(v => (
                <button key={v.name} className="grid-item" style={{ color: colors.text }}
                  onClick={() => { buyItem('vehicles', v.name); closeModal(); }} disabled={v.price > character.money}>
                  <span className="grid-item-icon">{v.emoji}</span>
                  <div className="grid-item-name">{v.name}</div>
                  <div className="grid-item-price">${v.price.toLocaleString()}</div>
                </button>
              ))}
            </div>
            <button className="modal-close-btn" style={{ background: colors.primary, color: '#fff' }} onClick={closeModal}>{t('close')}</button>
          </div>
        </div>
      );
    }

    // Adopt Pet
    if (modal === 'adopt-pet') {
      return <AdoptPetModal items={gameData?.items?.pets} character={character} onAdopt={adoptPet} onClose={closeModal} colors={colors} t={t} />;
    }

    // Blackjack
    if (modal === 'blackjack' && bjGame) {
      const playerTotal = getCardValue(bjGame.playerCards);
      const dealerTotal = bjGame.playerStood ? getCardValue(bjGame.dealerCards) : '?';

      return (
        <div className="modal-overlay">
          <div className="modal-content" style={{ color: colors.text, '--glass-bg': theme === 'dark' ? 'rgba(30,30,30,0.95)' : 'rgba(255,255,255,0.95)' }}>
            <h2 className="modal-title">🃏 Blackjack - ${bjGame.bet}</h2>
            <div className="blackjack-table">
              <p style={{ color: '#fff', marginBottom: '0.5rem' }}>Dealer's Hand</p>
              <div className="card-area">
                {bjGame.dealerCards.map((c, i) => (
                  <div key={i} className={`playing-card ${['♥', '♦'].includes(c.suit) ? 'red' : 'black'} ${!bjGame.playerStood && i === 1 ? 'hidden' : ''}`}>
                    {bjGame.playerStood || i === 0 ? `${c.value}${c.suit}` : ''}
                  </div>
                ))}
              </div>
              <div className="hand-total">Total: {dealerTotal}</div>

              <div style={{ margin: '1.5rem 0', borderTop: '2px dashed rgba(255,255,255,0.3)' }} />

              <p style={{ color: '#fff', marginBottom: '0.5rem' }}>Your Hand</p>
              <div className="card-area">
                {bjGame.playerCards.map((c, i) => (
                  <div key={i} className={`playing-card ${['♥', '♦'].includes(c.suit) ? 'red' : 'black'}`}>
                    {c.value}{c.suit}
                  </div>
                ))}
              </div>
              <div className="hand-total">Total: {playerTotal}</div>

              {bjGame.phase === 'playing' && (
                <div className="blackjack-actions">
                  <button className="bj-btn hit" onClick={bjHit}>{t('hit')}</button>
                  <button className="bj-btn stand" onClick={bjStand}>{t('stand')}</button>
                  {bjGame.playerCards.length === 2 && character.money >= bjGame.bet && (
                    <button className="bj-btn double" onClick={() => { setBjGame({...bjGame, bet: bjGame.bet * 2}); bjHit(); bjStand(); }}>
                      {t('double')}
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }

    // Maze
    if (modal === 'maze' && maze) {
      return (
        <div className="modal-overlay">
          <div className="modal-content" style={{ color: colors.text, '--glass-bg': theme === 'dark' ? 'rgba(30,30,30,0.95)' : 'rgba(255,255,255,0.95)' }}>
            <h2 className="modal-title">🏃 {t('escape')}!</h2>
            <p style={{ textAlign: 'center', color: colors.textSec, marginBottom: '0.5rem' }}>Navigate to the gold exit</p>
            <div className="maze-container">
              <div className="maze-grid">
                {maze.maze.map((row, y) => (
                  <div key={y} className="maze-row">
                    {row.map((cell, x) => (
                      <div key={x} className={`maze-cell ${cell === 1 ? 'wall' : ''} ${playerPos[0] === x && playerPos[1] === y ? 'player' : ''} ${x === maze.size - 1 && y === maze.size - 1 ? 'exit' : ''}`} />
                    ))}
                  </div>
                ))}
              </div>
              <div className="maze-controls">
                <button className="maze-control-btn" onClick={() => moveMaze('up')}>⬆️</button>
                <div className="maze-controls-row">
                  <button className="maze-control-btn" onClick={() => moveMaze('left')}>⬅️</button>
                  <button className="maze-control-btn" onClick={() => moveMaze('right')}>➡️</button>
                </div>
                <button className="maze-control-btn" onClick={() => moveMaze('down')}>⬇️</button>
              </div>
            </div>
            <button className="modal-close-btn" style={{ background: colors.error, color: '#fff' }} onClick={() => escapePrison(false)}>
              {t('give_up')}
            </button>
          </div>
        </div>
      );
    }

    // Driver's Test
    if (modal === 'driver-test' && driverTest) {
      const answered = Object.keys(testAnswers).length;
      return (
        <div className="modal-overlay">
          <div className="modal-content" style={{ color: colors.text, '--glass-bg': theme === 'dark' ? 'rgba(30,30,30,0.95)' : 'rgba(255,255,255,0.95)' }}>
            <h2 className="modal-title" data-testid="driver-test-title">🚗 Driver's License Test</h2>
            <p style={{ textAlign: 'center', color: colors.textSec, marginBottom: '1rem' }}>Answer {driverTest.length} questions correctly to pass</p>
            {driverTest.map((q, qi) => (
              <div key={qi} style={{ marginBottom: '1.25rem', padding: '1rem', background: 'rgba(255,255,255,0.05)', borderRadius: '12px' }}>
                <p style={{ fontWeight: 600, marginBottom: '0.5rem' }}>{qi + 1}. {q.q}</p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
                  {q.options.map((opt, oi) => (
                    <button key={oi} data-testid={`test-q${qi}-opt${oi}`}
                      style={{
                        padding: '0.6rem 0.75rem', borderRadius: '8px', border: 'none', cursor: 'pointer', textAlign: 'left',
                        background: testAnswers[qi] === oi ? `${colors.primary}33` : 'rgba(255,255,255,0.08)',
                        color: colors.text, fontWeight: testAnswers[qi] === oi ? 600 : 400,
                        outline: testAnswers[qi] === oi ? `2px solid ${colors.primary}` : 'none',
                      }}
                      onClick={() => setTestAnswers({ ...testAnswers, [qi]: oi })}>
                      {opt}
                    </button>
                  ))}
                </div>
              </div>
            ))}
            <button className="start-life-btn" data-testid="submit-driver-test"
              disabled={answered < driverTest.length}
              style={{ opacity: answered < driverTest.length ? 0.5 : 1 }}
              onClick={submitDriverTest}>
              📝 Submit Test ({answered}/{driverTest.length})
            </button>
            <button className="modal-close-btn" style={{ background: colors.textMuted, color: '#fff' }}
              onClick={() => { setDriverTest(null); setModal(null); }}>
              Cancel
            </button>
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <div className="app" data-theme={theme}>
      {screen === 'home' && renderHome()}
      {screen === 'game' && renderGame()}
      {renderModal()}

      {/* Event Popup */}
      {eventPopup && (
        <div className="modal-overlay" style={{ zIndex: 1100 }}>
          <div className="modal-content event-popup" data-testid="event-popup"
            style={{ color: colors.text, '--glass-bg': theme === 'dark' ? 'rgba(30,30,30,0.95)' : 'rgba(255,255,255,0.95)' }}>
            <h2 className="modal-title" style={{ color: colors.primary }} data-testid="event-popup-title">{eventPopup.title}</h2>
            <p style={{ textAlign: 'center', color: colors.textSec, marginBottom: '1.25rem', fontSize: '1rem' }}>{eventPopup.text}</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              {eventPopup.choices?.map((choice, i) => (
                <button key={i} className="primary-btn" data-testid={`event-choice-${i}`}
                  style={{
                    background: `linear-gradient(135deg, ${colors.primary}cc, ${colors.secondary}cc)`,
                    padding: '0.85rem', fontSize: '0.95rem', borderRadius: '12px',
                  }}
                  onClick={() => handleEventChoice(choice)}>
                  {choice.text}
                  <span style={{ display: 'block', fontSize: '0.75rem', opacity: 0.7, marginTop: '0.2rem' }}>
                    {Object.entries(choice.effects || {}).map(([k, v]) => `${k}: ${v > 0 ? '+' : ''}${v}`).join(' | ')}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {loading && <div className="loading-overlay"><div className="spinner" /></div>}
      {notification && (
        <div className="notification" style={{
          background: notification.type === 'error' ? colors.error : notification.type === 'success' ? colors.success : colors.primary
        }}>{notification.msg}</div>
      )}
    </div>
  );
}

// Adopt Pet Modal Component
function AdoptPetModal({ items, character, onAdopt, onClose, colors, t }) {
  const [petName, setPetName] = useState('');
  const [selectedPet, setSelectedPet] = useState(null);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" style={{ color: colors.text, '--glass-bg': 'rgba(30,30,30,0.95)' }} onClick={e => e.stopPropagation()}>
        <h2 className="modal-title">🐾 {t('pets')}</h2>
        <div className="items-grid">
          {items?.map(p => (
            <button key={p.name} className={`grid-item ${selectedPet === p.name ? 'selected' : ''}`}
              style={{ color: colors.text, borderColor: selectedPet === p.name ? colors.primary : 'transparent' }}
              onClick={() => setSelectedPet(p.name)} disabled={p.price > character.money}>
              <span className="grid-item-icon">{p.emoji}</span>
              <div className="grid-item-name">{p.name}</div>
              <div className="grid-item-price">${p.price.toLocaleString()}</div>
            </button>
          ))}
        </div>
        {selectedPet && (
          <div style={{ marginTop: '1rem' }}>
            <input type="text" className="creator-input" placeholder="Name your pet..." value={petName}
              onChange={e => setPetName(e.target.value)} style={{ color: colors.text, marginBottom: '0.75rem' }} />
            <button className="primary-btn" style={{ background: colors.success, width: '100%' }}
              onClick={() => onAdopt(selectedPet, petName)}>
              🐾 {t('adopt')}
            </button>
          </div>
        )}
        <button className="modal-close-btn" style={{ background: colors.primary, color: '#fff' }} onClick={onClose}>{t('close')}</button>
      </div>
    </div>
  );
}

export default App;
